const itemTypes = require("./itemTypes.js");
const UTILS = require("../libs/utils.js");
const config = require("../config.js");
const COLORS = require("./colors.js");
const Player = require("./player.js");
module.exports = function (game, RENDER, SOUND, PARTICLES, prefabs, serverIO) {
  this.list = [];
  var v12908;
  var v12909;
  var v12910;
  var vO416 = {};
  var v12911 = new game.THREE.Vector3(0, 0, 0);
  var v12912 = new game.THREE.Vector3(0, 0, 0);
  var kills = require("./kills.js");
  Object.defineProperty(this, "isServer", {
    get() {
      if (serverIO) {
        return 1;
      } else {
        return 0;
      }
    }
  });
  this.setOnGround = function (p16246) {
    p16246.onGround = true;
    p16246.lastGround = {
      x: p16246.x,
      y: p16246.y,
      z: p16246.z,
      height: p16246.height
    };
  };
  this.playerCollision = function (p16247, p16248) {
    if (p16247 && p16247.config.pColl && p16247.active) {
      for (var vLN02307 = 0; vLN02307 < this.list.length; ++vLN02307) {
        v12908 = this.list[vLN02307];
        if (v12908.active && p16247.collidesP(v12908)) {
          if (p16247.oldY >= v12908.y.round(1) + v12908.height) {
            p16247.y = v12908.y.round(1) + v12908.height;
            this.resetStep(p16247, p16248);
            p16247.velocity.y = 0;
            this.setOnGround(p16247);
            p16247.onTerrain = false;
          } else if (p16247.oldX - p16247.scale >= v12908.x.round(1) + v12908.scale - 0.00001) {
            var v12916 = v12908.scale + p16247.scale;
            p16247.x = v12908.x.round(1) + v12916;
            p16247.velocity.x = 0;
            v12908.velocity.x = 0;
          } else if (p16247.oldX + p16247.scale <= v12908.x.round(1) - v12908.scale + 0.00001) {
            var v12916 = v12908.scale + p16247.scale;
            p16247.x = v12908.x.round(1) - v12916;
            p16247.velocity.x = 0;
            v12908.velocity.x = 0;
          } else if (p16247.oldZ - p16247.scale >= v12908.z.round(1) + v12908.scale - 0.00001) {
            var v12916 = v12908.scale + p16247.scale;
            p16247.z = v12908.z.round(1) + v12916;
            p16247.velocity.z = 0;
            v12908.velocity.z = 0;
          } else if (p16247.oldZ + p16247.scale <= v12908.z.round(1) - v12908.scale + 0.00001) {
            var v12916 = v12908.scale + p16247.scale;
            p16247.z = v12908.z.round(1) - v12916;
            p16247.velocity.z = 0;
            v12908.velocity.z = 0;
          }
        }
      }
    }
  };
  this.playerConvTeam = function (p16249) {
    if (serverIO && !game.waitTimers && game.mode.convTeam) {
      for (var vLN02308 = 0; vLN02308 < this.list.length; ++vLN02308) {
        if (p16249.active && this.list[vLN02308].active && p16249.team == game.mode.convTeam && p16249.team != this.list[vLN02308].team && !this.list[vLN02308].godMode) {
          var v12917 = config.playerHeight / 2;
          var v12918 = UTILS.getD3D(p16249.x, p16249.y + v12917, p16249.z, this.list[vLN02308].x, this.list[vLN02308].y + v12917, this.list[vLN02308].z);
          if (v12918 <= v12917 * 2.4) {
            game.broadcast("ac", p16249.sid, this.list[vLN02308].sid, game.mode.convWord);
            this.score(p16249, 100, 2);
            p16249.convs++;
            game.updateTeam(this.list[vLN02308], p16249.team);
            if (game.mode.killConv) {
              this.kill(this.list[vLN02308], null, null, true);
            }
            if (game.gameTimer) {
              game.gameTimer += 10000;
            }
          }
        }
      }
    }
  };
  this.update = function (delta) {
    for (var vLN02309 = 0; vLN02309 < this.list.length; ++vLN02309) {
      if (this.list[vLN02309] && this.list[vLN02309].active) {
        this.list[vLN02309].update(game, delta);
        if (game.isServer) {
          if (serverIO && game && game.isCustom && this.list[vLN02309] && this.list[vLN02309].playTime >= 30000 && this.list[vLN02309].didAct) {
            game.playTime += delta;
            game.uniquePlay(this.list[vLN02309]);
          }
          this.tickPlayer(this.list[vLN02309], delta);
        }
        if (RENDER) {
          this.updateHeight(this.list[vLN02309]);
          this.updateMshClient(this.list[vLN02309]);
          this.updateEffects(this.list[vLN02309], delta);
          this.itemEffects(this.list[vLN02309], null, delta);
        }
      } else if (serverIO && this.list[vLN02309].deathInfo && this.list[vLN02309].deathInfo.tillNext && !this.list[vLN02309].kpdData) {
        this.list[vLN02309].deathInfo.tillNext -= delta;
        if (this.list[vLN02309].deathInfo.tillNext <= 0) {
          this.list[vLN02309].deathInfo.tillNext = null;
          this.list[vLN02309].send("frs", game.isOfficial && game.isOfficial.rotationMaps || !game.hasHost());
        }
      }
    }
  };
  this.setTeam = function (p16251) {
    if (!game.waitTimers && game.mode.convTeam) {
      p16251.team = game.mode.convTeam;
    } else if (game.mode.teamOptions && !game.mode.teamSort) {
      p16251.team = 1;
    } else if (game.mode.friendly) {
      p16251.team = 1;
    } else if (game.mode.clanWar) {
      p16251.team = p16251.account && p16251.account.clan ? p16251.account.clan : 1;
    } else if (!p16251.team && game.mode.teams && !p16251.spectating) {
      if (game.mode.multiTeam) {
        let vO417 = {};
        for (var vLN02314 = 0; vLN02314 < game.mode.multiTeam; vLN02314++) {
          vO417[vLN02314 + 1] = 0;
        }
        for (var vLN02314 = 0; vLN02314 < this.list.length; ++vLN02314) {
          if (!this.list[vLN02314].spectating) {
            if (this.list[vLN02314].team) {
              vO417[this.list[vLN02314].team]++;
            }
          }
        }
        var vLN229 = 2;
        for (var v12919 in vO417) {
          if (vO417[v12919] < vO417[vLN229]) {
            vLN229 = parseInt(v12919);
          }
        }
        p16251.team = vLN229;
      } else {
        var vLN02312 = 0;
        var vLN02313 = 0;
        for (var vLN02314 = 0; vLN02314 < this.list.length; ++vLN02314) {
          if (!this.list[vLN02314].spectating) {
            if (this.list[vLN02314].team == 1) {
              vLN02312++;
            }
            if (this.list[vLN02314].team == 2) {
              vLN02313++;
            }
          }
        }
        p16251.team = vLN02312 >= vLN02313 ? 2 : 1;
      }
    }
  };
  this.activeCount = function () {
    var vLN02315 = 0;
    for (var vLN02316 = 0; vLN02316 < this.list.length; ++vLN02316) {
      if (this.list[vLN02316].active) {
        vLN02315++;
      }
    }
    return vLN02315;
  };
  this.forcePos = function () {
    for (var vLN02317 = 0; vLN02317 < this.list.length; ++vLN02317) {
      this.list[vLN02317].forcePos = true;
      if (this.list[vLN02317].objInstances) {
        var v12920 = this.list[vLN02317];
        v12920.objInstances.visible = false;
        this.list[vLN02317].inView = false;
      }
    }
  };
  this.storeState = function (p16252, p16253) {
    p16252.stateHistory.unshift({
      time: p16253,
      h: p16252.height,
      ah: p16252.adjustedHeight,
      x: p16252.x.round(2),
      y: p16252.y.round(2),
      z: p16252.z.round(2),
      sV: p16252.stepVal,
      xD: p16252.xDire,
      yD: p16252.yDire,
      cV: Math.round(p16252.crouchVal)
    });
    for (var v12921 = p16252.stateHistory.length - 1; v12921 >= 0; --v12921) {
      if (p16253 - p16252.stateHistory[v12921].time >= config.stateHistory) {
        p16252.stateHistory.splice(v12921, 1);
      }
    }
  };
  this.fetchState = function (p16254, p16255, p16256, p16257) {
    if (game && game.isSandbox) {
      if (p16254.stateHistory.length) {
        const v12922 = p16254.stateHistory[0];
        p16254.stateHistory.length = 1;
        return v12922;
      }
      return {
        h: p16254.height,
        ah: p16254.adjustedHeight,
        x: p16254.x.round(2),
        y: p16254.y.round(2),
        z: p16254.z.round(2),
        sV: p16254.stepVal,
        xD: p16254.xDire,
        yD: p16254.yDire,
        cV: Math.round(p16254.crouchVal)
      };
    }
    p16256 = p16256 || 0;
    p16257 = p16257 || 0;
    var v12923 = p16255 ? p16255.inputSTPrg : 0;
    var v12924 = (p16255 ? p16255.inputSTime : 0) + game.startTime + p16257;
    var v12925 = null;
    var v12926 = null;
    for (var v12927 = p16254.stateHistory.length, vLN02318 = 0; vLN02318 < v12927; ++vLN02318) {
      if (v12924 >= p16254.stateHistory[vLN02318].time) {
        v12925 = vLN02318;
        break;
      }
    }
    if (v12925 == null) {
      v12925 = v12927 - 1;
    }
    v12925 += p16256;
    v12926 = p16254.stateHistory[v12925 + 1];
    v12925 = p16254.stateHistory[v12925];
    if (!p16256 && v12926 && v12925) {
      return {
        x: UTILS.lerp(v12925.x, v12926.x, v12923),
        y: UTILS.lerp(v12925.y, v12926.y, v12923),
        z: UTILS.lerp(v12925.z, v12926.z, v12923),
        xD: UTILS.lerpAngle(v12925.xD, v12926.xD, v12923),
        yD: UTILS.lerpAngle(v12925.yD, v12926.yD, v12923),
        sV: UTILS.lerp(v12925.sV, v12926.sV, v12923),
        cV: v12925.cV,
        h: v12925.h,
        ah: v12925.ah
      };
    } else {
      return v12925;
    }
  };
  this.updateHeight = function (p16258) {
    var v12928 = game.config.thirdPerson || p16258.config && (p16258.config.camOffX || p16258.config.camOffY || p16258.config.camOffZ);
    var v12929 = config.crouchDst * p16258.crouchVal;
    if (!RENDER || p16258.renderYou) {
      p16258.heightOld = p16258.height;
      p16258.height = config.playerHeight - v12929;
      let v12930 = config.playerHeight - config.headScale + config.headScale * p16258.headMlt;
      p16258.adjustedHeight = v12930 - v12929;
    }
    if (!p16258.renderYou || v12928) {
      var v12931;
      for (var vLN02319 = 0; vLN02319 < 4; ++vLN02319) {
        v12931 = !!p16258.crouchVal;
        if (!!p16258.legMeshes[vLN02319] && (!RENDER || !RENDER.lowSpec)) {
          if (vLN02319 <= 1) {
            p16258.legMeshes[vLN02319].visible = !v12931;
          } else {
            p16258.legMeshes[vLN02319].visible = v12931;
            p16258.legMeshes[vLN02319].position.y = config.legHeight - config.crouchDst + 0.5 + (config.crouchDst - v12929);
          }
        }
        if (p16258.shoeMeshes[vLN02319] && RENDER && !RENDER.lowSpec) {
          if (p16258.shoeMeshes[vLN02319].hide) {
            p16258.shoeMeshes[vLN02319].visible = false;
          } else if (vLN02319 <= 1) {
            p16258.shoeMeshes[vLN02319].visible = !v12931;
          } else {
            p16258.shoeMeshes[vLN02319].visible = v12931;
          }
        }
      }
    }
  };
  this.updateMshServ = function (p16259, p16260, p16261, p16262, p16263, p16264, p16265, p16266) {
    if (p16259.objInstances) {
      p16266 = p16266 || 0;
      var v12932 = Math.sin(p16265) * config.stepAnim;
      v12932 -= v12932 * (p16266 * config.crouchAnimMlt);
      game.playerMesh.moveMesh(p16259.objInstances, p16260, p16261, p16262);
      game.playerMesh.rotateMesh(p16259.objInstances, p16263);
      var v12933 = config.crouchDst * p16266;
      var v12934 = config.crouchLean * p16266;
      if (p16259.lowerBody) {
        game.playerMesh.rotateMesh(p16259.lowerBody, 0, v12934 + p16264 * 0.5, 0);
      }
      if (p16259.upperBody) {
        p16259.upperBody.rotation.x -= v12934;
      }
      if (p16259.lowerBody) {
        game.playerMesh.moveMesh(p16259.lowerBody, 0, config.legHeight - v12933, 0);
      }
      if (p16259.upperBody) {
        game.playerMesh.rotateMesh(p16259.upperBody, 0, p16264 * 0.5, 0);
        game.playerMesh.moveMesh(p16259.upperBody, 0, config.playerHeight - config.cameraHeight - config.legHeight, 0);
      }
      for (var vLN02320 = 0; vLN02320 < p16259.legMeshes.length; ++vLN02320) {
        p16259.legMeshes[vLN02320].rotation.x = v12932 * (vLN02320 == 1 || vLN02320 == 3 ? 1 : -1) * 9 + (vLN02320 > 1 ? -0.6 : 0);
      }
      game.playerMesh.moveMesh(p16259.weaponMeshes[p16259.loadoutIndex], p16259.weapon.xOff, p16259.weapon.yOff, p16259.weapon.zOff);
      p16259.objInstances.updateWorldMatrix(true, true);
    }
  };
  this.updateMshClient = function (p16267, p16268) {
    if (p16267.objInstances) {
      var v12935 = game.config.thirdPerson || !game.controls || !game.controls.camType.isNormal || p16267.config && (p16267.config.camOffX || p16267.config.camOffY || p16267.config.camOffZ);
      var v12936 = RENDER.getPlayerWeaponId(p16267);
      var v12937 = p16267.currentSkin;
      var v12938 = (p16267.weapon.attach != null || v12937.attachBypass) && !v12937.noAttach && game.attach[p16267.attachIndex] ? game.attach[p16267.attachIndex] : null;
      var v12939 = v12938 ? v12938.aimOffY + (p16267.weapon.aimOffY || 0) || 0 : 0;
      if (p16267.renderYou && RENDER.weaponADSOffY[v12936] != 1) {
        v12939 = (v12939 || 0.1) * RENDER.weaponADSOffY[v12936];
      }
      if (v12937.aimY) {
        v12939 += v12937.aimY;
      }
      if (p16267.weapon.aimY) {
        v12939 += p16267.weapon.aimY;
      }
      if (v12938 && v12937.attachAimY) {
        v12939 += v12937.attachAimY;
      }
      var v12940 = p16267.renderYou && !v12935;
      var v12941 = RENDER.aimAnim[v12936] && p16267.isYou ? p16267.aimVal : 1;
      var v12942 = p16267.weapon.animWhileAim ? 1 : v12941;
      var v12943 = (1 - (1 - config.aimAnimMlt) * (1 - v12941)) * config.animMult * RENDER.weaponBob[v12936];
      var v12944 = 1 - p16267.crouchVal * 0.8;
      var v12945 = (1 - (1 - v12941)) * config.animMult;
      var v12946 = (1 - (1 - v12941) * (p16267.weapon.recoilYMA || 1)) * config.animMult;
      if (!p16267.renderYou) {
        v12945 = 0;
      }
      var v12947 = 1 - ((v12938 ? v12938.zRec || 0 : 0) || p16267.weapon.recoilZM || 0.5) * (1 - v12942);
      var v12948 = (1 - (p16267.weapon.zRot || 0.3) * (1 - v12942)) * (p16267.weapon.zRM || 1) * RENDER.weaponBob[v12936];
      var v12949 = 1 - (p16267.weapon.jYMlt || 1) * (1 - v12942);
      var v12950 = 1 - (1 - v12942) * 0.45;
      var v12951 = p16267.bobAnimY * 0.9 * v12949 * RENDER.weaponBob[v12936] * v12945;
      var v12952 = p16267.landBobY * (p16267.weapon.landBob || 1) * 0.6 * (1 - (1 - v12942) * 0.75) * RENDER.weaponBob[v12936];
      if (p16267.landBobYR != v12952) {
        p16267.landBobYR += (v12952 - p16267.landBobYR) * 0.1;
      }
      var v12953 = p16267.landBobY * (p16267.weapon.landBob || 1) * 0.1;
      var v12954 = 1 - p16267.crouchVal * 0.5;
      var v12955 = p16267.jumpRot * v12954 * v12945 * RENDER.weaponBob[v12936];
      if (p16267.jumpRotM != v12955) {
        p16267.jumpRotM += (v12955 - p16267.jumpRotM) * 0.08;
      }
      var v12956 = p16267.jumpBobY * (p16267.weapon.jumpYM || 1) * v12945 * v12954 * RENDER.weaponBob[v12936];
      var v12957 = 1 - (1 - v12942) * 0.75;
      var v12958 = 1 - (p16267.weapon.aimRecMlt || 1) * (1 - v12942);
      var v12959 = p16268 ? 0.05 : config.stepAnim;
      var v12960 = Math.sin(p16267.stepVal) * v12959;
      var v12961 = Math.cos(p16267.stepVal * 2) / 2 * v12959;
      var v12962 = -Math.sin(p16267.stepChase) * v12959;
      var v12963 = -(Math.cos(p16267.stepChase * 2) / 2) * v12959;
      var v12964 = v12935 ? 0 : 1 - v12941;
      var v12965 = (v12964 <= 0.5 ? v12964 : 0.5 - (v12964 - 0.5)) * (p16267.weapon.aimLean || 0.5);
      var v12966 = p16267.swapTime / p16267.weapon.swapTime * RENDER.weapSwapY[v12936];
      var vLN02321 = 0;
      if (p16267.reloadTimer > 0) {
        var v12967 = p16267.reloadTimer / (p16267.weapon.reload * (game.config.reSpd || 1) * p16267.attributes.reload * (p16267.perks.includes(2) ? 0.5 : 1) * (p16267.isKranked ? game.mode.bonuses.reload : 1) * (game.mode && game.mode.reloadMlt != null ? game.mode.reloadMlt : 1));
        vLN02321 = 1 - v12967;
        vLN02321 = vLN02321 > 0.5 ? 0.5 - (vLN02321 - 0.5) : vLN02321;
        vLN02321 *= RENDER.weapReloadY[v12936];
        vLN02321 *= p16267.weapon.reloY;
      }
      vLN02321 *= p16267.renderYou ? 1 : 0.3;
      var v12968 = p16267.renderYou ? v12935 ? -v12960 * 0.5 : 0 : -v12960 * 2;
      var v12969 = p16267.renderYou && !v12935 ? Math.abs(v12962 * 0.5) * v12945 : Math.abs(v12960 * 6);
      if (p16267.config && p16267.config.mdl) {
        v12969 = 0;
      }
      game.playerMesh.moveMesh(p16267.objInstances, p16267.x, p16267.y + v12969, p16267.z);
      if (p16267.config && p16267.config.mdl == 2) {
        v12968 = 0;
      }
      if (game.mode && game.mode.teamOptions && game.mode.teamOptions[p16267.team - 1] == "Prop") {
        game.playerMesh.rotateMesh(p16267.objInstances, p16267.propRot ? p16267.xDire : p16267.propRotSaved == null ? 0 : p16267.propRotSaved);
      } else if (!p16267.config || p16267.config.mdl != 1) {
        game.playerMesh.rotateMesh(p16267.objInstances, p16267.xDire + v12968);
      }
      v12961 -= v12961 * (p16267.crouchVal * config.crouchAnimMlt);
      v12960 -= v12960 * (p16267.crouchVal * config.crouchAnimMlt);
      if (!v12940) {
        var v12970 = config.crouchDst * p16267.crouchVal;
        var v12971 = config.crouchLean * p16267.crouchVal;
        game.playerMesh.rotateMesh(p16267.lowerBody, 0, v12971 + p16267.yDire * 0.5, 0);
        if (p16267.upperBody) {
          p16267.upperBody.rotation.x -= v12971;
        }
        game.playerMesh.moveMesh(p16267.lowerBody, 0, config.legHeight - v12970, 0);
      }
      var v12972 = v12935 ? 0.4 : 1;
      game.playerMesh.rotateMesh(p16267.upperBody, vLN02321 * -(v12972 * 1), -(v12951 * 0.2) + +v12953 + vLN02321 * -(v12972 * 2.8) + p16267.yDire * (p16267.renderYou && !v12935 ? 1 : 0.5) + (-(Math.PI / 4) * v12966 + p16267.recoilAnimY * config.recoilMlt) + (v12937.yRot || p16267.weapon.yRot || 0), RENDER.weaponRot[v12936] * 0.35);
      if (!!v12940 || !p16267.crouchVal || !p16267.isYou) {
        game.playerMesh.moveMesh(p16267.upperBody, 0, p16267.recoilAnimY * ((p16267.weapon.recoilYM || 0.3) * v12946) + (p16267.height - config.cameraHeight - config.legHeight), 0);
      }
      for (var vLN02323 = 0; vLN02323 < p16267.legMeshes.length; ++vLN02323) {
        if (RENDER.lowSpec) {
          p16267.legMeshes[vLN02323].visible = false;
        } else {
          p16267.legMeshes[vLN02323].rotation.x = v12960 * (vLN02323 == 1 || vLN02323 == 3 ? 1 : -1) * 9 + (vLN02323 > 1 ? -0.6 : 0);
        }
        if (RENDER.lowSpec && p16267.shoeMeshes[vLN02323]) {
          p16267.shoeMeshes[vLN02323].visible = false;
        } else if (p16267.shoeMeshes[vLN02323]) {
          p16267.shoeMeshes[vLN02323].rotation.x = p16267.legMeshes[vLN02323].rotation.x;
        }
      }
      for (var vLN02323 = 0; vLN02323 < p16267.armMeshes.length; ++vLN02323) {
        p16267.armMeshes[vLN02323].position.z = v12960 * (vLN02323 ? -1 : 1);
        p16267.armMeshes[vLN02323].rotation.x = p16267.armMeshes[vLN02323].xR || 0;
        p16267.armMeshes[vLN02323].rotation.y = p16267.armMeshes[vLN02323].yR || 0;
        p16267.armMeshes[vLN02323].position.x = p16267.armMeshes[vLN02323].xP || 0;
        p16267.armMeshes[vLN02323].position.y = p16267.armMeshes[vLN02323].yP || 0;
        if (vLN02323 != 1) {
          if (p16267.meleeAnim && p16267.weaponGeos[p16267.loadoutIndex]) {
            p16267.armMeshes[0].position.z += p16267.meleeAnim.lArm || 0;
            p16267.armMeshes[0].position.y -= (p16267.meleeAnim.lArm || 0) * 0.27;
            p16267.armMeshes[0].rotation.y += (p16267.meleeAnim.lArm || 0) * 0.1;
            p16267.armMeshes[0].position.x -= (p16267.meleeAnim.lArm || 0) * 0.3;
          }
        } else {
          p16267.armMeshes[1].rotation.z = p16267.armMeshes[vLN02323].zR + p16267.crouchVal * 0.12 + v12963 * -1 + p16267.jumpBobY * 0.2;
          if (p16267.weaponGeos[p16267.loadoutIndex]) {
            p16267.weaponGeos[p16267.loadoutIndex].rotation.z = p16267.weaponGeos[p16267.loadoutIndex].zR;
            p16267.weaponGeos[p16267.loadoutIndex].position.x = p16267.weaponGeos[p16267.loadoutIndex].xP;
            p16267.weaponGeos[p16267.loadoutIndex].position.y = p16267.weaponGeos[p16267.loadoutIndex].yP;
            p16267.weaponGeos[p16267.loadoutIndex].position.z = p16267.weaponGeos[p16267.loadoutIndex].zP;
            p16267.weaponGeos[p16267.loadoutIndex].rotation.y = p16267.weaponGeos[p16267.loadoutIndex].yR;
            if (p16267.canThrow) {
              if (p16267.canThrow && !p16267.weaponGeos[p16267.loadoutIndex].visible) {
                p16267.weaponGeos[p16267.loadoutIndex].visible = true;
              }
            } else {
              p16267.weaponGeos[p16267.loadoutIndex].visible = false;
            }
            if (p16267.aimVal < 1 && p16267.canThrow && p16267.weapon.canThrow) {
              var v12973 = 1 - p16267.aimVal;
              if (p16267.swapTime) {
                v12973 = 0;
              }
              p16267.armMeshes[1].rotation.z -= v12973 * 1.3;
              p16267.armMeshes[1].position.x += v12973 * 1.7;
              p16267.armMeshes[1].position.z += v12973 * 1.8;
              p16267.armMeshes[1].position.y += v12973 * 2.9;
              p16267.armMeshes[1].rotation.y += v12973 * 1;
              p16267.armMeshes[1].rotation.x += v12973 * 1.7;
            } else if (p16267.inspecting && p16267.canThrow) {
              p16267.armMeshes[1].rotation.z -= p16267.inspectAn.arZ;
              p16267.armMeshes[1].rotation.x -= p16267.inspectAn.arX;
              p16267.armMeshes[1].rotation.y -= p16267.inspectAn.arY;
              p16267.armMeshes[1].position.z += p16267.inspectAn.apZ;
              p16267.armMeshes[1].position.x += p16267.inspectAn.apX;
              p16267.armMeshes[1].position.y += p16267.inspectAn.apY;
              if (!p16267.currentMelee.statc) {
                p16267.weaponGeos[p16267.loadoutIndex].position.z += p16267.inspectAn.wpZ;
                p16267.weaponGeos[p16267.loadoutIndex].position.y += p16267.inspectAn.wpY;
                p16267.weaponGeos[p16267.loadoutIndex].rotation.y += p16267.inspectAn.wrY;
                p16267.weaponGeos[p16267.loadoutIndex].rotation.z += p16267.inspectAn.wpSp;
              }
            } else if (p16267.meleeAnim) {
              p16267.armMeshes[1].rotation.z += p16267.meleeAnim.armR || 0;
              p16267.armMeshes[1].rotation.y += (p16267.meleeAnim.armT || 0) - (p16267.meleeAnim.rArm || 0) * 0.25;
              p16267.armMeshes[1].rotation.x += p16267.meleeAnim.armS || 0;
              p16267.armMeshes[1].position.x += (p16267.meleeAnim.armM || 0) + (p16267.meleeAnim.rArm || 0) * 0.3;
              p16267.armMeshes[1].position.z += (p16267.meleeAnim.armE || 0) + (p16267.meleeAnim.rArm || 0) * 1.15;
              p16267.armMeshes[1].position.y += (p16267.meleeAnim.armY || 0) - (p16267.meleeAnim.rArm || 0) * 0.3;
              if (!p16267.currentMelee.statc) {
                p16267.weaponGeos[p16267.loadoutIndex].rotation.z += p16267.meleeAnim.weaR || 0;
                p16267.weaponGeos[p16267.loadoutIndex].position.x += p16267.meleeAnim.weaM || 0;
                p16267.weaponGeos[p16267.loadoutIndex].rotation.y += p16267.meleeAnim.flipW || 0;
              }
            }
          }
        }
      }
      if (p16267.weaponMeshes[p16267.loadoutIndex] && p16267.weaponMeshes[p16267.loadoutIndex].flapMesh && p16267.weapon.flap && RENDER.sniperFlapAnim) {
        var v12980 = v12963 * 3 + p16267.recoilAnim * 2.8 - p16267.leanAnimZ - p16267.leanAnimX * 3 - p16267.landBobYR * 1.8 + v12951 + p16267.crouchVal * 0.1;
        game.playerMesh.rotateMesh(p16267.weaponMeshes[p16267.loadoutIndex].flapMesh, p16267.weapon.flap.rot * p16267.swapTweenA + v12980, null, null);
      }
      var v12975 = (1 - (1 - v12941) * 0.88) * 1.75 * RENDER.weaponBob[v12936];
      var v12976 = p16267.weapon.xOff * (p16267.renderYou ? RENDER.weaponOffX[v12936] : 1);
      var v12977 = p16267.weapon.yOff * (p16267.renderYou ? RENDER.weaponOffY[v12936] : 1);
      var v12978 = p16267.weapon.zOff * (p16267.renderYou ? RENDER.weaponOffZ[v12936] : 1);
      var v12979 = p16267.weaponMeshes[p16267.loadoutIndex];
      game.playerMesh.rotateMesh(v12979, p16267.inspectX + p16267.jumpRotM * 0.2 + p16267.leanAnimX * v12950 * RENDER.weaponLean[v12936] * (p16267.weapon.leanMlt || 1) + (-v12962 * 0.16 * v12945 * v12944 + p16267.leanAnimZ * 0.2) * v12943, -v12963 * 1.5 * (v12940 ? 0 : 1) + -Math.cos(p16267.idleAnim) * v12954 * 0.01 * v12975 + (p16267.weapon.rotOff || 0) * v12945 + (v12937.rotOffA || p16267.weapon.rotOffA || 0) * (1 - v12945) - (p16267.swapTweenR || 0) * 0.35 * v12945 + -p16267.landBobYR * 0.4 + p16267.recoilTweenY * v12958 + p16267.leanAnimY * v12950 * RENDER.weaponLean[v12936] * (p16267.weapon.leanMlt || 1) + -(v12963 * 0.9) * v12943, v12955 + v12965 + p16267.recoilTweenR * v12958 + p16267.leanAnimZ * 0.7 * v12948 + -p16267.inspectX * (p16267.weapon.inspectR || 0) + ((p16267.weapon.cLean || 0) * p16267.crouchVal * v12945 + -v12962 * 0) * v12943);
      game.playerMesh.moveMesh(v12979, p16267.recoilX * v12957 + (p16267.swapTweenR || 0) * 0.2 - p16267.jumpRotM * v12945 * 1.3 + -p16267.inspectX * (p16267.weapon.inspectM || 0) + (p16267.leanAnimZ * 0.35 - (p16267.weapon.cRot || 0) * p16267.crouchVal * v12945 + v12960 * 0.5 * v12944 * v12945) * v12941 * v12943 + v12976 - (v12976 - p16267.weapon.xOrg) * v12964, p16267.recoilZ * v12957 + Math.sin(p16267.idleAnim) * 0.02 * v12975 + p16267.recoilTweenYM * v12958 + v12956 + v12952 * 0.5 - v12951 * 1.5 - (p16267.weapon.bomb ? p16267.interProg * 3 : 0) + (v12961 * 0.85 - (p16267.weapon.cDrop || 0) * p16267.crouchVal * v12945) * v12943 + v12977 - (v12977 - p16267.weapon.yOrg + (v12937 ? v12937.yOrg || 0 : 0) + v12939) * v12964, v12978 - (v12978 - (v12937.zOrg || p16267.weapon.zOrg)) * v12964 + p16267.recoilTweenZ + p16267.bobAnimZ * v12943 + p16267.recoilAnim * (p16267.weapon.recoilZ || 0) * v12947);
      if (v12979 && v12979.charmMesh && p16267.weapon.charm) {
        var v12980 = v12963 * 3 + p16267.recoilAnim * 2.8 - p16267.leanAnimZ - p16267.leanAnimX * 3 - p16267.landBobYR * 1.8 + v12951 + p16267.crouchVal * 1.5;
        var v12981 = p16267.swapTweenA * 0.1;
        game.playerMesh.rotateMesh(v12979.charmMesh, -Math.PI - v12979.rotation.y * 0.3, Math.max(-p16267.leanAnimX * 3.8 + p16267.crouchVal * 0.2 * v12945 + -v12951 * 3.5 + p16267.landBobYR * 5 + -v12960 * 2, -0.3), p16267.yDire * 0.2 - p16267.recoilTweenY * 1.5 - p16267.recoilAnim * 4);
      }
    }
  };
  this.playClip = function (p16269, p16270, p16271) {
    if (p16269 && p16270 && p16269.active && p16269.hasAnims) {
      if (serverIO) {
        var v12982 = config.clipNames.indexOf(p16270);
        if (v12982 >= 0) {
          for (var vLN02324 = 0; vLN02324 < this.list.length; ++vLN02324) {
            if (this.list[vLN02324] != p16269 && (this.list[vLN02324].spectating || this.list[vLN02324].active && UTILS.getD3D(this.list[vLN02324].x, this.list[vLN02324].y, this.list[vLN02324].z, p16269.x, p16269.y, p16269.z) < (game.mode.viewDis || 600))) {
              this.list[vLN02324].send("c", p16269.sid, v12982);
            }
          }
        }
      } else if (RENDER && p16269.meshRef && p16269.meshRef.visible && p16269.meshRef.playClip) {
        p16269.meshRef.playClip(p16270, p16271);
      }
    }
  };
  this.updateEffects = function (p16272, p16273) {
    if (p16272) {
      if (RENDER && p16272.isYou) {
        p16272.drunkCnt += p16273 * 0.01 * p16272.attributes.drunk;
        RENDER.swayX = Math.cos(p16272.drunkCnt) * 0.1 * p16272.attributes.drunk;
        RENDER.swayY = Math.sin(p16272.drunkCnt) * 0.1 * p16272.attributes.drunk;
      }
    }
  };
  this.itemEffects = function (p16274, p16275, p16276) {
    var v12983 = false;
    p16274.effectTimer -= p16276;
    if (p16274.effectTimer <= 0) {
      p16274.effectTimer = 500;
      v12983 = true;
    }
    if (v12983 && p16274.currentBody && p16274.currentBody.particle != null) {
      PARTICLES.effect(p16274.x + UTILS.randInt(-2, 2), p16274.y + p16274.height / 2 + UTILS.randInt(-2, 2), p16274.z + UTILS.randInt(-2, 2), 0, 0, p16274.currentBody.particle, p16275);
    }
    if (v12983 && p16274.currentBack && p16274.currentBack.particle != null) {
      PARTICLES.effect(p16274.x + UTILS.randInt(-2, 2), p16274.y + p16274.height / 2 + UTILS.randInt(-2, 2), p16274.z + UTILS.randInt(-2, 2), 0, 0, p16274.currentBack.particle, p16275);
    }
    if (v12983 && p16274.currentDye && p16274.currentDye.particle != null) {
      PARTICLES.effect(p16274.x + UTILS.randInt(-2, 2), p16274.y + p16274.height / 2 + UTILS.randInt(-4, 4), p16274.z + UTILS.randInt(-2, 2), 0, 0, p16274.currentDye.particle, p16275);
    }
    if (v12983 && p16274.currentShoes && p16274.currentShoes.particle != null) {
      PARTICLES.effect(p16274.x + UTILS.randInt(-2, 2), p16274.y + 0.1, p16274.z + UTILS.randInt(-2, 2), 0, 0, p16274.currentShoes.particle, p16275);
    }
  };
  this.generateMeshData = function (p16277, p16278, p16279) {
    if (p16277) {
      return {
        fileExt: p16277.fileExt,
        setLayer: p16278 ? undefined : 1,
        animS: p16277.animS,
        hasAnim: p16277.hasAnim,
        local: p16277.local,
        localM: p16277.localM,
        src: game.store.types[p16277.assetType || p16277.type] + p16277.id,
        texSrc: p16277.tex ? game.store.types[p16277.assetType || p16277.type] + p16277.id + "_" + p16277.tex : null,
        frames: p16277.frames,
        frameT: p16277.frameT,
        rotT: p16277.rotT,
        movT: p16277.movT,
        movE: p16277.movE,
        movD: p16277.movD,
        sameEnv: p16277.sameEnv,
        env: p16277.env || p16277.sameEnv ? p16277.env || 3 : undefined,
        sameGlow: p16277.sameGlow,
        glowText: p16277.glow,
        emissive: (p16277.glow || p16277.sameGlow) && !p16277.noEmis ? p16277.emiss || "#ffffff" : null,
        emissInt: p16277.glowInt,
        pulsT: p16277.pulsT,
        transparent: p16277.opac != null || p16277.trans,
        rAnim: p16277.rAnim,
        rAnimA: p16277.rAnimA,
        rAnimT: p16277.rAnimT,
        rAnimM: p16277.rAnimM,
        rgb: p16277.rgb || !!p16279 && p16279.rgb,
        rgbS: p16277.rgbS || (p16279 ? p16279.rgbS : 0),
        rgbT: p16277.rgbT,
        useWireframe: p16277.wire,
        side: p16277.side || 0,
        opacity: p16277.opac || 1,
        shaderNum: p16277.shaderNum,
        color: p16277.color || null,
        alphaTest: p16277.alpha || 0
      };
    } else {
      return {};
    }
  };
  this.generateMeshes = function (p16280, p16281, p16282 = false, p16283) {
    p16280.leftHand = !!RENDER && RENDER.leftHand;
    p16280.meshRef = null;
    if (game.config.noCosm) {
      p16280.dyeIndex = -1;
      p16280.bodyIndex = -1;
      p16280.backIndex = -1;
      p16280.waistIndex = -1;
      p16280.hatIndex = -1;
      p16280.headIndex = -1;
      p16280.faceIndex = -1;
      p16280.shoeIndex = -1;
      p16280.petIndex = -1;
      p16280.wristIndex = -1;
      p16280.skinColIndex = -1;
    }
    if (game.mode && game.mode.teamOptions && game.mode.teamOptions[p16280.team - 1] == "Prop") {
      p16280.petIndex = -1;
    }
    var {
      dyeIndex: iÎíííîî,
      bodyIndex: iIìïíïì,
      backIndex: iÍiïiîi,
      waistIndex: iÏíìíîí,
      hatIndex: iÌîìïíï,
      headIndex: iÌîîîiï,
      faceIndex: iÌììïiì,
      shoeIndex: iÌíîïîi,
      petIndex: iÏïîííi,
      wristIndex: iÏiiïiï,
      skinColIndex: iÏîîîïi,
      meleeIndex: iÏïïîîì
    } = p16280;
    var v12984 = p16280.config.colors;
    var v12985 = config.skinColors[p16280.skinColIndex] ? config.skinColors[p16280.skinColIndex].col : UTILS.isHexColor(p16280.skinColIndex) ? p16280.skinColIndex : v12984[0];
    var v12986 = v12984[1];
    var v12987 = v12984[5];
    var v12988 = v12984[2];
    var v12989 = v12984[6] || v12984[2];
    var v12990 = v12984[3];
    var v12991 = UTILS.isHexColor(p16280.hairCol) ? p16280.hairCol : v12984[4];
    var vO418 = {};
    if (iÎíííîî != -1 && !serverIO) {
      vO418 = game.store.skins[iÎíííîî];
      if (vO418) {
        if (vO418.useSkin) {
          v12985 = v12985;
          v12986 = v12985;
          v12987 = v12985;
          v12988 = v12985;
          v12989 = v12985;
          v12990 = v12985;
        } else {
          if (vO418.skinCol != null) {
            v12985 = vO418.skinCol;
          }
          if (Array.isArray(v12985)) {
            v12985 = UTILS.getRandom(v12985);
          }
          if (vO418.shirtCol != null) {
            v12986 = vO418.shirtCol;
          }
          if (Array.isArray(v12986)) {
            v12986 = UTILS.getRandom(v12986);
          }
          if (vO418.sleeveCol != null) {
            v12987 = vO418.sleeveCol;
          }
          if (Array.isArray(v12987)) {
            v12987 = UTILS.getRandom(v12987);
          }
          if (vO418.pantsCol != null) {
            v12988 = vO418.pantsCol;
          }
          if (Array.isArray(v12988)) {
            v12988 = UTILS.getRandom(v12988);
          }
          v12989 = vO418.waistCol == null ? v12988 : vO418.waistCol;
          if (Array.isArray(v12989)) {
            v12989 = UTILS.getRandom(v12989);
          }
          if (vO418.shoeCol != null) {
            v12990 = vO418.shoeCol;
          }
          if (Array.isArray(v12990)) {
            v12990 = UTILS.getRandom(v12990);
          }
          if (vO418.hairCol != null) {
            v12991 = vO418.hairCol;
          }
          if (Array.isArray(v12991)) {
            v12991 = UTILS.getRandom(v12991);
          }
        }
      } else {
        vO418 = {};
      }
    }
    var v12992 = p16283 && (game.config.thirdPerson || p16280.config && (p16280.config.camOffX || p16280.config.camOffY || p16280.config.camOffZ) || !p16281 || serverIO);
    p16280.meshHoldObj = game.playerMesh.genObj3D(0, 0, 0);
    p16280.objInstances = game.playerMesh.genObj3D(p16280.x, p16280.y, p16280.z, p16280.id);
    p16280.objInstances.add(p16280.meshHoldObj);
    if (!serverIO) {
      var v12993 = game.mode && game.mode.teamOptions && game.mode.modelOverrides && game.mode.modelOverrides[game.mode.teamOptions[p16280.team - 1]];
      if (v12993) {
        var v12994 = game.mode.modelOverrides[game.mode.teamOptions[p16280.team - 1]];
        if (v12994.noCosmetics) {
          iIìïíïì = -1;
          iÍiïiîi = -1;
          iÏíìíîí = -1;
          iÌîìïíï = -1;
          iÌîîîiï = -1;
          iÌììïiì = -1;
          iÌíîïîi = -1;
          iÏïïîîì = -1;
          iÏiiïiï = -1;
          iÏïîííi = -1;
          iÎíííîî = -1;
          iÏîîîïi = -1;
        }
        if (v12994.hatIndex) {
          p16280.hatIndex = v12994.hatIndex;
        }
        if (v12994.headIndex) {
          p16280.headIndex = v12994.headIndex;
        }
        if (v12994.bodyIndex) {
          p16280.bodyIndex = v12994.bodyIndex;
        }
        if (v12994.backIndex) {
          p16280.backIndex = v12994.backIndex;
        }
        if (v12994.waistIndex) {
          p16280.waistIndex = v12994.waistIndex;
        }
        if (v12994.faceIndex) {
          p16280.faceIndex = v12994.faceIndex;
        }
        if (v12994.shoeIndex) {
          p16280.shoeIndex = v12994.shoeIndex;
        }
        if (v12994.wristIndex) {
          p16280.wristIndex = v12994.wristIndex;
        }
        if (v12994.petIndex) {
          p16280.petIndex = v12994.petIndex;
        }
        if (v12994.dyeIndex) {
          p16280.dyeIndex = v12994.dyeIndex;
        }
        if (v12994.meleeIndex) {
          p16280.meleeIndex = v12994.meleeIndex;
        }
        if (v12994.skinColIndex) {
          p16280.skinColIndex = v12994.skinColIndex;
        }
        if (v12994.skinColor) {
          v12985 = v12994.skinColor;
        }
        if (v12994.shirtColor) {
          v12986 = v12994.shirtColor;
        }
        if (v12994.pantsColor) {
          v12988 = v12994.pantsColor;
        }
        if (v12994.waistColor || v12994.pantsColor) {
          v12989 = v12994.waistColor || v12994.pantsColor;
        }
        if (v12994.shoeColor) {
          v12990 = v12994.shoeColor;
        }
        if (v12994.sleeveColor) {
          v12987 = v12994.sleeveColor;
        }
        if (v12994.hairColor) {
          v12991 = v12994.hairColor;
        }
      }
      if (p16280.isJuggernaut) {
        iIìïíïì = 4908;
        iÏíìíîí = 4911;
        iÌîîîiï = 4909;
        iÌíîïîi = 4910;
      }
    }
    if (p16280.config.mdlFP || v12992 && !p16280.config.mdlFP) {
      if (p16280.config && p16280.config.mdl && p16283) {
        var v12995 = p16280.assetTxt;
        if (!v12995) {
          v12995 = p16280.config.aID || "";
        }
        var v12996 = (p16280.config.animS == 1 ? p16280.config.animS : p16280.config.animS) || 1;
        if (p16280.config.mdl == 1) {
          if (RENDER) {
            var v12997 = v12995 ? parseInt(v12995.replace(/[^\d]/g, "")) || null : null;
            RENDER.loadSprite({
              src: v12997 ? v12997 + "/texture" : "sprite_0",
              color: "#ffffff",
              mat: game.THREE.SpriteMaterial,
              depthWrite: true,
              transparent: true,
              alphaTest: 0.02,
              asset: v12997 != null
            }, p16280.objInstances);
          }
        } else if (p16280.config.mdl == 2 && RENDER) {
          var v12998 = !!v12995.includes("g");
          var v12999 = !!v12995.includes("q");
          var v13000 = !!v12995.includes("f");
          p16280.meshRef = RENDER[v12998 || v12999 || v13000 ? "loadAnimMesh" : "loadMesh"]({
            isMdl: true,
            fileExt: v12999 ? "glb" : v12998 ? "gltf" : v13000 ? "fbx" : null,
            src: v12995.replace(/[^\d]/g, "") + "/model",
            color: "#ffffff",
            vertexColors: true,
            startAnim: v12998 || v12999 || v13000 ? "Idle" : null,
            emissive: v12995.includes("e") ? "#ffffff" : null,
            normal: v12995.includes("n"),
            spec: v12995.includes("s"),
            asset: v12995.replace(/[^\d]/g, ""),
            animS: v12996
          }, 0, (v12998 || v12999 || v13000 ? 0 : config.playerHeight / 2) + (p16280.config.mdlYO || 0) + (p16282 ? p16280.config.mdPY || 1 : 1), 0, UTILS.toRad(p16280.config.mdlDr || 0), (p16280.config.mdlS || 1) * (p16282 ? p16280.config.mdPS || 1 : 1), p16280.objInstances, false);
        }
        p16280.assetTxt = null;
      } else if (game.mode && game.mode.teamOptions && game.mode.teamOptions[p16280.team - 1] == "Prop" && p16283) {
        var v13001 = prefabs.prefabs[p16280.propID];
        if (RENDER) {
          RENDER.loadMesh({
            isMdl: true,
            src: v13001.name.toLowerCase() + "_0",
            emissive: v13001.name == "ACIDBARREL" ? "#ffffff" : null
          }, 0, v13001.scale + (v13001.CPY || 0), 0, 0, v13001.scale, p16280.objInstances, false);
        }
      } else {
        var v13002;
        var v13003;
        var v13004;
        var v13005;
        var v13006;
        var v13007;
        var v13008 = false;
        if (iÌîìïíï >= 0 && v12992 && !serverIO) {
          v13003 = game.store.skins[iÌîìïíï];
        }
        if (iÌîîîiï >= 0 && v12992 && !serverIO) {
          v13004 = game.store.skins[iÌîîîiï];
        }
        if (iIìïíïì >= 0 && v12992 && !serverIO) {
          v13005 = game.store.skins[iIìïíïì];
        }
        if (iÍiïiîi >= 0 && v12992 && !serverIO) {
          v13006 = game.store.skins[iÍiïiîi];
        }
        if (iÏiiïiï >= 0 && !serverIO) {
          v13007 = game.store.skins[iÏiiïiï];
        }
        var v13009 = v13003 && v13003.noHead || v13004 && v13004.noHead;
        var v13010 = v13003 && v13003.noHair || v13004 && v13004.noHair;
        p16280.lowerBody = game.playerMesh.genObj3D(0, config.legHeight, 0);
        if (v12992) {
          p16280.headObj = game.playerMesh.genHead(p16280.renderYou, serverIO ? {
            pad: config.hitBoxPadP
          } : {
            hairCol: v12991,
            skinCol: v12985,
            uvScale: vO418.uvScale,
            rgb: vO418.rgb,
            rgbS: vO418.rgbS || 0,
            noHead: v13009,
            noHair: v13010,
            transparent: vO418.opac != null,
            opacity: vO418.opac || 1,
            texSrc: vO418.tex ? vO418.tex : null,
            rotT: vO418.rotT,
            movT: vO418.movT,
            movE: vO418.movE,
            movD: vO418.movD,
            emissive: vO418.glow || vO418.sameGlow ? vO418.emiss || "#ffffff" : null,
            color: vO418 ? vO418.color : null,
            sameGlow: vO418.sameGlow,
            shaderNum: vO418 ? vO418.shaderNum : null,
            video: vO418 ? vO418.video : undefined,
            projection: vO418 ? vO418.projection : undefined,
            repeatY: vO418.tileS || 0,
            repeatX: vO418.tileS || 0
          });
          p16280.lowerBody.add(p16280.headObj);
          p16280.lowerBody.add(game.playerMesh.genBody(p16280.renderYou, serverIO ? {
            pad: config.hitBoxPadP
          } : {
            shirtCol: v12986,
            pantsCol: v12988,
            waistCol: v12989,
            skinCol: v12985,
            uvScale: vO418.uvScale,
            rgb: vO418.rgb,
            rgbS: vO418.rgbS || 0,
            noBody: !!v13005 && v13005.noBody,
            transparent: vO418.opac != null,
            opacity: vO418.opac || 1,
            texSrc: vO418.tex ? vO418.tex : null,
            rotT: vO418.rotT,
            movT: vO418.movT,
            movE: vO418.movE,
            movD: vO418.movD,
            emissive: vO418.glow || vO418.sameGlow ? vO418.emiss || "#ffffff" : null,
            color: vO418 ? vO418.color : null,
            sameGlow: vO418.sameGlow,
            shaderNum: vO418 ? vO418.shaderNum : null,
            video: vO418 ? vO418.video : undefined,
            projection: vO418 ? vO418.projection : undefined,
            repeatY: vO418.tileS || 0,
            repeatX: vO418.tileS || 0
          }));
        }
        p16280.upperBody = game.playerMesh.genObj3D(0, 0, 0);
        p16280.lowerBody.add(p16280.upperBody);
        if (v13005 && !serverIO) {
          p16280.bodyMesh = RENDER.genObj3D(0, (config.playerHeight - config.legHeight - config.headScale) / 2 - (v13005.sitOff || 0), -(v13005.sitOffZ || 0));
          p16280.lowerBody.add(p16280.bodyMesh);
          RENDER[v13005.hasAnim ? "loadAnimMesh" : "loadMesh"](this.generateMeshData(v13005, v12992, vO418), 0, 0, 0, Math.PI / 2, (v13005.sclMlt || 1) * 2.1, p16280.bodyMesh);
        }
        if (v13006 && !serverIO) {
          p16280.backMesh = RENDER.genObj3D(0, (config.playerHeight - config.legHeight - config.headScale) / 2 - (v13006.sitOff || 0), -(v13006.sitOffZ || 0));
          p16280.lowerBody.add(p16280.backMesh);
          RENDER[v13006.hasAnim ? "loadAnimMesh" : "loadMesh"](this.generateMeshData(v13006, v12992, vO418), 0, 0, 0, Math.PI / 2, (v13006.sclMlt || 1) * 2.1, p16280.backMesh);
        }
        if (iÏíìíîí >= 0 && v12992 && !serverIO) {
          v13002 = game.store.skins[iÏíìíîí];
          p16280.waistMesh = RENDER.genObj3D(0, (config.playerHeight - config.legHeight - config.headScale - 2) / 2 - (v13002.sitOff || 0), -(v13002.sitOffZ || 0));
          p16280.lowerBody.add(p16280.waistMesh);
          if (v13002.noLegs) {
            v13008 = true;
          }
          RENDER[v13002.hasAnim ? "loadAnimMesh" : "loadMesh"](this.generateMeshData(v13002, v12992, vO418), 0, 0, 0, Math.PI / 2, (v13002.sclMlt || 1) * 2.1, p16280.waistMesh);
        }
        if (v13003 && !serverIO) {
          p16280.hatMesh = RENDER.genObj3D(0, config.playerHeight - config.legHeight - (v13003.sitOff || 0), -(v13003.sitOffZ || 0));
          p16280.lowerBody.add(p16280.hatMesh);
          RENDER[v13003.hasAnim ? "loadAnimMesh" : "loadMesh"](this.generateMeshData(v13003, v12992, vO418), 0, 0, 0, Math.PI / 2, (v13003.sclMlt || 1) * 2.1, p16280.hatMesh);
        }
        if (v13004 && !serverIO) {
          p16280.headMesh = RENDER.genObj3D(0, config.playerHeight - config.legHeight - (v13004.sitOff || 0), -(v13004.sitOffZ || 0));
          p16280.lowerBody.add(p16280.headMesh);
          RENDER[v13004.hasAnim ? "loadAnimMesh" : "loadMesh"](this.generateMeshData(v13004, v12992, vO418), 0, 0, 0, Math.PI / 2, (v13004.sclMlt || 1) * 2.1, p16280.headMesh);
        }
        if (p16280.faceIndex >= 0 && v12992 && !serverIO) {
          v13002 = game.store.skins[iÌììïiì];
          p16280.faceMesh = RENDER.genObj3D(0, config.playerHeight - config.legHeight - (v13002.sitOff || 0), -(v13002.sitOffZ || 0));
          p16280.lowerBody.add(p16280.faceMesh);
          RENDER[v13002.hasAnim ? "loadAnimMesh" : "loadMesh"](this.generateMeshData(v13002, v12992, vO418), 0, 0, 0, Math.PI / 2, (v13002.sclMlt || 1) * 1, p16280.faceMesh);
        }
        if (v12992 && !v13008) {
          var v13011;
          var v13012 = UTILS.randInt(0, 1);
          for (var vLN02326 = 0; vLN02326 < 4; ++vLN02326) {
            v13011 = false;
            if (iÌíîïîi >= 0 && vLN02326 < 2 && !serverIO) {
              v13002 = game.store.skins[iÌíîïîi];
              v13011 = v13002.legLen;
              if (v13002.randomLeg && v13012 != vLN02326) {
                v13011 = false;
              }
              var v13013 = config.legHeight - (vLN02326 > 1 ? config.crouchDst + 0.5 : 0);
              var v13014 = RENDER.genObj3D(config.legScale / 2 * (vLN02326 == 1 || vLN02326 == 3 ? -1 : 1), v13013 - (v13002.sitOff || 0) - 0.01, -(v13002.sitOffZ || 0));
              RENDER[v13002.hasAnim ? "loadAnimMesh" : "loadMesh"](this.generateMeshData(v13002, v12992, vO418), 0, 0 - v13013, 0, Math.PI / 2, (v13002.sclMlt || 1) * 1, v13014);
              p16280.shoeMeshes.push(v13014);
              if (vLN02326 >= 2) {
                RENDER.rotateMesh(p16280.shoeMeshes[vLN02326], vLN02326 == 2 ? -(Math.PI / 6) : Math.PI / 8, 0, 0);
              }
              p16280.shoeMeshes[vLN02326].hide = v13002.randomLeg && v13012 != vLN02326;
              p16280.shoeMeshes[vLN02326].visible = !p16280.shoeMeshes[vLN02326].hide && vLN02326 <= 1;
              p16280.meshHoldObj.add(p16280.shoeMeshes[vLN02326]);
            }
            p16280.legMeshes.push(game.playerMesh.genLeg(vLN02326 == 1 || vLN02326 == 3, v12988, v12990, serverIO ? {
              crouch: vLN02326 > 1,
              pad: config.hitBoxPadP
            } : {
              crouch: vLN02326 > 1,
              legLen: !!v13011 && v13011,
              rgb: !!vO418 && vO418.rgb,
              rgbS: vO418 ? vO418.rgbS : 0,
              uvScale: vO418.uvScale,
              transparent: vO418.opac != null,
              opacity: vO418.opac || 1,
              texSrc: vO418.tex ? vO418.tex : null,
              rotT: vO418.rotT,
              movT: vO418.movT,
              movE: vO418.movE,
              movD: vO418.movD,
              emissive: vO418.glow || vO418.sameGlow ? vO418.emiss || "#ffffff" : null,
              color: vO418 ? vO418.color : null,
              sameGlow: vO418.sameGlow,
              shaderNum: vO418 ? vO418.shaderNum : null,
              video: vO418 ? vO418.video : undefined,
              projection: vO418 ? vO418.projection : undefined,
              repeatY: vO418.tileS || 0,
              repeatX: vO418.tileS || 0
            }));
            if (vLN02326 >= 2) {
              game.playerMesh.rotateMesh(p16280.legMeshes[vLN02326], vLN02326 == 2 ? -(Math.PI / 6) : Math.PI / 8, 0, 0);
            }
            p16280.legMeshes[vLN02326].visible = vLN02326 <= 1;
            p16280.meshHoldObj.add(p16280.legMeshes[vLN02326]);
          }
        }
        if (p16283) {
          for (var vLN02326 = 0; vLN02326 < p16280.ammos.length; ++vLN02326) {
            var v13015 = game.playerMesh.genObj3D(0, 0, 0);
            var v13016 = game.players.getWeapon(p16280, vLN02326);
            var v13017 = game.store.skins[v13016.melee ? iÏïïîîì : p16280.getSkinForLoadout(vLN02326)];
            if (!v13016.melee && v13017 && v13017.weapon - 1 != p16280.loadout[vLN02326]) {
              v13017 = null;
            }
            if (!v13017 || v13016.upgraded) {
              v13017 = {};
              if (v13016.altSkin) {
                v13017 = v13016.altSkin || {};
              }
            }
            var v13018 = (v13016.attach != null || v13017.attachBypass) && !v13017.noAttach && game.attach[p16280.attachIndex] ? game.attach[p16280.attachIndex] : null;
            if (!serverIO && p16280.isYou && v13016.ammo) {
              v13015.muzzles = [];
              v13015.casings = [];
              for (var vLN02329 = 0; vLN02329 < 2; ++vLN02329) {
                if (!vLN02329 || v13016.akimbo) {
                  v13015.muzzles.push(new game.THREE.Sprite());
                  v13015.muzzles[vLN02329].position.z = -(v13016.muzOff || 0);
                  v13015.muzzles[vLN02329].position.y = v13016.muzOffY || 0;
                  v13015.muzzles[vLN02329].visible = false;
                  v13015.muzzles[vLN02329].static = true;
                  PARTICLES.particles.push(v13015.muzzles[vLN02329]);
                  v13015.add(v13015.muzzles[vLN02329]);
                  v13015.casings.push(RENDER.genObj3D(vLN02329 ? -v13016.xOff * 2 : 0, v13016.caseYOff || 0, v13016.caseZOff || 0));
                  v13015.add(v13015.casings[vLN02329]);
                }
              }
              v13015.muzzleFlash = RENDER.genObj3D(0, 0.4, 0);
              v13015.muzzles[0].add(v13015.muzzleFlash);
            }
            var vLN1165 = 1;
            if (v13016.src || !p16280.renderYou) {
              var v13023 = game.playerMesh.genArms(v13016, null, !v12992, serverIO ? {
                armS: vLN1165,
                pad: config.hitBoxPadP,
                leftHoldY: v13017.leftHoldY,
                leftHoldX: v13017.leftHoldX,
                leftHoldZ: v13017.leftHoldZ,
                rightHoldY: v13017.rightHoldY,
                rightHoldZ: v13017.rightHoldZ,
                rightHoldX: v13017.rightHoldX
              } : {
                shirtCol: v12986,
                sleeveCol: v12987,
                skinCol: v12985,
                armS: vLN1165,
                uvScale: vO418.uvScale,
                noRightHand: !!v13017.noRightHand,
                leftHoldY: v13017.leftHoldY,
                leftHoldX: v13017.leftHoldX,
                leftHoldZ: v13017.leftHoldZ,
                rightHoldY: v13017.rightHoldY,
                rightHoldZ: v13017.rightHoldZ,
                rightHoldX: v13017.rightHoldX,
                noSleeve: vO418 && vO418.noSleeve || p16280.config.noSleeve,
                noLeftSleeve: v13007 && v13007.noLeftSleeve,
                rgb: !!vO418 && vO418.rgb,
                rgbS: vO418 ? vO418.rgbS : 0,
                transparent: vO418.opac != null,
                opacity: vO418.opac || 1,
                texSrc: vO418.tex ? vO418.tex : null,
                rotT: vO418.rotT,
                movT: vO418.movT,
                movE: vO418.movE,
                movD: vO418.movD,
                emissive: vO418.glow || vO418.sameGlow ? vO418.emiss || "#ffffff" : null,
                color: vO418 ? vO418.color : null,
                sameGlow: vO418.sameGlow,
                shaderNum: vO418 ? vO418.shaderNum : null,
                video: vO418 ? vO418.video : undefined,
                projection: vO418 ? vO418.projection : undefined,
                repeatY: vO418.tileS || 0,
                repeatX: vO418.tileS || 0
              }, v13007 && !serverIO && p16280.isYou);
              v13015.add(v13023.mesh);
              p16280.mergedArmMeshes[vLN02326] = v13023.mesh;
              if (v13007 && !serverIO && p16280.isYou) {
                let v13020 = v13023.vecs.l;
                let v13021 = v13023.mesh.geometry.attributes.position.array;
                const v13022 = new game.THREE.Box3().setFromBufferAttribute(new game.THREE.Float32BufferAttribute(v13021.slice(v13020.startP, v13020.endP), 3)).getCenter(new game.THREE.Vector3());
                p16280.wristMeshes[vLN02326] = RENDER.genObj3D(v13022.x, v13022.y, v13022.z);
                p16280.wristMeshes[vLN02326].quaternion.copy(v13020.quat);
                v13023.mesh.add(p16280.wristMeshes[vLN02326]);
                RENDER[v13007.hasAnim ? "loadAnimMesh" : "loadMesh"](this.generateMeshData(v13007, v12992, vO418), 0, 0, 0, [-(Math.PI / 2), -(Math.PI / 2), 0], (v13007.sclMlt || 1) * 1, p16280.wristMeshes[vLN02326]);
              }
            } else {
              var v13023;
              for (var vLN02329 = 0; vLN02329 < 2; ++vLN02329) {
                v13023 = game.playerMesh.genArms(v13016, vLN02329 + 1, !v12992, serverIO ? {
                  pad: config.hitBoxPadP,
                  armS: vLN1165
                } : {
                  shirtCol: v12986,
                  sleeveCol: v12987,
                  skinCol: v12985,
                  armS: vLN1165,
                  uvScale: vO418.uvScale,
                  noRightHand: !!v13017.noRightHand,
                  rgb: !!vO418 && vO418.rgb,
                  rgbS: vO418 ? vO418.rgbS : 0,
                  transparent: vO418.opac != null,
                  opacity: vO418.opac || 1,
                  noSleeve: vO418 && vO418.noSleeve || p16280.config.noSleeve,
                  noLeftSleeve: v13007 && v13007.noLeftSleeve,
                  texSrc: vO418.tex ? vO418.tex : null,
                  rotT: vO418.rotT,
                  movT: vO418.movT,
                  movE: vO418.movE,
                  movD: vO418.movD,
                  emissive: vO418.glow || vO418.sameGlow ? vO418.emiss || "#ffffff" : null,
                  color: vO418 ? vO418.color : null,
                  sameGlow: vO418.sameGlow,
                  shaderNum: vO418 ? vO418.shaderNum : null,
                  video: vO418 ? vO418.video : undefined,
                  projection: vO418 ? vO418.projection : undefined,
                  repeatY: vO418.tileS || 0,
                  repeatX: vO418.tileS || 0
                });
                v13015.add(v13023.mesh);
                p16280.armMeshes.push(v13023.mesh);
              }
              if (v13007 && !serverIO && p16280.isYou) {
                p16280.wristMeshes[vLN02326] = RENDER.genObj3D(-1.55 - (v13007.sitOffX || 0), -1.4 - (v13007.sitOff || 0), 1 - (v13007.sitOffZ || 0));
                p16280.armMeshes[0].add(p16280.wristMeshes[vLN02326]);
                RENDER[v13007.hasAnim ? "loadAnimMesh" : "loadMesh"](this.generateMeshData(v13007, v12992, vO418), 0, 0, 0, [v13007.sxRot || 0, v13007.syRot || 0, v13007.szRot || 0], (v13007.sclMlt || 1) * 1, p16280.wristMeshes[vLN02326]);
              }
            }
            p16280.weaponMeshes.push(v13015);
            p16280.weaponMeshes[vLN02326].visible = false;
            p16280.upperBody.add(p16280.weaponMeshes[vLN02326]);
            if (!serverIO && !!v13016.melee && (!!p16280.renderYou || !game.mode || !game.mode.teamOptions || game.mode.teamOptions[p16280.team - 1] != "Infected")) {
              if (v13017.holdTyp) {
                v13017.holdTyp == 1;
              } else {
                p16280.weaponGeos[vLN02326] = RENDER[v13017.hasAnim ? "loadAnimMesh" : "loadMesh"]({
                  fileExt: v13017.fileExt,
                  setLayer: v12992 ? undefined : 1,
                  animS: v13017.animS,
                  hasAnim: v13017.hasAnim,
                  inspectAnim: v13017.inspectAnim,
                  local: v13017.local,
                  localM: v13017.localM,
                  src: "melee/melee_" + (v13017.id || 0),
                  texSrc: game.mode && game.mode.teamOptions && game.mode.teamOptions[p16280.team - 1] == "Stalker" ? "melee/melee_0_5" : v13017.pat ? v13017.tex : v13017.tex ? "melee/melee_" + (v13017.id || 0) + "_" + v13017.tex : "",
                  sameEnv: v13017.sameEnv,
                  env: v13017.env || v13017.sameEnv ? v13017.env || 3 : undefined,
                  sameGlow: v13017.sameGlow,
                  glowText: v13017.glow || v13017.sameGlow,
                  emissive: v13017.glow || v13017.sameGlow ? v13017.emiss || "#ffffff" : null,
                  emissInt: v13017.glowInt,
                  rotT: v13017.rotT,
                  movT: v13017.movT,
                  movE: v13017.movE,
                  movD: v13017.movD,
                  pulsT: v13017.pulsT,
                  minGlo: v13017.minGlo,
                  frameT: v13017.frameT,
                  tFilter: game.THREE.LinearFilter,
                  frames: v13017.frames,
                  transparent: v13017.opac != null || v13016.seeThrough || v13017.trans,
                  mat: (p16282 || p16280.renderYou) && !v13017.noShine ? RENDER.weaponShine ? game.THREE.MeshPhongMaterial : game.THREE.MeshLambertMaterial : null,
                  uv2: true,
                  specular: 2697513,
                  shininess: 100,
                  rgb: v13017.rgb,
                  rgbS: v13017.rgbS,
                  rgbT: v13017.rgbT,
                  useWireframe: v13017.wire,
                  side: v13017.side || 0,
                  opacity: v13017.opac || 1,
                  alphaTest: v13017.alpha || 0,
                  shaderNum: v13017.shaderNum,
                  video: v13017.video,
                  projection: v13017.projection,
                  color: v13017.color || null
                }, (p16280.renderYou ? 0.9 : 1.7) + (p16280.renderYou ? v13017.sxOff || 0 : v13017.osxOff || 0), (p16280.renderYou ? -0.95 : -0.4) + (p16280.renderYou ? v13017.syOff || 0 : v13017.osyOff || 0), (p16280.renderYou ? 0.72 : 1.2) + (p16280.renderYou ? v13017.szOff || 0 : v13017.oszOff || 0), [-(Math.PI / 3.5), p16280.renderYou ? 0.3 + (v13017.flip ? Math.PI : 0) : Math.PI / 2, !p16280.renderYou && v13017.oFlip ? -Math.PI / 0.00001 : -(Math.PI * 0.9) + (p16280.renderYou ? v13017.sxRot || 0 : 0)], v13017.sclMlt || 0.9, p16280.armMeshes[1] ? p16280.armMeshes[1] : p16280.weaponMeshes[vLN02326]);
                if (p16280.armMeshes[1]) {
                  p16280.armMeshes[1].yR = p16280.armMeshes[1].rotation.y;
                  if (p16280.renderYou) {
                    p16280.armMeshes[1].zR = p16280.armMeshes[1].rotation.z = -0.3;
                    p16280.armMeshes[1].xR = p16280.armMeshes[1].rotation.x = -0.4;
                    p16280.armMeshes[1].xP = p16280.armMeshes[1].position.x = 0.4;
                    p16280.armMeshes[1].yP = p16280.armMeshes[1].position.y = 0.3;
                  } else {
                    p16280.armMeshes[1].zR = p16280.armMeshes[1].rotation.z = 0.3;
                    p16280.armMeshes[1].yP = p16280.armMeshes[1].position.y = -0.4;
                    p16280.armMeshes[1].xR = p16280.armMeshes[1].rotation.x;
                    p16280.armMeshes[1].xP = p16280.armMeshes[1].position.x = -0.2;
                  }
                  p16280.armMeshes[0].xP = p16280.armMeshes[0].position.x = 0.3;
                  p16280.armMeshes[0].yP = p16280.armMeshes[0].position.y = -0.5;
                  p16280.armMeshes[0].zR = p16280.armMeshes[0].rotation.z = -0.4;
                  p16280.armMeshes[0].yR = p16280.armMeshes[0].rotation.y;
                }
              }
              if (game.mode && game.mode.noKnives) {
                p16280.weaponGeos[vLN02326].visible = false;
              }
            }
            if (!serverIO && v13016.src) {
              var v13024 = p16280.getSkinForLoadout(vLN02326) >= 0 && (v13017.glow || v13017.sameGlow);
              for (var vLN02329 = 0; vLN02329 < 2; ++vLN02329) {
                if (!vLN02329 || v13016.akimbo) {
                  RENDER[v13017.hasAnim ? "loadAnimMesh" : "loadMesh"]({
                    fileExt: v13017.fileExt,
                    setLayer: v12992 ? undefined : 1,
                    animS: v13017.animS,
                    hasAnim: v13017.hasAnim,
                    inspectAnim: v13017.inspectAnim,
                    local: v13016.local || v13017.local,
                    localM: v13016.localM || v13017.localM,
                    src: "weapons/" + v13016.src + (v13017.mid == null ? "" : "_" + v13017.mid),
                    texSrc: v13017.mid == null ? v13017.tex ? v13017.tex : v13017 && v13017.id != null ? "weapons/skins/" + v13016.src + "_" + v13017.id : null : UTILS.getReModel(game.store, v13017),
                    tFilter: game.THREE.LinearFilter,
                    mat: (p16282 || p16280.renderYou) && !v13017.noShine ? RENDER.weaponShine ? game.THREE.MeshPhongMaterial : game.THREE.MeshLambertMaterial : null,
                    frames: v13017.frames,
                    frameT: v13017.frameT,
                    pulsT: v13017.pulsT,
                    minGlo: v13017.minGlo,
                    shadows: RENDER.highResShad,
                    rotT: v13017.rotT,
                    movT: v13017.movT,
                    movE: v13017.movE,
                    movD: v13017.movD,
                    repeatY: v13017.tileS || 0,
                    repeatX: v13017.tileS || 0,
                    sameEnv: v13017.sameEnv,
                    env: v13017.env || v13017.sameEnv ? v13017.env || 3 : undefined,
                    sameGlow: v13017.sameGlow,
                    glowText: v13024,
                    uv2: true,
                    ao: v13017.ao || p16281 && !v13016.noAo,
                    shininess: v13017.noShine ? v13017.shine || v13016.shine || 60 : 0,
                    specular: 2697513,
                    transparent: v13017.opac != null || v13016.seeThrough || v13017.trans,
                    emissive: (v13016.transp || v13024) && !v13017.noEmis ? v13017.emiss || "#ffffff" : null,
                    emissInt: v13017.glowInt,
                    rgb: v13017.rgb,
                    rgbS: v13017.rgbS,
                    rgbT: v13017.rgbT,
                    useWireframe: v13017.wire,
                    side: v13016.side || v13017.side || 0,
                    opacity: v13017.opac || 1,
                    shaderNum: v13017.shaderNum,
                    video: v13017.video,
                    projection: v13017.projection,
                    color: v13017.color || null,
                    alphaTest: v13017.alpha || 0,
                    normal: v13017.normal || null,
                    spec: v13017.spec || null,
                    metalness: v13017.metalness || null,
                    roughness: v13017.roughness || null,
                    displacement: v13017.displacement || null,
                    bump: v13017.bump || null,
                    outlineMesh: v13017.outline == null ? undefined : v13017.outline,
                    outlineScale: v13017.outlineS ? v13017.outlineS : undefined
                  }, vLN02329 == 1 ? -(v13016.xOff * 2) : 0, v13017.yOff || v13016.wyOff || 0, v13017.zOff || v13016.wzOff || 0, v13016.rot || Math.PI / 2, v13017.mScl || v13016.scale, p16280.weaponMeshes[vLN02326]);
                }
              }
            }
            var v13025 = game.store.skins[p16280.charms[vLN02326]];
            if (!serverIO && v13016.charm && v13025 && !v13017.noCharm) {
              var v13026 = RENDER.loadMesh({
                src: "charms/charm_mount_0",
                tFilter: game.THREE.LinearFilter,
                mat: RENDER.weaponShine ? game.THREE.MeshPhongMaterial : game.THREE.MeshLambertMaterial,
                shininess: 60,
                transparent: true
              }, v13017.charmMXOff || v13016.charmMXOff, v13017.charmMYOff || v13016.charmMYOff, v13017.charmMZOff || v13016.charmMZOff, Math.PI / 2, v13016.charmMScl * (v13017.charmMScl || 1), p16280.weaponMeshes[vLN02326]);
              p16280.weaponMeshes[vLN02326].charmMesh = RENDER.loadMesh({
                local: v13025.local,
                localM: v13025.localM,
                src: "charms/charm_" + v13025.id,
                texSrc: v13025.tex ? "charms/charm_" + v13025.id + "_" + v13025.tex : null,
                tFilter: game.THREE.LinearFilter,
                mat: RENDER.weaponShine ? game.THREE.MeshPhongMaterial : game.THREE.MeshLambertMaterial,
                shininess: 60,
                transparent: true,
                sameGlow: v13025.sameGlow,
                glowText: v13025.glow || v13025.sameGlow,
                emissive: (v13025.glow || v13025.sameGlow) && !v13025.noEmis ? v13025.emiss || "#ffffff" : null,
                frames: v13025.frames,
                frameT: v13025.frameT,
                pulsT: v13025.pulsT,
                alphaTest: v13025.alpha || 0
              }, v13017.charmXOff || v13016.charmXOff, (v13017.charmYOff || v13016.charmYOff) + 0.17, v13017.charmZOff || v13016.charmZOff, -Math.PI, v13016.charmScl * (v13017.charmScl || 1), v13026);
            }
            if (!serverIO && p16281 && v13016.flap && RENDER.sniperFlap && v13017.mid == null && !v13017.hasAnim) {
              p16280.weaponMeshes[vLN02326].flapMesh = RENDER.loadMesh({
                src: "attach/" + v13016.flap.src,
                tFilter: game.THREE.LinearFilter,
                mat: RENDER.weaponShine ? game.THREE.MeshPhongMaterial : game.THREE.MeshLambertMaterial,
                shininess: 60,
                transparent: true
              }, v13016.flap.xOff, v13016.flap.yOff, v13016.flap.zOff, Math.PI / 2, v13016.flap.scl, p16280.weaponMeshes[vLN02326]);
            }
            if (!serverIO && v13018 && (p16281 || p16282)) {
              var vLN02330 = 0;
              if (v13018.yOff && v13018.yOff[v13016.id]) {
                vLN02330 = v13018.yOff[v13016.id];
              }
              RENDER.loadMesh({
                src: "attach/" + v13018.src,
                tFilter: game.THREE.LinearFilter,
                shininess: 60,
                side: v13018.side || 0,
                mat: p16282 || p16280.renderYou ? RENDER.weaponShine ? game.THREE.MeshPhongMaterial : game.THREE.MeshLambertMaterial : null,
                specular: 2697513,
                transparent: true
              }, 0, -(v13016.yOrg || 0) + (v13017.attachYOff || v13016.attachYOff || 0) - vLN02330, -(v13017.attachZOff || v13016.attachZOff || 0) - (v13018.zOff || 0), Math.PI / 2, v13017.attachScale || v13018.scale, p16280.weaponMeshes[vLN02326]);
            }
          }
        }
        p16280.meshHoldObj.add(p16280.lowerBody);
        if (!serverIO) {
          function f2101(p16284) {
            p16284.layers.set(1);
          }
          if (!v12992) {
            p16280.objInstances.traverse(f2101);
          }
        }
      }
    }
    if (p16280.leftHand) {
      p16280.upperBody.applyMatrix4(RENDER.mirroredMatrix);
    }
    if (!serverIO) {
      p16280.petHolder = RENDER.genObj3D(3, p16280.height, 0);
      p16280.objInstances.add(p16280.petHolder);
    }
    return p16280.objInstances;
  };
  this.pickProp = function (p16285) {};
  this.regenMeshes = function (p16286) {
    if (p16286.objInstances) {
      this.disposeMesh(p16286, true);
    }
    var v13027 = !game || !game.disableMeshes;
    this.generateMeshes(p16286, p16286.renderYou, false, v13027);
    game.players.updateHeadSize(p16286, p16286.headMlt);
    if (RENDER) {
      RENDER.add(p16286.objInstances);
      if (p16286.petIndex >= 0 && v13027) {
        game.pets.add(p16286);
      }
    }
    var v13028 = p16286.config.aID || "";
    p16286.hasAnims = !!v13028.includes("g") || !!v13028.includes("q") || !!v13028.includes("f");
    this.swapWeapon(p16286, 0, true);
    if (p16286.isYou && RENDER) {
      this.resetAim();
    }
  };
  this.hideAll = function () {
    for (var vLN02331 = 0; vLN02331 < this.list.length; ++vLN02331) {
      if (this.list[vLN02331].active && this.list[vLN02331].objInstances && (this.list[vLN02331].forcePos = !this.list[vLN02331].latestData, this.list[vLN02331].latestData = false, !this.list[vLN02331].isYou)) {
        var v13029 = this.list[vLN02331];
        v13029.objInstances.visible = false;
      }
    }
  };
  this.clear = function () {
    for (var vLN02332 = 0; vLN02332 < this.list.length; ++vLN02332) {
      this.disposeMesh(this.list[vLN02332]);
    }
    this.list.length = 0;
  };
  this.toggleLOD = function (p16287, p16288) {
    var v13030 = game && game.hidePlayers;
    if (p16287 && p16287.isBot) {
      v13030 = false;
    }
    if (!v13030 && !!game && !!game.useLOD) {
      if (p16287.latestData) {
        if (p16287.objInstances) {
          p16287.objInstances.visible = p16288;
        }
        p16287.lodActive = !p16288;
      }
    }
  };
  this.disposeMesh = function (p16289) {
    if (RENDER) {
      RENDER.remove(p16289.objInstances);
      game.pets.remove(p16289);
      if (p16289.buildHelper) {
        RENDER.remove(p16289.buildHelper);
        RENDER.remove(p16289.buildHelperN);
        p16289.buildHelper = null;
        p16289.buildHelperN = null;
      }
    }
    p16289.objInstances = null;
    p16289.meshHoldObj = null;
    p16289.headObj = null;
    p16289.faceMesh = null;
    p16289.hatMesh = null;
    p16289.headMesh = null;
    p16289.bodyMesh = null;
    p16289.backMesh = null;
    p16289.waistMesh = null;
    p16289.wristMeshes.length = 0;
    p16289.weaponMeshes.length = 0;
    p16289.weaponGeos = {};
    p16289.mergedArmMeshes.length = 0;
    p16289.armMeshes.length = 0;
    p16289.legMeshes.length = 0;
    p16289.shoeMeshes.length = 0;
  };
  this.isValidProp = function (p16290) {
    return !!prefabs.prefabs[p16290];
  };
  this.randomProp = function () {
    return UTILS.getRandom(prefabs.props).id;
  };
  this.updateProp = function (p16291, p16292, p16293) {
    if (p16291 && p16291.active) {
      if (p16292 != null) {
        p16291.propID = p16292;
      }
      var v13031 = prefabs ? prefabs.prefabs[p16292].scale : 0;
      var v13032 = prefabs ? prefabs.prefabs[p16292].CP || 0 : 0;
      p16291.height = v13031 + v13032;
      p16291.adjustedHeight = v13031 + v13032;
      p16291.scale = v13031 + v13032;
      if (p16293) {
        this.regenMeshes(p16291);
      }
      if (serverIO) {
        game.broadcast("up", p16291.sid, p16292, false, p16291.propSwitches);
      }
    }
  };
  this.updateHeadSize = function (p16294, p16295, p16296) {
    if (p16295 > 1 || p16296) {
      p16294.headMlt = p16296 ? 1 : p16295;
      if (p16294.headObj && p16294.headMlt) {
        let v13033 = game && game.mode ? game.mode.headMlt || 0.1 : 0.1;
        let v13034 = Math.round((p16294.headMlt - 1) / v13033);
        p16294.headObj.scale.setScalar(p16294.headMlt);
        p16294.headObj.position.y = v13034 * -0.48;
        let v13035 = (config.headScale * p16294.headMlt - config.headScale) / 2;
        if (p16294.faceMesh) {
          p16294.faceMesh.scale.setScalar(p16294.headMlt);
          let v13036 = game.store.skins[p16294.faceIndex];
          let v13037 = (v13036.sitOff || 0) / p16294.headMlt;
          p16294.faceMesh.position.y = config.playerHeight - config.legHeight + v13035 - v13037;
        }
        if (p16294.hatMesh) {
          p16294.hatMesh.scale.setScalar(p16294.headMlt);
          let v13038 = game.store.skins[p16294.hatIndex];
          let v13039 = v13038.sitOff || 0;
          p16294.hatMesh.position.y = config.playerHeight - config.legHeight + v13035 - v13039;
        }
        if (p16294.headMesh) {
          p16294.headMesh.scale.setScalar(p16294.headMlt);
          let v13040 = game.store.skins[p16294.headIndex];
          let v13041 = v13040.sitOff || 0;
          p16294.headMesh.position.y = config.playerHeight - config.legHeight + v13035 - v13041;
        }
      }
      game.players.updateHeight(p16294);
    }
  };
  this.remove = function (p16297) {
    var v13042 = this.indexBySid(p16297);
    if (v13042 >= 0) {
      if (game.isServer && this.list[v13042]) {
        game.dropFlag(this.list[v13042].flag);
        this.dropWeapon(this.list[v13042], true);
      }
      var v13043 = this.list[v13042].id;
      if (this.list[v13042].objInstances) {
        this.disposeMesh(this.list[v13042]);
      }
      this.list.splice(v13042, 1);
      if (game.isServer) {
        for (var v13044 = this.list.length - 1; v13044 >= 0; --v13044) {
          v13042 = this.list[v13044].sentTo.indexOf(v13043);
          if (v13042 >= 0) {
            this.list[v13044].sentTo.splice(v13042, 1);
          }
        }
        game.broadcast("2", p16297);
        this.syncLeaders(true);
      }
      if (typeof window != "undefined" && "updateWindow" in window) {
        window.updateWindow(23);
      }
    }
  };
  this.resetMovVals = function (p16298) {
    var v13045 = game.movement[p16298.config.movSch || 0];
    if (v13045 && v13045.sendVals) {
      for (var vLN02333 = 0; vLN02333 < v13045.sendVals.length; ++vLN02333) {
        p16298[v13045.sendVals[vLN02333]] = 0;
      }
    }
  };
  this.add = function (p16299, p16300, p16301, p16302, p16303, p16304, p16305, p16306, p16307, p16308, p16309, p16310, p16311, p16312, p16313, p16314, p16315, p16316, p16317, p16318, p16319, p16320, p16321, p16322, p16323, p16324, p16325, p16326, p16327, p16328, p16329, p16330, p16331, p16332, p16333, p16334, p16335, p16336) {
    var v13046;
    for (var vLN02334 = 0; vLN02334 < this.list.length; ++vLN02334) {
      if (this.list[vLN02334].id == p16299) {
        v13046 = this.list[vLN02334];
        break;
      }
    }
    if (v13046) {
      v13046.weaponMeshes.length = 0;
      v13046.weaponGeos = {};
      v13046.legMeshes.length = 0;
      v13046.shoeMeshes.length = 0;
      v13046.armMeshes.length = 0;
      v13046.mergedArmMeshes.length = 0;
      v13046.wristMeshes.length = 0;
    } else {
      v13046 = new Player(p16299, this, game, serverIO);
      v13046.sid = p16300 ? p16300 : UTILS.generateSID(this.list) + (p16335 ? 10000 : 0);
      this.list[this.list._push ? "_push" : "push"](v13046);
    }
    var v13047 = !game || !game.disableMeshes;
    if (!p16304) {
      p16304 = "Guest_" + v13046.sid;
    }
    v13046.init(p16303, p16301, p16302, p16304, p16325, p16326);
    v13046.tmpAccountName = p16328;
    if (this.isServer && game.mode != null) {
      this.setTeam(v13046);
    }
    if (p16324) {
      v13046.team = p16324;
    }
    v13046.skins = p16306 || [-1, -1];
    v13046.charms = p16332 || [-1, -1];
    v13046.faceIndex = p16307;
    v13046.shoeIndex = p16308;
    v13046.hatIndex = p16309;
    v13046.headIndex = p16310;
    v13046.bodyIndex = p16311;
    v13046.backIndex = p16312;
    v13046.waistIndex = p16313;
    v13046.petIndex = p16314;
    v13046.wristIndex = p16315;
    v13046.meleeIndex = p16316;
    v13046.skinColIndex = p16317;
    v13046.hairCol = p16318;
    v13046.dyeIndex = p16319;
    v13046.pcStatIndex = p16321;
    v13046.attachIndex = p16320;
    v13046.secIndex = p16322;
    v13046.alias = p16329 || p16304;
    v13046.isJuggernaut = p16330;
    v13046.headMlt = p16331;
    v13046.userIP = p16336;
    v13046.upgrades = p16333;
    v13046.isBot = p16334;
    v13046.setClass(game, p16305, p16322, !!RENDER);
    this.resetMovVals(v13046);
    var v13048 = game.mode && game.mode.unrestrictedWeapons;
    if (!p16327 && game.mode.startingLoadout) {
      p16327 = game.mode.startingLoadout;
    }
    if (p16327) {
      v13046.updateLoadout(game, v13046.loadoutIndex, false, p16327, v13048 ? [...v13046.ammos] : undefined, v13048 ? [...v13046.reserveAmmos] : undefined, v13048 ? [...v13046.upgrades] : undefined);
    }
    if (game.mode && game.mode.objWep) {
      v13046.updateLoadout(game, v13046.loadoutIndex, false, [game.activeObjective]);
    }
    this.generateMeshes(v13046, v13046.renderYou, false, v13047);
    game.players.updateHeadSize(v13046, v13046.headMlt);
    if (RENDER) {
      RENDER.add(v13046.objInstances);
      if (v13046.petIndex >= 0 && v13047) {
        game.pets.add(v13046);
      }
    } else {
      serverIO;
    }
    var v13049 = v13046.config.aID || "";
    v13046.hasAnims = !!v13049.includes("g") || !!v13049.includes("q") || !!v13049.includes("f");
    if (game.mode && game.mode.teamOptions && game.mode.teamOptions[v13046.team - 1] == "Prop") {
      this.updateProp(v13046, p16323 || 1, true);
    }
    this.swapWeapon(v13046, 0, true);
    if (typeof window != "undefined" && "updateWindow" in window) {
      window.updateWindow(23);
    }
    return v13046;
  };
  this.getJumpSound = function (p16337) {
    if (p16337 && p16337.currentShoes && p16337.currentShoes.stepSnd && p16337.currentShoes.jumpSnd) {
      return "shoe_" + p16337.currentShoes.id;
    } else {
      return "jump_" + UTILS.randInt(0, 1);
    }
  };
  var v13050;
  this.getStepSound = function (p16338) {
    if (p16338 && p16338.currentShoes && p16338.currentShoes.stepSnd) {
      return "shoe_" + p16338.currentShoes.id;
    } else {
      v13050 = config.stepSounds[p16338.stepSrc || 0];
      return v13050.ids[UTILS.randInt(0, v13050.ids.length - 1)];
    }
  };
  this.resetStep = function (p16339, p16340, p16341) {
    if (!p16339.wasOnGround && !(p16339.oldY <= p16339.y)) {
      p16341 = p16341 || p16339.velocity.y;
      p16339.wallJumpC = 0;
      if (!p16340 && p16339.renderYou && p16339.velocity.y) {
        if (p16339.jumpTween) {
          p16339.jumpTween.stop();
        }
        if (p16339.landTween) {
          p16339.landTween.stop();
        }
        p16339.landTween = new TWEEN.Tween(p16339).to({
          landBobY: p16341 * 6,
          jumpBobY: 0
        }, 100).easing(TWEEN.Easing.Linear.None).onComplete(function () {
          p16339.landTween = new TWEEN.Tween(p16339).to({
            landBobY: 0
          }, 1100).easing(TWEEN.Easing.Elastic.Out).start();
        }).start();
      }
      var v13051 = game.mode.noSliding && !p16339.perks.includes(4) && !p16339.perks.includes(5);
      var v13052 = !game.mode.realMov && p16339.crouchVal && p16339.canSlide && p16339.canSlideT <= 0 && game.config.canSlide && !v13051;
      if (SOUND && !p16340 && p16341 && (!game.mode || !game.mode.teamOptions || game.mode.teamOptions[p16339.team - 1] != "Stalker")) {
        SOUND.play(this.getStepSound(p16339), (p16339.currentShoes.stepSnd ? 0.4 : 1) * 0.7, false);
        if (p16339.renderYou && !p16339.currentShoes.stepSnd && v13052) {
          SOUND.play("slide_0", 0.35, false);
        }
      }
      if (v13052) {
        p16339.canSlide = false;
        p16339.canSlideT = 100;
        p16339.slideTimer = config.slideTime * (game.config.slidTime || 1) * (p16339.config.slT || 1) * p16339.crouchVal;
        var v13053 = (this.onTerrain ? config.playerTerrainSlideVelMlt : config.playerSlideVelMlt) * p16339.config.slA;
        v13053 *= game.config.slidSpd || 0;
        p16339.velocity.x *= v13053;
        p16339.velocity.z *= v13053;
      }
      if (this.isServer && game.config && game.config.fallDmg) {
        var v13054 = Math.abs(p16341);
        if (v13054 > game.config.fallDmgThr) {
          v13054 *= 10;
          v13054 *= game.config.fallDmg;
          if (this.changeHealth(p16339, null, v13054)) {
            this.kill(p16339);
          }
        }
      }
    }
  };
  this.playerStep = function (p16342, p16343, p16344, p16345) {
    if (p16343 || p16345) {
      if (!p16345) {
        if (!p16342.renderYou && p16342.crouchVal) {
          p16343 *= 1.6;
        }
        p16342.stepVal += p16343 * config.stepMlt * p16342.stepDir;
        var v13055 = Math.PI / 2 * p16342.config.stpFr;
      }
      if (p16345 || p16342.stepVal >= v13055 && p16342.stepDir == 1 || p16342.stepVal <= -v13055 && p16342.stepDir == -1) {
        if (SOUND && !p16344 && (!game.mode || !game.mode.teamOptions || game.mode.teamOptions[p16342.team - 1] != "Stalker")) {
          var v13056 = UTILS.randFloat(0.15, 0.25) * (p16342.crouchVal < 1 ? 1 : p16342.isYou ? 0.5 : 0);
          var v13057 = p16342.crouchVal < 1 ? 1 : 0.8;
          if (p16342.config.stpSD) {
            v13057 += p16342.config.stpSD * p16343;
          }
          var v13058 = this.getStepSound(p16342);
          if (p16342.currentShoes && p16342.currentShoes.stepSnd) {
            v13057 *= UTILS.randFloat(0.95, 1.05);
            v13056 *= 0.6;
          }
          if (p16342.isYou) {
            SOUND.play(v13058, v13056, false, v13057);
          } else if (v13056) {
            game.playerSound(config.networkSounds.indexOf(v13058), p16342.sid, p16342.x, p16342.y, p16342.z, v13056, v13057, 170, null, null, true);
          }
        }
        p16342.stepDir *= -1;
      }
    }
  };
  this.jump = function (p16346) {
    if ((!p16346 || !p16346.weapon.noJump) && (!p16346 || !p16346.wasStopCrouch)) {
      p16346.didAct = true;
      p16346.jumpCooldown = p16346.config.jpC * 0;
      p16346.didJump = true;
      p16346.didJumpW = true;
      p16346.onTerrain = false;
      var v13059 = config.jumpVel * (game.config ? game.config.jumpMlt : 1) * (p16346.attributes.jump || 1) * (game.mode && game.mode.jumpMlt != null ? game.mode.jumpMlt : 1) * (game.mode && game.mode.jumpVel != null ? game.mode.jumpVel : 1);
      if (game.mode.realMov) {
        v13059 *= 0.92;
      }
      v13059 *= p16346.attributes.rooted;
      var v13060 = config.jumpPush * (game.config ? game.config.jumpMlt : 1) * (p16346.attributes.jump || 1) * (game.mode && game.mode.jumpMlt != null ? game.mode.jumpMlt : 1);
      var v13061 = (v13059 - v13059 * (config.crouchJump * p16346.crouchVal)) * (p16346.weapon.jumMlt || p16346.weapon.spdMlt) * (p16346.aimVal ? 1 : config.aimJumpSlow);
      if (p16346.config.ovrJump) {
        p16346.velocity.y = v13061;
      } else {
        p16346.velocity.y += v13061;
      }
      var v13062 = UTILS.getDistance(0, 0, p16346.velocity.x, p16346.velocity.z);
      p16346.velocity.x -= v13060 * v13062 * Math.sin(p16346.xDire);
      p16346.velocity.z -= v13060 * v13062 * Math.cos(p16346.xDire);
      if (!p16346.recon) {
        this.playClip(p16346, "Jump", 1);
      }
      if (SOUND && !p16346.recon && p16346.isYou) {
        if (p16346.renderYou) {
          if (p16346.landTween) {
            p16346.landTween.stop();
          }
          p16346.landTween = new TWEEN.Tween(p16346).to({
            landBobY: 0
          }, 100).easing(TWEEN.Easing.Linear.None).start();
          if (p16346.jumpTween) {
            p16346.jumpTween.stop();
          }
          p16346.jumpTween = new TWEEN.Tween(p16346).to({
            jumpBobY: 0.22
          }, 500).easing(TWEEN.Easing.Back.Out).start();
          var v13063 = UTILS.randFloat(0.12, 0.15);
          var v13064 = new TWEEN.Tween(p16346).to({
            jumpRot: [v13063, 0]
          }, 900).easing(TWEEN.Easing.Back.Out).start();
        }
        SOUND.play(this.getJumpSound(p16346), 0.04, false);
      }
    }
  };
  this.tryJump = function (p16347, p16348) {
    if (game.config && game.config.autoJump && p16348) {
      this.jump(p16347);
    } else {
      if (p16347.didJump && !p16348) {
        p16347.didJump = false;
      }
      if (!p16347.didJump && p16348) {
        this.jump(p16347);
      }
    }
  };
  this.toggleAim = function (p16349, p16350) {
    if (!!SOUND && !p16349.recon && !p16349.weapon.melee) {
      if (p16349.weapon.aimSound) {
        SOUND.play(p16349.weapon.aimSound, 0.05);
      } else {
        SOUND.play("aim_" + p16350, 0.1);
      }
    }
    if (!p16350 || game.mode && game.mode.teamOptions && game.mode.teamOptions[p16349.team - 1] == "Prop") {
      this.resetAim();
    }
    if (game.controls.camType.isNormal && p16349.weapon.scope && !p16349.currentSkin.noScope && p16349.weaponMeshes && p16349.weaponMeshes[p16349.loadoutIndex]) {
      RENDER.zoom(p16350 ? 1 + (p16349.weapon.zoom - 1) * RENDER.adsFov[RENDER.getPlayerWeaponId(p16349)] : 1);
      p16349.weaponMeshes[p16349.loadoutIndex].visible = !this.isWeaponHidden(p16349, p16349.loadoutIndex) && !p16350;
      if (RENDER.aimRecticle.custom) {
        aimRecticle.style.opacity = (p16350 ? 1 : 0) * RENDER.aimRecticle.opacMlt;
      } else {
        RENDER.aimRecticle.opacity = p16350 ? 1 : 0;
      }
    }
    var v13065 = (p16349.weapon.attach != null || p16349.currentSkin.attachBypass) && !p16349.currentSkin.noAttach && game.attach[p16349.attachIndex] ? game.attach[p16349.attachIndex] : null;
    if (game.controls.camType.isNormal && v13065) {
      if (RENDER.aimDot.custom) {
        aimDot.style.opacity = p16350 ? 1 : 0;
        aimDot.style.display = RENDER.aimDot.display ? "" : "none";
      } else {
        RENDER.aimDot.opacity = p16350 ? 1 : 0;
      }
    }
    if (game.controls.camType.isNormal && p16349.weaponMeshes && p16349.weaponMeshes[p16349.loadoutIndex] && RENDER.hideADS[RENDER.getPlayerWeaponId(p16349)]) {
      if (p16350) {
        p16349.weaponMeshes[p16349.loadoutIndex].visible = false;
      } else {
        p16349.weaponMeshes[p16349.loadoutIndex].visible = !this.isWeaponHidden(p16349, p16349.loadoutIndex);
      }
    }
  };
  this.updateAim = function (p16351, p16352) {
    var v13066 = p16351 && (p16351.weapon.attach != null || p16351.currentSkin.attachBypass) && !p16351.currentSkin.noAttach && game.attach[p16351.attachIndex] ? game.attach[p16351.attachIndex] : null;
    var v13067 = p16351.weapon.zoom;
    if (v13066) {
      v13067 *= v13066.zoomMlt || 1;
    }
    RENDER.zoom(1 + (v13067 - 1) * p16352 * RENDER.adsFov[RENDER.getPlayerWeaponId(p16351)]);
  };
  this.isWeaponHidden = function (p16353, p16354) {
    var v13068 = p16353.loadout[p16354];
    if (game.weaponConfig[v13068].melee && game.hideWeapon[2]) {
      return true;
    }
    return !!game.weaponConfig[v13068].secondary && !!game.hideWeapon[1] || !game.weaponConfig[v13068].melee && !game.weaponConfig[v13068].secondary && !!game.hideWeapon[0];
  };
  this.cantShoot = function (p16355) {
    var v13069 = game.mode && game.mode.finiteAmmo && !p16355.isBot;
    if (!p16355.cantShootTimer && p16355.ammos[p16355.loadoutIndex] <= 0 && (game.mode && game.mode.noReloads || v13069 && p16355.reserveAmmos[p16355.loadoutIndex] <= 0)) {
      if (SOUND) {
        SOUND.play("gclick_0", 0.65);
      }
      p16355.cantShootTimer = p16355.weapon.rate || 0;
    }
  };
  this.reload = function (p16356) {
    var v13070 = game.mode && game.mode.ammoLimit != null ? game.mode.ammoLimit : p16356.weapon.ammo;
    var v13071 = game.mode && game.mode.finiteAmmo && !p16356.isBot;
    var v13072 = p16356.weapon.noReload && !v13071;
    if (!p16356.reloadTimer && p16356.ammos[p16356.loadoutIndex] < v13070 && !v13072 && (!v13071 || v13071 && p16356.reserveAmmos[p16356.loadoutIndex] > 0)) {
      var v13073 = this.getReloadSnd(p16356, 1);
      if (SOUND) {
        SOUND.play(v13073, 0.25);
      }
      p16356.reloadTimer = p16356.weapon.reload * (game.config.reSpd || 1) * p16356.attributes.reload * (p16356.perks.includes(2) ? 0.5 : 1) * (p16356.isKranked ? game.mode.bonuses.reload : 1) * (game.mode && game.mode.reloadMlt != null ? game.mode.reloadMlt : 1);
      p16356.burstCount = 0;
      if (p16356.isYou) {
        this.cancelInspect(p16356);
        if (RENDER) {
          ammoHolder.style.backgroundSize = "100%";
        }
      }
    }
  };
  this.reloadUIAnim = function (p16357) {
    if (RENDER && p16357.isYou) {
      ammoHolder.style.backgroundSize = Math.max(p16357.reloadTimer / (p16357.weapon.reload * (game.config.reSpd || 1) * p16357.attributes.reload * (p16357.perks.includes(2) ? 0.5 : 1) * (p16357.isKranked ? game.mode.bonuses.reload : 1) * (game.mode && game.mode.reloadMlt != null ? game.mode.reloadMlt : 1)) * 100, 0).round() + "%  100%";
    }
  };
  this.endReload = function (p16358) {
    var v13074 = this.getReloadSnd(p16358, "2" + (p16358.weapon.custReload || ""));
    if (SOUND) {
      SOUND.play(v13074, 0.25);
    }
  };
  this.resetReloadUIAnim = function () {
    if (RENDER) {
      ammoHolder.style.backgroundSize = "0%";
    }
  };
  this.resetAim = function () {
    RENDER.zoom(1);
    RENDER.aimRecticle.opacity = 0;
    RENDER.aimDot.opacity = 0;
    aimRecticle.style.opacity = 0;
    aimDot.style.opacity = 0;
  };
  this.updatePlayerAmmo = function (p16359) {
    if (p16359.isYou) {
      if (ammoHolder.style.display != "inline-block") {
        ammoHolder.style.display = "inline-block";
      }
      var v13075 = !game.mode || !game.mode.noReloads;
      if (ammoVal.firstChild) {
        ammoVal.firstChild.nodeValue = p16359.ammos[p16359.loadoutIndex] || (p16359.weapon.melee ? "-" : 0);
      } else {
        ammoVal.textContent = p16359.ammos[p16359.loadoutIndex] || (p16359.weapon.melee ? "-" : 0);
      }
      var v13076 = v13075 ? "| " + (game.mode && game.mode.ammoLimit != null ? "-" : game.mode && game.mode.finiteAmmo && !p16359.isBot ? p16359.reserveAmmos[p16359.loadoutIndex] || "-" : p16359.weapon.ammo || "-") : "";
      if (ammoMax.firstChild) {
        ammoMax.firstChild.nodeValue = v13076;
      } else {
        ammoMax.textContent = v13076;
      }
      var v13077 = game.mode && game.mode.finiteAmmo && !p16359.isBot;
      var v13078 = game.players.getWeapon(p16359, p16359.loadoutIndex);
      var v13079 = v13078 && v13078.ammo;
      if (v13079 && p16359.ammos[p16359.loadoutIndex] <= 0 && game.mode && game.mode.ammoLimit == null && (!v13077 || v13077 && p16359.reserveAmmos[p16359.loadoutIndex] > 0)) {
        if (reloadMsg.style.display != "block" && v13075) {
          reloadMsg.style.display = "block";
        }
      } else if (reloadMsg.style.display != "none") {
        reloadMsg.style.display = "none";
      }
    }
  };
  this.updatePlayerFov = function (p16360) {
    if (p16360.isYou) {
      window.updateFov(0, undefined, RENDER.getPlayerWeaponId(p16360) - 1);
      window.updateFov(1, undefined, RENDER.getPlayerWeaponId(p16360) - 1);
    }
  };
  this.wInspect = function (p16361) {
    if (p16361.inspecting) {
      this.cancelInspect(p16361);
    } else if (!p16361.weapon.nInsp && !p16361.inspecting && p16361.aimVal == 1 && !p16361.reloadTimer && (!p16361.weapon.melee || p16361.canThrow)) {
      p16361.inspecting = true;
      var v13080 = p16361.weapon.inspAnim;
      if (p16361.weapon.melee && game.store.skins[p16361.meleeIndex]) {
        if (game.store.skins[p16361.meleeIndex].inspS) {
          SOUND.play(game.store.skins[p16361.meleeIndex].inspS, 0.03, false, 1);
        }
        if (game.store.skins[p16361.meleeIndex].flipAnim) {
          SOUND.play("melee_equip", 0.03, false, 1.7);
          if (v13080) {
            v13080.wpSp = Math.PI * 4;
          }
        } else if (v13080) {
          v13080.wpSp = 0;
        }
      } else if (v13080) {
        v13080.wpSp = 0;
      }
      if (v13080) {
        var v13081 = p16361.weapon.melee ? p16361.currentMelee : p16361.currentSkin;
        if (RENDER && v13081 && v13081.inspectAnim && p16361.weaponGeos[p16361.loadoutIndex].playAllClips) {
          p16361.weaponGeos[p16361.loadoutIndex].playAllClips(1);
        }
        p16361.inspectTween = v13081 && v13081.insAnim ? v13081.insAnim(TWEEN, v13080) : new TWEEN.Tween(p16361.inspectAn).to(v13080, 400).easing(TWEEN.Easing.Exponential.Out).start();
      }
    }
  };
  this.cancelInspect = function (p16362) {
    if (p16362.inspectTween) {
      p16362.inspectTween.stop();
    }
    p16362.inspecting = false;
    p16362.inspectX = 0;
    p16362.inspectAn = {
      arZ: 0,
      arX: 0,
      arY: 0,
      apZ: 0,
      apX: 0,
      apY: 0,
      wpZ: 0,
      wpY: 0,
      wrY: 0,
      wpSp: 0
    };
    var v13082 = p16362.weapon.melee ? p16362.currentMelee : p16362.currentSkin;
    if (RENDER && v13082 && v13082.inspectAnim && p16362.weaponGeos[p16362.loadoutIndex].stopAllClips) {
      p16362.weaponGeos[p16362.loadoutIndex].stopAllClips();
    }
  };
  this.sprayPosition = function (p16363, p16364, p16365, p16366, p16367, p16368, p16369) {
    if (p16364) {
      var v13083 = game.store.skins[p16365];
      var vLN02335 = 0;
      var vLN02336 = 0;
      var vLN02337 = 0;
      var v13084 = Math.round(p16363.xDire / (Math.PI / 2)) * 90;
      if (p16367 >= p16364.y + p16364.height) {
        vLN02336 = -90;
        vLN02337 = v13084;
      } else if (p16367 <= p16364.y - p16364.height) {
        vLN02336 = 90;
        vLN02337 = -v13084;
      } else if (p16366 <= p16364.x - p16364.width) {
        vLN02335 = -90;
      } else if (p16366 >= p16364.x + p16364.width) {
        vLN02335 = 90;
      } else if (p16368 <= p16364.z - p16364.length) {
        vLN02335 = 180;
      }
      var v13085 = config.sprayScale * (v13083.sclW || 1) / 2;
      var v13086 = config.sprayScale * (v13083.sclH || 1) / 2;
      if (vLN02336) {
        if (p16364.width < v13085 || p16364.length < v13086) {
          return;
        }
        if (p16368 - v13086 < p16364.z - p16364.length) {
          p16368 = p16364.z - p16364.length + v13086;
        } else if (p16368 + v13086 > p16364.z + p16364.length) {
          p16368 = p16364.z + p16364.length - v13086;
        }
        if (p16366 - v13085 < p16364.x - p16364.width) {
          p16366 = p16364.x - p16364.width + v13085;
        } else if (p16366 + v13085 > p16364.x + p16364.width) {
          p16366 = p16364.x + p16364.width - v13085;
        }
      } else {
        if (p16364.height < v13086) {
          return;
        }
        if (vLN02335 == 90 || vLN02335 == -90) {
          if (p16364.length < v13085) {
            return;
          }
          if (p16368 - v13085 < p16364.z - p16364.length) {
            p16368 = p16364.z - p16364.length + v13085;
          } else if (p16368 + v13085 > p16364.z + p16364.length) {
            p16368 = p16364.z + p16364.length - v13085;
          }
        } else {
          if (p16364.width < v13085) {
            return;
          }
          if (p16366 - v13085 < p16364.x - p16364.width) {
            p16366 = p16364.x - p16364.width + v13085;
          } else if (p16366 + v13085 > p16364.x + p16364.width) {
            p16366 = p16364.x + p16364.width - v13085;
          }
        }
        if (p16367 + v13086 > p16364.y + p16364.height) {
          p16367 = p16364.y + p16364.height - v13086;
        }
      }
      p16363.lastSpray = game.now;
      var v13087 = "spray" + (game.store.skins[p16369] && game.store.skins[p16369].spraySnd ? "_" + game.store.skins[p16369].spraySnd : "");
      if (game.playSound) {
        game.playSound(config.networkSounds.indexOf(v13087), 0.4, p16363.sid, p16366, p16367, p16368, true);
      }
      var v13088 = game.isSandbox ? config.maxSpraysF : config.maxSprays;
      if (p16363.account && p16363.account.premiumT > 0) {
        v13088 = p16363.account.featured ? config.maxSpraysF : config.maxSpraysP;
      }
      if (p16363.unlimitedSprays) {
        v13088 = 10000;
      }
      if (p16363.spraysPlaced >= v13088) {
        p16363.spraysPlaced = 0;
      }
      var v13089 = p16363.sid + "_" + p16363.spraysPlaced;
      p16363.spraysPlaced++;
      if (this.isServer) {
        game.broadcast("sp", v13089, v13083.index, p16366.round(2), p16367.round(2), p16368.round(2), vLN02335, vLN02336, vLN02337, p16369);
        game.incStat("spry", p16363);
        game.challenges.update(game, "spry", 1, {
          item: v13083.index
        }, p16363);
      }
    }
  };
  this.spray = function (p16370, p16371) {
    if (game.now - p16370.lastSpray >= config.sprayTimer) {
      if (game.isSandbox || p16370.account && p16370.account.premiumT > 0) {
        var v13090 = game.store.skins[p16371] && game.store.skins[p16371].type == itemTypes.SPRAY && (game.store.skins[p16371].free || game.isSandbox);
        if (!p16370.account || p16371 == null || p16371 == null) {
          p16371 = v13090 ? p16371 : 2482;
        } else {
          var v13091 = UTILS.canUseSkin(p16371, game.store.skins, p16370.account, p16370.classIndex, undefined, 4);
          p16371 = v13090 || v13091 ? p16371 : 2482;
        }
      } else {
        p16371 = 2482;
        if (game.store.skins[p16370.sprayIndex] && game.store.skins[p16370.sprayIndex].type == itemTypes.SPRAY) {
          p16371 = p16370.sprayIndex;
        }
      }
      vA714.length = 0;
      var vLN02338 = 0;
      var v13092 = 1 / (config.sprayRange * Math.sin(p16370.xDire + Math.PI) * Math.cos(p16370.yDire));
      var v13093 = 1 / (config.sprayRange * Math.cos(p16370.xDire + Math.PI) * Math.cos(p16370.yDire));
      var v13094 = 1 / (config.sprayRange * Math.sin(p16370.yDire));
      for (var vLN02339 = 0; vLN02339 < game.map.manager.objects.length; ++vLN02339) {
        v12909 = game.map.manager.objects[vLN02339];
        if (!v12909.noShoot && !v12909.noVis && !!v12909.active) {
          vLN02338 = UTILS.lineInRect(p16370.x, p16370.z, p16370.y + p16370.height - config.cameraHeight, v13092, v13093, v13094, v12909.x - v12909.width, v12909.z - v12909.length, v12909.y - v12909.height, v12909.x + v12909.width, v12909.z + v12909.length, v12909.y + v12909.height);
          if (vLN02338 && vLN02338 <= 1) {
            vA714.push({
              obj: v12909,
              dst: vLN02338
            });
          }
        }
      }
      if (vA714.length && (vA714.sort(UTILS.orderByDst), v12909 = vA714[0].obj, v12909)) {
        var v13095 = config.sprayRange * vA714[0].dst - 0.1;
        var v13096 = p16370.y + p16370.height - config.cameraHeight + v13095 * Math.sin(p16370.yDire);
        var v13097 = p16370.x + v13095 * Math.sin(p16370.xDire + Math.PI) * Math.cos(p16370.yDire);
        var v13098 = p16370.z + v13095 * Math.cos(p16370.xDire + Math.PI) * Math.cos(p16370.yDire);
        this.sprayPosition(p16370, v12909, p16371, v13097, v13096, v13098);
      }
    }
  };
  this.build = function (p16372, p16373) {
    if ((!serverIO || !!p16373) && !p16372.selectBuild) {
      var v13099 = p16372.xDire;
      var v13100 = p16372.yDire;
      var v13101 = p16372.y + p16372.height - config.cameraHeight;
      vA714.length = 0;
      var v13102 = 1 / (p16372.weapon.range * Math.sin(v13099 + Math.PI) * Math.cos(v13100));
      var v13103 = 1 / (p16372.weapon.range * Math.cos(v13099 + Math.PI) * Math.cos(v13100));
      var v13104 = 1 / (p16372.weapon.range * Math.sin(v13100));
      var v13105 = game.map.terrain;
      if (v13105) {
        var v13106 = v13105.raycast(p16372.x, -p16372.z, v13101, 1 / v13102, -1 / v13103, 1 / v13104);
        if (v13106) {
          let v13107 = UTILS.getD3D(p16372.x, v13101, p16372.z, v13106.x, v13106.z, -v13106.y);
          vA714.push({
            terrain: true,
            dst: v13107 / p16372.weapon.range
          });
        }
      }
      var v13108 = null;
      for (var v13109 = game.map.manager.objects, vLN02343 = 0; vLN02343 < v13109.length; ++vLN02343) {
        v12909 = v13109[vLN02343];
        if (v12909.active && !v12909.noShoot) {
          v13108 = null;
          if (v12909.buildInd != null && game.BUILD_OBJS[v12909.buildInd].snapFunc) {
            v13108 = game.BUILD_OBJS[v12909.buildInd].snapFunc(p16372.x, p16372.z, v13101, v13102, v13103, v13104, p16372.buildIndex, v12909);
          }
          if (v13108 == null) {
            v13108 = UTILS.lineInRect(p16372.x, p16372.z, v13101, v13102, v13103, v13104, v12909.x - v12909.width, v12909.z - v12909.length, v12909.y - v12909.height, v12909.x + v12909.width, v12909.z + v12909.length, v12909.y + v12909.height);
          }
          if (v13108 && v13108 <= 1) {
            vA714.push({
              obj: v12909,
              dst: v13108
            });
          }
        }
      }
      if (vA714.length) {
        vA714.sort(UTILS.orderByDst);
        v12909 = vA714[0].obj || null;
        var v13110 = v12909 ? game.BUILD_OBJS[v12909.buildInd] || null : null;
        var v13111 = game.BUILD_OBJS[p16372.buildIndex];
        var v13121 = !config.isProd || p16372.score >= v13111.cost;
        var v13113 = p16372.weapon.range * vA714[0].dst - 0.0001;
        var v13118 = p16372.x + v13113 * Math.sin(v13099 + Math.PI) * Math.cos(v13100);
        var v13119 = v13101 + v13113 * Math.sin(v13100);
        var v13120 = p16372.z + v13113 * Math.cos(v13099 + Math.PI) * Math.cos(v13100);
        var v13117 = null;
        var v13122 = 0;
        if (v12909) {
          if (v13118 <= v12909.x - v12909.width) {
            v13117 = "Left";
          } else if (v13118 >= v12909.x + v12909.width) {
            v13117 = "Right";
          } else if (v13120 <= v12909.z - v12909.length) {
            v13117 = "Front";
          } else if (v13120 >= v12909.z + v12909.length) {
            v13117 = "Back";
          } else if (v13119 >= v12909.y + v12909.height) {
            v13117 = "Top";
          } else if (v13119 <= v12909.y - v12909.height) {
            v13117 = "Bottom";
          }
        }
        v13118 = Math.round(v13118);
        v13119 = Math.round(v13119);
        v13120 = Math.round(v13120);
        if (v12909) {
          if (v13117 && v13110 && v13110.buildSnap) {
            [v13118, v13119, v13120, v13121, v13122] = v13110.buildSnap(v13118, v13119, v13120, v13121, v13117, v12909, p16372.buildIndex);
          } else if (v13111.places == "floor" && v13117 != "Top" && v13117 != "Bottom") {
            v13121 = false;
          } else if (v13111.places == "objs") {
            v13121 = false;
          }
        }
        if (v13111.rotFacing && (!v12909 || !v13110 || !v13110.buildSnap)) {
          var v13123 = Math.PI / 4;
          var v13124 = p16372.xDire.roundToNearest(v13123);
          v13124 = Math.abs(v13124) / v13123;
          v13122 = v13124 != 1 && v13124 != 4 && v13124 != 5 && v13124 != 8;
        }
        var vLN02342 = 0;
        if (v13111.rotDir) {
          if (v13117 == "Left") {
            vLN02342 = 0;
          } else if (v13117 == "Front") {
            vLN02342 = Math.PI / 2;
          } else if (v13117 == "Right") {
            vLN02342 = Math.PI;
          } else if (v13117 == "Back") {
            vLN02342 = -Math.PI / 2;
          }
        }
        var v13125 = v13122 ? v13111.l : v13111.w;
        var v13126 = v13111.h;
        var v13127 = v13122 ? v13111.w : v13111.l;
        if (v13121) {
          for (var vLN02343 = 0; vLN02343 < v13109.length && (v13109[vLN02343].buildInd == null || !v13109[vLN02343].active || !(v13110 && v13110.buildSnap ? v13109[vLN02343].buildInd == p16372.buildIndex && v13109[vLN02343].x == v13118 && v13109[vLN02343].z == v13120 && v13109[vLN02343].y == v13119 + v13111.h / 2 && (v13121 = false) : game.map.manager.collisionC(v13118, v13119, v13120, v13125 / 2, v13126 / 2, v13127 / 2, v13109[vLN02343], -0.01) && (v13121 = false), !v13121)); ++vLN02343) {
            ;
          }
        }
        if (p16373 && v13121) {
          p16372.reloads[p16372.loadoutIndex] = p16372.weapon.rate;
          p16372.didShoot = true;
          p16372.didAct = true;
        }
        if (this.isServer) {
          if (v13121 && game.buildObj(p16372.buildIndex, v13118, v13119, v13120, v13125, v13126, v13127, vLN02342, -1, false, p16372)) {
            this.score(p16372, -v13111.cost);
          }
        } else {
          if (!p16372.buildHelper) {
            p16372.buildHelper = RENDER.addCube(v13118, v13119, v13120, 1, 1, 1, null, {
              src: "default",
              colr: "#55acee",
              opacity: 0.7,
              transparent: true,
              autoMatrix: true,
              noGroup: true,
              noShader: true
            });
            p16372.buildHelperN = RENDER.addCube(v13118, v13119, v13120, 1, 1, 1, null, {
              src: "default",
              colr: "#ee5555",
              opacity: 0.7,
              transparent: true,
              autoMatrix: true,
              noGroup: true,
              noShader: true
            });
          }
          p16372.buildHelper.visible = false;
          p16372.buildHelperN.visible = false;
          var v13128 = p16372["buildHelper" + (v13121 ? "" : "N")];
          v13128.visible = true;
          RENDER.scaleMesh(v13128, v13125 + 0.1, v13126 + 0.1, v13127 + 0.1);
          RENDER.moveMesh(v13128, v13118, v13119 - 0.05, v13120);
        }
      } else if (!serverIO) {
        if (p16372.buildHelper) {
          p16372.buildHelper.visible = false;
          p16372.buildHelperN.visible = false;
        }
      }
    }
  };
  this.debugHitboxes = function (p16374) {};
  this.debugHitbox = function (p16375, p16376, p16377) {
    if (p16375 && p16375.debugMode && serverIO) {
      var v13129 = this.fetchState(p16376, p16375);
      if (v13129) {
        var v13130 = p16376.y + p16376.adjustedHeight - p16377;
        var v13131 = v13130 < config.headScale * p16376.headMlt;
        var v13132 = config.headScale * p16376.headMlt;
        p16375.send("hbdb", p16376.sid, v13129.x, v13129.y, v13129.z, p16376.scale + p16376.hitboxPadW, v13129.ah + p16376.hitboxPadH, p16377, v13131 ? 16498733 : 16711680, v13132 + p16376.hitboxPadH);
      }
    }
  };
  this.melee = function (p16378, p16379) {
    if (!p16378.disableMelee && p16378.config.canMelee) {
      p16379.syncTime = true;
      var v13133 = p16378.weapon.canThrow && p16378.aimVal == 0 && p16378.canThrow;
      p16378.reloads[p16378.loadoutIndex] = p16378.weapon.rate * (game.config.fiRat || 1) * p16378.attributes.fRate * (p16378.perks.includes(1) ? 0.66 : 1) * (p16378.isKranked ? game.mode.bonuses.firerate : 1) * p16378.config.melRate;
      p16378.didShoot = true;
      p16378.didAct = true;
      var v13134 = game.store.skins[p16378.meleeIndex] || {};
      var vLN1166 = 1;
      if (v13133 && game.config.chrgWeps) {
        vLN1166 = Math.min(1, Math.max(0.1, p16378.chargeTime / p16378.throwCharge));
        var v13135 = game && game.mode && game.mode.forceCharge;
        if (v13135) {
          vLN1166 = 1;
        }
      }
      p16378.chargeTime = 0;
      p16378.fullCharge = false;
      this.playClip(p16378, "Melee", 1);
      if (p16378.isYou) {
        if (p16378.isYou && game.controls) {
          if (game.controls.cntrlInput.vibration && game.controls.gamepad.active) {
            game.controls.gamepad.rumble(p16378.weapon.rumbleDur || 200, (p16378.weapon.rumble || 0.5) * game.controls.cntrlInput.vibrationMlt);
          } else if (game.controls.mblInput.vibration && !game.controls.isMobile && "vibrate" in navigator) {
            navigator.vibrate(p16378.weapon.rumbleDur || 200);
          }
        }
        if (p16378.weapon.anim) {
          p16378.weapon.anim(p16378, TWEEN, p16378.canThrow ? v13133 ? 3 : 1 : 2, vLN1166);
        }
        this.cancelInspect(p16378);
        if (p16378.canThrow) {
          SOUND.play("swsh_" + (v13134.cSwing ? v13134.id || 0 : 0) + "_" + UTILS.randInt(0, 1), 0.1, false);
        } else {
          SOUND.play("swsh_def_" + UTILS.randInt(0, 1), 0.1, false);
        }
      }
      var v13136 = p16378.xDire;
      var v13137 = p16378.yDire;
      var v13138 = p16378.y + p16378.height - config.cameraHeight;
      if (v13133) {
        if (serverIO) {
          game.incStat("s", p16378);
        }
        p16378.canThrow = !!p16378.unlimitedAmmo;
        p16378.lastThrowTime = Date.now();
        p16378.shotCntP++;
        var v13139 = game.projectiles.stored[0];
        var v13140 = p16378.meleeIndex;
        var vO419 = {
          wId: 12,
          w: p16378.upgrades[p16378.loadoutIndex] ? game.upgradeWeapons[12] : game.weaponConfig[12]
        };
        var vO420 = {
          s: v13140,
          d: vLN1166,
          v: Math.max(0.3, vLN1166)
        };
        if (game.store.skins[v13140] && game.store.skins[v13140].explode) {
          vO420.ex = 0;
        }
        var vLN2482 = 2482;
        if (game.store.skins[p16378.sprayIndex] && game.store.skins[p16378.sprayIndex].type == itemTypes.SPRAY) {
          vLN2482 = p16378.sprayIndex;
        }
        if (game.store.skins[v13140] && game.store.skins[v13140].sprayI) {
          vO420.spr = vLN2482;
        }
        if (this.isServer) {
          game.projectiles.init(p16378.x, v13138, p16378.z, v13136, v13137, v13139, p16378, vO419, true, vO420);
        } else {
          PARTICLES.physObj(p16378.x, v13138, p16378.z, v13136, v13137, 3000, false, null, null, v13139, -1, p16378.shotCntP, vO420);
        }
        if (p16378.isYou) {
          p16378.lastThrow = p16378.canThrow;
          var v13141 = document.getElementById("weapIconMel");
          if (v13141) {
            v13141.src = UTILS.assetsUrl("/textures/weapons/icon_0.png");
          }
        }
      } else {
        vA714.length = 0;
        var vLN02344 = 0;
        var v13142 = p16378.weapon.range * Math.sin(v13136 + Math.PI) * Math.cos(v13137);
        var v13143 = p16378.weapon.range * Math.cos(v13136 + Math.PI) * Math.cos(v13137);
        var v13144 = p16378.weapon.range * Math.sin(v13137);
        var v13145 = v12911.set(v13142, v13144, v13143).normalize();
        v13142 = 1 / v13142;
        v13143 = 1 / v13143;
        v13144 = 1 / v13144;
        v12912.set(p16378.x, v13138, p16378.z);
        game.raycaster.set(v12912, v13145);
        if (this.isServer) {
          for (var vLN02348 = 0; vLN02348 < game.map.manager.objects.length; ++vLN02348) {
            v12909 = game.map.manager.objects[vLN02348];
            if (v12909.active && !v12909.noShoot) {
              vLN02344 = UTILS.lineInRect(p16378.x, p16378.z, v13138, v13142, v13143, v13144, v12909.x - v12909.width, v12909.z - v12909.length, v12909.y - v12909.height, v12909.x + v12909.width, v12909.z + v12909.length, v12909.y + v12909.height);
              if (vLN02344 && vLN02344 <= 1) {
                vA714.push({
                  obj: v12909,
                  dst: vLN02344
                });
              }
            }
          }
        }
        if (this.isServer) {
          for (var vLN02348 = 0; vLN02348 < this.list.length; ++vLN02348) {
            if (this.list[vLN02348].active && !this.list[vLN02348].noPVP && p16378 != this.list[vLN02348] && !p16378.noPVP && (p16378.forcePVP && this.list[vLN02348].forcePVP || !p16378.forcePVP && !this.list[vLN02348].forcePVP) && (!p16378.team || p16378.team != this.list[vLN02348].team || game.mode.dmgTeam || game.config.frFire) && (v12909 = this.fetchState(this.list[vLN02348], p16378), v12909)) {
              if (!this.list[vLN02348].newHitboxes) {
                vLN02344 = UTILS.lineInRect(p16378.x, p16378.z, v13138, v13142, v13143, v13144, v12909.x - this.list[vLN02348].scale - this.list[vLN02348].hitboxPadW, v12909.z - this.list[vLN02348].scale - this.list[vLN02348].hitboxPadW, v12909.y, v12909.x + this.list[vLN02348].scale + this.list[vLN02348].hitboxPadW, v12909.z + this.list[vLN02348].scale + this.list[vLN02348].hitboxPadW, v12909.y + v12909.ah + this.list[vLN02348].hitboxPadH);
                if (vLN02344 && vLN02344 <= 1) {
                  vA714.push({
                    player: true,
                    obj: this.list[vLN02348],
                    dst: vLN02344
                  });
                }
              } else {
                vLN02344 = UTILS.lineInRect(p16378.x, p16378.z, v13138, v13142, v13143, v13144, v12909.x - config.hitBoxPad, v12909.z - config.hitBoxPad, v12909.y - config.hitBoxPad, v12909.x + config.hitBoxPad, v12909.z + config.hitBoxPad, v12909.y + v12909.h + config.hitBoxPad);
                if (vLN02344 && vLN02344 <= 1) {
                  this.updateMshServ(this.list[vLN02348], v12909.x, v12909.y, v12909.z, v12909.xD, v12909.yD, v12909.sV, v12909.cV);
                  var v13146 = game.raycaster.intersectObjects(this.list[vLN02348].objInstances.children, true);
                  if (v13146.length) {
                    vA714.push({
                      player: true,
                      obj: this.list[vLN02348],
                      dst: v13146[0].distance / p16378.weapon.range
                    });
                  }
                }
              }
            }
          }
        }
        if (serverIO) {
          for (var vLN02348 = 0; vLN02348 < game.AI.ais.length; ++vLN02348) {
            if (game.AI.ais[vLN02348].active && (!p16378.team || p16378.team != game.AI.ais[vLN02348].team || game.mode.dmgTeam || game.config.frFire)) {
              v12909 = game.AI.ais[vLN02348].fetchState(p16378);
              if (!v12909) {
                continue;
              }
              vLN02344 = UTILS.lineInRect(p16378.x, p16378.z, v13138, v13142, v13143, v13144, v12909.x - game.AI.ais[vLN02348].scale, v12909.z - game.AI.ais[vLN02348].scale, v12909.y, v12909.x + game.AI.ais[vLN02348].scale, v12909.z + game.AI.ais[vLN02348].scale, v12909.y + game.AI.ais[vLN02348].height * 2);
              if (vLN02344 && vLN02344 <= 1) {
                vA714.push({
                  ai: true,
                  obj: game.AI.ais[vLN02348],
                  dst: vLN02344
                });
              }
            }
          }
        }
        var v13147 = p16378.weapon.range * p16378.rangeMlt;
        if (vA714.length) {
          vA714.sort(UTILS.orderByDst);
          var v13148 = +p16378.weapon.dmg;
          var v13149 = +p16378.weapon.dmg;
          if (!p16378.canThrow) {
            v13148 = 35;
          }
          if (p16378.smite) {
            v13148 = 10000;
          }
          v13148 *= p16378.attributes.dmg;
          v13148 *= p16378.dmgMlt;
          if (!UTILS.isNumber(v13148) || !UTILS.isNumber(v13149)) {
            return;
          }
          for (var vLN02348 = 0; vLN02348 < vA714.length; ++vLN02348) {
            v12909 = vA714[vLN02348];
            v13147 = p16378.weapon.range * p16378.rangeMlt * v12909.dst;
            var v13150 = v13138 + v13147 * Math.sin(v13137);
            if (this.isServer) {
              if (v12909.obj && v12909.ai) {
                if ((!game.waitTimers || game.waitTimers[0] && game.waitTimers[0].contTime) && !v12909.obj.invincible) {
                  v12909.obj.changeHealth(-v13148, p16378);
                  if (v12909.obj.killScore && game.mode && game.mode.pointsPerHit) {
                    this.score(p16378, Math.ceil(v13148 * game.mode.pointsPerHit), 1);
                  }
                  if (!v12909.obj.active && v12909.obj.killScore) {
                    this.score(p16378, v12909.obj.killScore, 1);
                  }
                  game.showHit(p16378, v12909.obj, Math.round(v13148), false, true);
                }
              } else if ((!game.waitTimers || game.waitTimers[0] && game.waitTimers[0].contTime) && v12909.obj && v13148 > 0 && v12909.obj.health && !v12909.player) {
                for (var vLN02349 = 0; vLN02349 < this.list.length; ++vLN02349) {
                  if (p16378 && p16378 == this.list[vLN02349] || this.list[vLN02349].specStream == p16378.sid) {
                    this.list[vLN02349].send("4");
                  }
                }
                v12909.obj.health -= v13148;
                if (v12909.obj.health <= 0) {
                  v12909.obj.active = false;
                  v12909.obj.health = 0;
                  v12909.obj.destroyedBy = p16378;
                  v12909.obj.destroyed = true;
                  game.map.manager.destObjs.push(v12909.obj.uid);
                  game.broadcast("do", v12909.obj.uid);
                  if (v12909.obj && v12909.obj.onDestroy) {
                    game.onTrigger(p16378, v12909.obj);
                  }
                }
              }
              if (serverIO && game.mode.teamOptions && game.mode.teamOptions[p16378.team - 1] == "Seekers" && !v12909.player && v12909.obj && v12909.obj.propID && this.changeHealth(p16378, null, 10)) {
                this.kill(p16378);
              }
              if (v12909.obj && (v12909.obj.onMelee || v12909.obj.onDamage || !p16378.canThrow && v12909.obj.onPunch)) {
                game.onTrigger(p16378, v12909.obj);
              }
              if (v12909.obj && v12909.obj.isEvent) {
                game.foundEventItem(p16378, v12909.obj);
              }
              if (v12909.obj && v12909.obj.mysteryBox && v12909.obj.purchasedBy == p16378.id && v12909.obj.state == 2 && v12909.obj.purchasedBy == p16378.id && v12909.obj.pendingWeapon != -1) {
                if (!game.fireSaleTimer) {
                  p16378.sharedBoxes++;
                  if (p16378.sharedBoxes == 5) {
                    p16378.sharingIsCaring = true;
                    p16378.send("sic", true);
                  }
                }
                v12909.obj.purchasedBy = -1;
                if (game.playSound) {
                  game.playSound(config.networkSounds.indexOf("bhop_reset"), 1.5, p16378.sid, p16378.x, p16378.y, p16378.z, true);
                }
                game.syncMysteryBox(v12909.obj);
              }
              if (v12909.player || v12909.obj && v12909.obj.dummy) {
                game.players.debugHitbox(p16378, v12909.obj, v13150);
                if (game.mode && game.mode.onMelee && game.mode.onMelee(game, p16378, v12909.obj, serverIO)) {
                  v13148 = v12909.obj.health || v13148;
                }
                if (this.changeHealth(v12909.obj, p16378, v13148, undefined, undefined, {
                  wep: 12
                })) {
                  if (p16378) {
                    if (p16378.canThrow) {
                      p16378.melees++;
                      if (serverIO) {
                        game.incStat("mk", p16378);
                        game.challenges.update(game, "mk", 1, {
                          wep: 12
                        }, p16378);
                      }
                    } else if (!p16378.canThrow) {
                      p16378.fistKills++;
                      if (serverIO) {
                        game.incStat("fk", p16378);
                        game.challenges.update(game, "fk", 1, {
                          wep: 12
                        }, p16378);
                      }
                    }
                  }
                  this.kill(v12909.obj, p16378, {
                    wId: p16378.weapon.id,
                    fs: !p16378.canThrow
                  });
                }
                v13148 -= p16378.weapon.pierce == null ? v13148 : v13149 * config.materialDens.flesh * p16378.weapon.pierce;
              } else {
                break;
              }
              if (v13148 <= 0) {
                break;
              }
            } else {
              break;
            }
          }
        }
      }
    }
  };
  this.endGrapple = function (p16380) {
    if (p16380) {
      p16380.grapple = null;
    }
  };
  this.tryGrapple = function (p16381, p16382, p16383, p16384) {
    if (p16383 && p16381 && p16381.active) {
      p16381.didShoot = true;
      p16381.chargeTime = 0;
      p16381.fullCharge = false;
      p16381.didAct = true;
      p16381.grapple = null;
      p16381.reloads[p16381.loadoutIndex] = p16381.weapon.rate;
      if (game.playSound) {
        var v13151 = config.networkSounds.indexOf(p16381.weapon.sound);
        game.playSound(v13151, 0.85, p16381.sid, p16381.x, p16381.y, p16381.z, false, UTILS.randFloat(0.9, 1.1), null, p16381.weapon.refDist, p16381.weapon.rollOff);
      }
      p16381.recoilForce += p16381.weapon.recoil;
      var v13152 = !p16381.config || p16381.config.mdl !== 2;
      if (p16381.renderYou && v13152) {
        if (p16381.recoilTween) {
          p16381.recoilTween.stop();
        }
        var vLN1502 = 150;
        p16381.recoilTween = new TWEEN.Tween(p16381).to(p16381.weapon.recoilAnim || {}, vLN1502 * 0.15).easing(TWEEN.Easing.Linear.None).onComplete(function () {
          p16381.recoilTween = new TWEEN.Tween(p16381).to({
            recoilTweenY: 0,
            recoilTweenR: 0,
            recoilTweenYM: 0,
            recoilTweenZ: 0
          }, vLN1502 * 0.95).easing(TWEEN.Easing.Back.Out).start();
        }).start();
        this.cancelInspect(p16381);
      }
      var v13153 = p16381.xDire;
      var v13154 = p16381.yDire;
      var v13155 = p16381.y + p16381.height - config.cameraHeight;
      vA714.length = 0;
      var v13156 = 1 / (p16382 * Math.sin(v13153 + Math.PI) * Math.cos(v13154));
      var v13157 = 1 / (p16382 * Math.cos(v13153 + Math.PI) * Math.cos(v13154));
      var v13158 = 1 / (p16382 * Math.sin(v13154));
      var vLN02350 = 0;
      for (var vLN02351 = 0; vLN02351 < game.map.manager.objects.length; ++vLN02351) {
        v12909 = game.map.manager.objects[vLN02351];
        if (!!v12909.active && !v12909.noShoot && !v12909.noGrapple) {
          vLN02350 = UTILS.lineInRect(p16381.x, p16381.z, v13155, v13156, v13157, v13158, v12909.x - v12909.width, v12909.z - v12909.length, v12909.y - v12909.height, v12909.x + v12909.width, v12909.z + v12909.length, v12909.y + v12909.height);
          if (vLN02350 && vLN02350 <= 1) {
            vA714.push({
              obj: v12909,
              dst: vLN02350
            });
          }
        }
      }
      if (vA714.length) {
        vA714.sort(UTILS.orderByDst);
        var v13159 = p16382 * vA714[0].dst;
        var v13160 = p16381.x + v13159 * Math.sin(v13153 + Math.PI) * Math.cos(v13154);
        var v13161 = v13155 + v13159 * Math.sin(v13154);
        var v13162 = p16381.z + v13159 * Math.cos(v13153 + Math.PI) * Math.cos(v13154);
        var v13163 = v13159 + p16381.height - config.cameraHeight + 0.001;
        p16381.grapple = {
          x: v13160.round(1),
          y: v13161.round(1),
          z: v13162.round(1),
          range: v13163
        };
        if (!serverIO) {
          p16384.grapObj = {
            x: v13160.round(1),
            y: v13161.round(1),
            z: v13162.round(1),
            r: v13163
          };
        }
        if (PARTICLES && p16381.isYou) {
          PARTICLES.addRope(p16381, v13160, v13161, v13162);
        }
      }
    }
  };
  this.tryDeployable = function (p16385) {
    if (p16385 && p16385.active) {
      var v13164 = p16385.weapon.deployRang;
      if (p16385.deployGun != null) {
        v13164 = (v13164 || 250) * 10;
      }
      var v13165 = p16385.xDire;
      var v13166 = p16385.yDire;
      var v13167 = p16385.y + p16385.height - config.cameraHeight;
      vA714.length = 0;
      var v13168 = 1 / (v13164 * Math.sin(v13165 + Math.PI) * Math.cos(v13166));
      var v13169 = 1 / (v13164 * Math.cos(v13165 + Math.PI) * Math.cos(v13166));
      var v13170 = 1 / (v13164 * Math.sin(v13166));
      var vLN02352 = 0;
      for (var vLN02353 = 0; vLN02353 < game.map.manager.objects.length; ++vLN02353) {
        v12909 = game.map.manager.objects[vLN02353];
        if (v12909.active && !v12909.noShoot) {
          vLN02352 = UTILS.lineInRect(p16385.x, p16385.z, v13167, v13168, v13169, v13170, v12909.x - v12909.width, v12909.z - v12909.length, v12909.y - v12909.height, v12909.x + v12909.width, v12909.z + v12909.length, v12909.y + v12909.height);
          if (vLN02352 && vLN02352 <= 1) {
            vA714.push({
              obj: v12909,
              dst: vLN02352
            });
          }
        }
      }
      if (vA714.length) {
        vA714.sort(UTILS.orderByDst);
        var v13171 = v13164 * vA714[0].dst;
        var v13172 = p16385.x + v13171 * Math.sin(v13165 + Math.PI) * Math.cos(v13166);
        var v13173 = v13167 + v13171 * Math.sin(v13166);
        var v13174 = p16385.z + v13171 * Math.cos(v13165 + Math.PI) * Math.cos(v13166);
        v13172 = v13172.round(1);
        v13173 = v13173.round(1);
        v13174 = v13174.round(1);
        var v13175 = vA714[0].obj;
        var vLN02354 = 0;
        var vLN02355 = 0;
        if (v13173 >= v13175.y + v13175.height) {
          vLN02355 = 0;
        } else if (v13173 <= v13175.y - v13175.height) {
          vLN02355 = 180;
        } else if (v13172 <= v13175.x - v13175.width) {
          vLN02355 = 90;
        } else if (v13172 >= v13175.x + v13175.width) {
          vLN02355 = -90;
        } else if (v13174 <= v13175.z - v13175.length) {
          vLN02354 = -90;
        } else if (v13174 >= v13175.z + v13175.length) {
          vLN02354 = 90;
        }
        game.dropSpawnable(p16385.deployGun == null ? p16385.weapon.deployable : p16385.deployGun, {
          x: v13172,
          y: v13173,
          z: v13174
        }, {
          xD: vLN02354,
          zD: vLN02355
        });
      }
      if (p16385.deployGun == null && p16385.ammos[p16385.loadoutIndex] <= 0) {
        game.players.removeWeapon(p16385, 23);
      }
    }
  };
  var vA714 = [];
  this.shoot = function (p16386, p16387, p16388, p16389, p16390, p16391) {
    if (!p16386.disableShooting && p16386.config.canShoot) {
      var v13176 = false;
      p16387.syncTime = true;
      if (serverIO) {
        game.incStat("s", p16386);
      }
      var v13177 = !p16386.unlimitedAmmo;
      if (p16386.weapon && p16386.weapon.fullChrgSht && !p16391) {
        v13177 = false;
      }
      if (v13177) {
        p16386.ammos[p16386.loadoutIndex]--;
      }
      if (p16386.ammos[p16386.loadoutIndex] < 0) {
        p16386.ammos[p16386.loadoutIndex] = 0;
      }
      p16386.didAct = true;
      var v13178 = game && game.mode && game.mode.forceCharge;
      var vLN1167 = 1;
      if (!p16386.weapon || !p16386.weapon.bypassChrg) {
        if (p16386.weapon && p16386.weapon.chrgTime && game.config.chrgWeps) {
          vLN1167 = Math.min(1, p16386.chargeTime / p16386.weapon.chrgTime);
          if (v13178) {
            vLN1167 = 1;
          }
        }
        p16386.didShoot = true;
        p16386.chargeTime = 0;
        p16386.fullCharge = false;
      }
      var vLN1168 = 1;
      if (p16386.weapon && p16386.weapon.rateChrg) {
        vLN1168 = 1 - Math.min(1, p16386.chargeTime / p16386.weapon.chrgTime);
        if (v13178) {
          vLN1168 = 0;
        }
        vLN1168 = Math.max(0.7, vLN1168 * 1.5);
      }
      if (p16391) {
        p16386.fullCharge = false;
        p16386.chargeTime = 0;
        vLN1167 = p16386.weapon.fullChrgMlt;
      } else {
        p16386.didShoot = true;
      }
      if (p16386.burstCount) {
        p16386.burstCount--;
      } else {
        p16386.burstCount = p16386.weapon.burst ? p16386.weapon.burstC - 1 : 0;
      }
      p16386.reloads[p16386.loadoutIndex] = (p16386.burstCount && p16386.weapon.burst ? p16386.weapon.burstR : p16386.weapon.rate) * (game.config.fiRat || 1) * p16386.attributes.fRate * (p16386.perks.includes(1) ? 0.66 : 1) * (p16386.isKranked ? game.mode.bonuses.firerate : 1) * vLN1168;
      this.updatePlayerAmmo(p16386);
      var v13179 = game.store.skins[p16386.getSkinForLoadout(p16386.loadoutIndex)];
      if (!v13179 && p16386.weapon.altSkin != null) {
        v13179 = p16386.weapon.altSkin;
      }
      if (v13179 && v13179.weapon - 1 != p16386.loadout[p16386.loadoutIndex] || p16386.weapon.upgraded) {
        v13179 = {};
      }
      if (game.playSound) {
        var v13180 = config.networkSounds.indexOf(p16391 ? p16386.weapon.sound + "_blast" : p16386.weapon.sound + (v13179 && v13179.mid != null && !v13179.noSnd ? "_" + v13179.mid : ""));
        game.playSound(v13180, 0.85, p16386.sid, p16386.x, p16386.y, p16386.z, false, UTILS.randFloat(0.9, 1.1), null, p16386.weapon.refDist, p16386.weapon.rollOff);
      }
      p16386.recoilForce += p16386.weapon.recoil * (p16391 ? 3.5 : 1);
      if (p16386.isYou && game.controls) {
        if (game.controls.cntrlInput.vibration && game.controls.gamepad.active) {
          game.controls.gamepad.rumble(p16386.weapon.rumbleDur || 200, (p16386.weapon.rumble || 0.5) * game.controls.cntrlInput.vibrationMlt);
        } else if (game.controls.mblInput.vibration && !game.controls.isMobile && "vibrate" in navigator) {
          navigator.vibrate(p16386.weapon.rumbleDur || 200);
        }
      }
      if (p16386.isYou) {
        this.playClip(p16386, "Shoot", 1);
      }
      var v13181 = !p16386.config || p16386.config.mdl !== 2;
      if (p16386.renderYou && v13181) {
        var v13182 = UTILS.randFloat(-Math.PI, Math.PI);
        p16386.recoilX += p16386.weapon.recoilR * Math.sin(v13182);
        p16386.recoilZ += p16386.weapon.recoilR * 0.3 * Math.cos(v13182);
        if (p16386.recoilTween) {
          p16386.recoilTween.stop();
        }
        var v13183 = (p16386.weapon.recoilAnim ? p16386.weapon.recoilAnim.time || p16386.weapon.rate : p16386.weapon.rate) * (game.config.fiRat || 1) * p16386.attributes.fRate * (p16386.perks.includes(1) ? 0.66 : 1) * (p16386.isKranked ? game.mode.bonuses.firerate : 1);
        if (p16386.aimVal == 0 && p16386.weapon.recoilAnim && p16386.weapon.recoilAnim.aimTime) {
          v13183 = p16386.weapon.recoilAnim.aimTime;
        }
        p16386.recoilTween = new TWEEN.Tween(p16386).to(p16386.weapon.recoilAnim || {}, v13183 * 0.15).easing(TWEEN.Easing.Linear.None).onComplete(function () {
          p16386.recoilTween = new TWEEN.Tween(p16386).to({
            recoilTweenY: 0,
            recoilTweenR: 0,
            recoilTweenYM: 0,
            recoilTweenZ: 0
          }, v13183 * 0.95).easing(TWEEN.Easing.Back.Out).start();
        }).start();
        this.cancelInspect(p16386);
      }
      if (p16386.weapon.deployRang || p16386.deployGun != null) {
        return this.tryDeployable(p16386);
      }
      if (!this.tmpPos) {
        this.tmpPos = new game.THREE.Vector3();
      }
      if (p16386.renderYou && v13181 && !this.isWeaponHidden(p16386, p16386.loadoutIndex)) {
        var v13184 = p16386.weaponMeshes[p16386.loadoutIndex];
        var v13185 = p16386.aimVal == 0 && p16386.weapon.scope && !p16386.currentSkin.noScope;
        if (v13184 && PARTICLES.showMuzzle && !p16386.weapon.nMuz && (!v13179 || !v13179.noMuz) && !game.controls.camOffset) {
          for (var vLN02367 = 0; vLN02367 < v13184.muzzles.length; ++vLN02367) {
            v13184.muzzles[vLN02367].visible = true;
            PARTICLES.setMaterial(v13184.muzzles[vLN02367], p16386.weapon.muzID || 2, 2, true);
            vO416.siz = (p16386.weapon.muzMlt || 1) * 4;
            vO416.static = true;
            vO416.life = 1;
            v13184.muzzles[vLN02367].init(vLN02367 ? -(p16386.weapon.xOff * 2 * (p16386.leftHand ? -1 : 1)) : 0, p16386.weapon.muzOffY || 0, -(p16386.weapon.muzOff || 0), vO416);
          }
          if (!v13185) {
            var v13246 = this.tmpPos;
            p16386.weaponMeshes[p16386.loadoutIndex].muzzles[0].getWorldPosition(v13246);
            v13246.project(RENDER.camera);
            v13246.x = (v13246.x + 1) / 2;
            v13246.y = (v13246.y + 1) / 2;
            RENDER.flash(v13246.x, v13246.y);
          }
        }
        if (!p16386.weapon.nCase && PARTICLES.active && v13184 && PARTICLES.showCasings) {
          for (var vLN02367 = 0; vLN02367 < v13184.casings.length; ++vLN02367) {
            var v13246 = this.tmpPos;
            var v13246 = v13184.casings[vLN02367].getWorldPosition(v13246);
            if (SOUND && game.now - (p16386.lastShell || 0) > 400) {
              p16386.lastShell = game.now;
              SOUND.play("case_" + UTILS.randInt(0, 1), 0.45, false, UTILS.randFloat(0.8, 1.3));
            }
            if (!v13185) {
              var v13189 = UTILS.randInt(0, 1) ? 1.4 : 0.8;
              PARTICLES.physObj(v13246.x, v13246.y, v13246.z, p16386.xDire - Math.PI / 2 * (vLN02367 ? -1 : 1), Math.PI / 5 * UTILS.randFloat(0.75, 1.2) * v13189, 25, false, p16386.weapon.caseInd || 1, p16386);
            }
          }
        }
      }
      if (p16386.renderYou) {
        var v13255 = game.mode && game.mode.finiteAmmo && !p16386.isBot;
        if (p16386.ammos[p16386.loadoutIndex] <= 0 && p16386.weapon.removeOnEmpty && (!v13255 || v13255 && p16386.reserveAmmos[p16386.loadoutIndex] <= 0)) {
          if (p16386.weapon.id == 25 && p16386.isJuggernaut) {
            game.setJuggernaut(p16386, false);
          } else {
            game.players.removeWeapon(p16386, p16386.weapon.id);
          }
          return;
        }
      }
      if (!p16386.renderYou || PARTICLES.yourTrails || p16386.weapon.physPow) {
        var v13191 = p16386.y + p16386.height - config.cameraHeight;
        var v13192 = p16386.xDire;
        var v13193 = p16386.yDire;
        if (p16386.config.shtToCam) {
          v13192 = p16389;
          v13193 = p16390;
        }
        if (p16386.config.shtDrg != 1) {
          v13192 = p16386.xDirChase == null ? p16389 : p16386.xDirChase;
          v13193 = p16386.yDirChase == null ? p16390 : p16386.yDirChase;
        }
        v13192 += UTILS.toRad(p16386.config.shotX || 0);
        v13193 += UTILS.toRad(p16386.config.shotY || 0);
        var v13194 = p16386.weapon.projectile != null && (!p16386.weapon.projectile.disable || game.config.bDrop);
        if (v13194) {
          p16386.shotCntP++;
          var v13195 = p16386.weapon.noProjSpread ? 0 : config.projSpreads[p16386.shotCntP % config.projSpreads.length];
          var v13204 = (p16386.spread * p16386.spreadMlt + (p16386.weapon.innac || 0)) * config.spreadAdj;
          v13204 *= v13195;
          var vLN02359 = v13192 + v13204;
          var vLN02360 = v13193 + (p16386.noRecoil ? 0 : p16386.recoilAnimY * config.recoilMlt) + v13204;
          if (this.isServer) {
            var vO421 = {
              wId: p16388,
              w: p16386.upgrades[p16386.loadoutIndex] ? game.upgradeWeapons[p16388] : game.weaponConfig[p16388],
              dmgMlt: 1 - (p16386.weapon.chrgMlt || 0.9) * (1 - vLN1167),
              rangeMlt: p16386.rangeMlt
            };
            if (p16386.weapon.effectOnHit != null) {
              vO421.effectInd = p16386.weapon.effectOnHit;
              vO421.effectC = Math.floor(vLN1167 * 10);
            }
            game.projectiles.init(p16386.x, v13191, p16386.z, vLN02359, vLN02360, p16386.weapon.projectile, p16386, vO421, undefined, p16386.weapon.customProj);
          }
          if (p16386.isYou && !p16386.weapon.projectile.dontPred) {
            PARTICLES.physObj(p16386.x, v13191, p16386.z, vLN02359, vLN02360, 3000, false, null, null, p16386.weapon.projectile, -1, p16386.shotCntP, p16386.weapon.customProj);
          }
        }
        var v13199 = p16386.weapon.physPow;
        if (!v13194 || v13199) {
          var vLN02358 = 0;
          var vA715 = [];
          var v13200 = v13199 ? -1 : 0;
          for (var v13201 = p16386.weapon.shots == null ? 1 : p16386.weapon.shots, vV13200 = v13200; vV13200 < v13201; ++vV13200) {
            if (vV13200 >= 0) {
              p16386.totShots++;
              if (p16386.active) {
                p16386.totShotsL++;
              }
            }
            var vLN02359 = 0;
            var vLN02360 = 0;
            if (p16386.weapon.cSpread && vV13200 >= 0) {
              var v13202 = UTILS.randFloat(0.3, 0.32) * p16386.spreadMlt;
              var v13203 = p16386.ammos[p16386.loadoutIndex] % 2;
              vLN02359 = v13192 + (p16386.weapon.cSpread[v13203][vLN02358] || 0) * v13202;
              vLN02360 = v13193 + (p16386.weapon.cSpread[v13203][vLN02358 + 1] || 0) * v13202;
              vLN02358 += 2;
            } else {
              var v13204 = vV13200 >= 0 ? (p16386.spread * p16386.spreadMlt + (p16386.weapon.innac || 0)) * config.spreadAdj : 0;
              if (p16391) {
                v13204 = 0;
              }
              vLN02359 = v13192 + UTILS.randFloat(-v13204, v13204);
              vLN02360 = v13193 + UTILS.randFloat(-v13204, v13204);
            }
            if (!p16386.noRecoil) {
              vLN02360 += p16386.recoilAnimY * config.recoilMlt;
            }
            var v13205 = +(p16386.weapon.range * p16386.rangeMlt);
            if (vV13200 < 0) {
              v13205 = +p16386.weapon.physRang;
            }
            vA714.length = 0;
            var vLN02361 = 0;
            var v13206 = v13205 * Math.sin(vLN02359 + Math.PI) * Math.cos(vLN02360);
            var v13207 = v13205 * Math.cos(vLN02359 + Math.PI) * Math.cos(vLN02360);
            var v13208 = v13205 * Math.sin(vLN02360);
            var v13209 = v12911.set(v13206, v13208, v13207).normalize();
            v13206 = 1 / v13206;
            v13207 = 1 / v13207;
            v13208 = 1 / v13208;
            v12912.set(p16386.x, v13191, p16386.z);
            game.raycaster.set(v12912, v13209);
            if (vV13200 < 0 && game && game.mode && game.mode.nonObjImpulse) {
              var v13226 = (game.mode && game.mode.noImpulseDist ? 1 : 0.04) * (game.config ? game.config.impulseMlt : 1) * (game.mode && game.mode.impulseMlt != null ? game.mode.impulseMlt : 1);
              var v13227 = v13226 * Math.sin(vLN02359 + Math.PI) * Math.cos(vLN02360);
              p16386.velocity.x -= v13227;
              var v13228 = v13226 * Math.cos(vLN02359 + Math.PI) * Math.cos(vLN02360);
              p16386.velocity.z -= v13228;
              var v13229 = v13226 * Math.sin(vLN02360);
              p16386.velocity.y -= v13229;
              p16386.onGround = false;
              if (!serverIO) {
                p16387.velObj = {
                  x: v13227,
                  y: v13228,
                  z: v13229
                };
              }
            }
            for (var vLN02370 = 0; vLN02370 < game.map.manager.objects.length; ++vLN02370) {
              v12909 = game.map.manager.objects[vLN02370];
              if (v12909.active && !v12909.noShoot) {
                vLN02361 = UTILS.lineInRect(p16386.x, p16386.z, v13191, v13206, v13207, v13208, v12909.x - v12909.width, v12909.z - v12909.length, v12909.y - v12909.height, v12909.x + v12909.width, v12909.z + v12909.length, v12909.y + v12909.height);
                if (vLN02361 && vLN02361 <= 1) {
                  vA714.push({
                    obj: v12909,
                    dst: vLN02361
                  });
                }
              }
            }
            for (var v13214 in game.map.manager.spawnables) {
              v12909 = game.map.manager.spawnables[v13214];
              if (v12909.active && v12909.shoot) {
                vLN02361 = UTILS.lineInRect(p16386.x, p16386.z, v13191, v13206, v13207, v13208, v12909.x - v12909.width, v12909.z - v12909.length, v12909.y - v12909.height, v12909.x + v12909.width, v12909.z + v12909.length, v12909.y + v12909.height);
                if (vLN02361 && vLN02361 <= 1) {
                  vA714.push({
                    spawnable: true,
                    obj: v12909,
                    dst: vLN02361
                  });
                }
              }
            }
            if (this.isServer && vV13200 >= 0) {
              for (var vLN02370 = 0; vLN02370 < this.list.length; ++vLN02370) {
                if (this.list[vLN02370].active && !this.list[vLN02370].noPVP && p16386 != this.list[vLN02370] && !p16386.noPVP && (p16386.forcePVP && this.list[vLN02370].forcePVP || !p16386.forcePVP && !this.list[vLN02370].forcePVP) && (!p16386.team || p16386.team != this.list[vLN02370].team || game.mode.dmgTeam || game.config.frFire) && (v12909 = this.fetchState(this.list[vLN02370], p16386), v12909)) {
                  if (!this.list[vLN02370].newHitboxes) {
                    vLN02361 = UTILS.lineInRect(p16386.x, p16386.z, v13191, v13206, v13207, v13208, v12909.x - this.list[vLN02370].scale - this.list[vLN02370].hitboxPadW, v12909.z - this.list[vLN02370].scale - this.list[vLN02370].hitboxPadW, v12909.y, v12909.x + this.list[vLN02370].scale + this.list[vLN02370].hitboxPadW, v12909.z + this.list[vLN02370].scale + this.list[vLN02370].hitboxPadW, v12909.y + v12909.ah + this.list[vLN02370].hitboxPadH);
                    if (vLN02361 && vLN02361 <= 1) {
                      vA714.push({
                        player: true,
                        obj: this.list[vLN02370],
                        dst: vLN02361
                      });
                    }
                  } else {
                    vLN02361 = UTILS.lineInRect(p16386.x, p16386.z, v13191, v13206, v13207, v13208, v12909.x - config.hitBoxPad, v12909.z - config.hitBoxPad, v12909.y - config.hitBoxPad, v12909.x + config.hitBoxPad, v12909.z + config.hitBoxPad, v12909.y + v12909.h + config.hitBoxPad);
                    if (vLN02361 && vLN02361 <= 1) {
                      this.updateMshServ(this.list[vLN02370], v12909.x, v12909.y, v12909.z, v12909.xD, v12909.yD, v12909.sV, v12909.cV);
                      var v13215 = game.raycaster.intersectObjects(this.list[vLN02370].objInstances.children, true);
                      if (v13215.length) {
                        vA714.push({
                          player: true,
                          obj: this.list[vLN02370],
                          headshot: v13215[0].object.name == "head",
                          legshot: v13215[0].object.name == "leg",
                          dst: v13215[0].distance / v13205
                        });
                      }
                    }
                  }
                }
              }
            }
            if (this.isServer && vV13200 >= 0) {
              for (var vLN02370 = 0; vLN02370 < game.AI.ais.length; ++vLN02370) {
                if (game.AI.ais[vLN02370].active && (!p16386.team || p16386.team != game.AI.ais[vLN02370].team || game.mode.dmgTeam || game.config.frFire)) {
                  v12909 = game.AI.ais[vLN02370].fetchState(p16386);
                  if (!v12909) {
                    continue;
                  }
                  vLN02361 = UTILS.lineInRect(p16386.x, p16386.z, v13191, v13206, v13207, v13208, v12909.x - game.AI.ais[vLN02370].scale, v12909.z - game.AI.ais[vLN02370].scale, v12909.y, v12909.x + game.AI.ais[vLN02370].scale, v12909.z + game.AI.ais[vLN02370].scale, v12909.y + game.AI.ais[vLN02370].height * 2);
                  if (vLN02361 && vLN02361 <= 1) {
                    vA714.push({
                      ai: true,
                      obj: game.AI.ais[vLN02370],
                      dst: vLN02361
                    });
                  }
                }
              }
            }
            var v13216 = game.map.terrain;
            if (v13216) {
              var v13217 = v13216.raycast(p16386.x, -p16386.z, v13191, 1 / v13206, -1 / v13207, 1 / v13208);
              if (v13217) {
                let v13218 = UTILS.getD3D(p16386.x, v13191, p16386.z, v13217.x, v13217.z, -v13217.y);
                vA714.push({
                  terrain: true,
                  dst: v13218 / v13205
                });
              }
            }
            var vV13205 = v13205;
            if (vA714.length) {
              vA714.sort(UTILS.orderByDst);
              var v13219 = +p16386.weapon.dmg * vLN1167;
              var v13220 = +p16386.weapon.dmg * vLN1167;
              var v13221 = p16386.weapon.funcOnHit;
              var v13222 = p16386.weapon.effectOnHit;
              var v13223 = Math.floor(vLN1167 * 10);
              if (p16386.smite) {
                v13219 = 10000;
              }
              v13219 *= p16386.attributes.dmg;
              v13219 *= p16386.dmgMlt;
              if (!UTILS.isNumber(v13219) || !UTILS.isNumber(v13220)) {
                break;
              }
              var v13224 = false;
              for (var vLN02370 = 0; vLN02370 < vA714.length; ++vLN02370) {
                v12909 = vA714[vLN02370];
                vV13205 = v13205 * v12909.dst;
                if (vV13200 < 0) {
                  var v13225 = game && game.mode && game.mode.nonObjImpulse;
                  if (!v13225 && (!v12909.obj || !v12909.obj.noPCol) && (!v12909.obj || !v12909.obj.noImpulse) && v12909.dst >= 0) {
                    var v13226 = (game.mode && game.mode.noImpulseDist ? 1 : 1 - v12909.dst) * (v13199 * (game.config ? game.config.impulseMlt : 1) * (game.mode && game.mode.impulseMlt != null ? game.mode.impulseMlt : 1));
                    var v13227 = v13226 * Math.sin(vLN02359 + Math.PI) * Math.cos(vLN02360);
                    p16386.velocity.x -= v13227;
                    var v13228 = v13226 * Math.cos(vLN02359 + Math.PI) * Math.cos(vLN02360);
                    p16386.velocity.z -= v13228;
                    var v13229 = v13226 * Math.sin(vLN02360);
                    p16386.velocity.y -= v13229;
                    p16386.onGround = false;
                    if (!serverIO) {
                      p16387.velObj = {
                        x: v13227,
                        y: v13228,
                        z: v13229
                      };
                    }
                  }
                  break;
                } else if (this.isServer) {
                  var v13230 = false;
                  var v13231 = false;
                  var v13232 = p16386.weapon.dropStart || 0;
                  var v13233 = Math.min(1, 1 - (1 - v12909.dst) * v13205 / (v13205 - v13232));
                  var vLN02366 = 0;
                  vLN02366 = v13220 > 0 ? Math.max(0, v13219 - p16386.weapon.dmgDrop * v13233) : Math.min(0, v13219 - p16386.weapon.dmgDrop * v13233);
                  if (vLN02366 == 0) {
                    break;
                  }
                  var v13240 = v13191 + vV13205 * Math.sin(vLN02360);
                  if (v12909.player) {
                    game.players.debugHitbox(p16386, v12909.obj, v13240);
                    if (vLN02370 == 0) {
                      p16386.hitShots++;
                      if (p16386.active) {
                        p16386.hitShotsL++;
                      }
                    }
                    var v13238 = v12909.obj.y + v12909.obj.adjustedHeight - v13240;
                    v13230 = v13238 < config.headScale * v12909.obj.headMlt;
                    if (v13230) {
                      vLN02366 *= v13230 && !p16386.weapon.noHeadShot ? p16386.weapon.hsMlt || 1.5 : 1;
                    } else if (!!game.config && game.config.headshotOnly) {
                      vLN02366 = 0;
                    }
                    v13231 = v12909.obj.y + config.legHeight - config.crouchDst * v12909.obj.crouchVal > v13240;
                    if (v13231 && !v13230) {
                      vLN02366 *= p16386.weapon.lsMlt || 0.5;
                    }
                  }
                  if (!UTILS.isNumber(vLN02366)) {
                    break;
                  }
                  if (serverIO && v12909.obj && v12909.ai) {
                    if (vLN02370 == 0) {
                      p16386.hitShots++;
                      if (p16386.active) {
                        p16386.hitShotsL++;
                      }
                    }
                    if (!v12909.obj.invincible) {
                      var v13236 = +vLN02366;
                      var v13237 = false;
                      var v13238 = v12909.obj.y + v12909.obj.height * 2 - v13240;
                      if (v12909.obj.critDmg && v12909.obj.critHei && v13238 < v12909.obj.critHei) {
                        v13237 = true;
                        v13236 *= v12909.obj.critDmg;
                      }
                      if (v13222 != null && v13223 > 0) {
                        v12909.obj.giveEffect(v13222, v13223);
                        if (v13222 == 8) {
                          v12909.obj.zappedBy = p16386.sid;
                        }
                      }
                      if (v13221) {
                        v13221(v12909.obj, p16386);
                      }
                      v12909.obj.changeHealth(-v13236, p16386);
                      if (v12909.obj.killScore && game.mode && game.mode.pointsPerHit) {
                        this.score(p16386, Math.ceil(v13236 * game.mode.pointsPerHit), 1);
                      }
                      if (!v12909.obj.active && v12909.obj.killScore) {
                        this.score(p16386, v12909.obj.killScore, 1);
                      }
                      game.showHit(p16386, v12909.obj, Math.round(v13236), v13237, true);
                    }
                  } else if (game.isServer && (!game.waitTimers || game.waitTimers[0] && game.waitTimers[0].contTime) && v12909.obj && v12909.obj.health && vLN02366 > 0 && !v12909.player && !v12909.spawnable) {
                    v12909.obj.health -= vLN02366;
                    for (var vLN02367 = 0; vLN02367 < this.list.length; ++vLN02367) {
                      if (p16386 && p16386 == this.list[vLN02367] || this.list[vLN02367].specStream == p16386.sid) {
                        this.list[vLN02367].send("4");
                      }
                    }
                    if (v12909.obj.health <= 0) {
                      v12909.obj.active = false;
                      v12909.obj.health = 0;
                      v12909.obj.destroyed = true;
                      v12909.obj.destroyedBy = p16386;
                      game.map.manager.destObjs.push(v12909.obj.uid);
                      game.broadcast("do", v12909.obj.uid);
                      if (v12909.obj && v12909.obj.onDestroy) {
                        game.onTrigger(p16386, v12909.obj);
                      }
                    }
                  } else if (serverIO && game.mode.teamOptions && game.mode.teamOptions[p16386.team - 1] == "Seekers" && !v12909.player && !v12909.spawnable && v12909.obj && v12909.obj.propID) {
                    if (this.changeHealth(p16386, null, 10)) {
                      this.kill(p16386);
                    }
                  } else if (serverIO && (!game.waitTimers || game.waitTimers[0] && game.waitTimers[0].contTime) && v12909.obj && v12909.spawnable) {
                    game.shootSpawnable(p16386, v12909.obj);
                    p16386.send("4");
                  }
                  if (v12909.obj && (v12909.obj.onShoot || v12909.obj.onDamage)) {
                    game.onTrigger(p16386, v12909.obj);
                  }
                  if (v12909.obj && v12909.obj.isEvent) {
                    game.foundEventItem(p16386, v12909.obj);
                  }
                  if (v12909.player) {
                    v13176 = true;
                    if (v13222 != null && v13223 > 0) {
                      game.players.giveEffect(v12909.obj, v13222, v13223);
                      if (v13222 == 8) {
                        v12909.obj.zappedBy = p16386.sid;
                      }
                    }
                    if (this.changeHealth(v12909.obj, p16386, vLN02366, null, v13230, {
                      wep: p16388
                    })) {
                      if (v13224) {
                        p16386.wallbangs++;
                        if (serverIO) {
                          game.incStat("wb", p16386);
                          vA715.push("wb", 1);
                        }
                      }
                      if (v13230) {
                        p16386.headshots++;
                        if (serverIO) {
                          game.incStat("hs", p16386);
                          vA715.push("hs", 1);
                        }
                      }
                      if (v13231) {
                        p16386.legshots++;
                        if (serverIO) {
                          game.incStat("ls", p16386);
                          vA715.push("ls", 1);
                        }
                      }
                      this.kill(v12909.obj, p16386, {
                        dst: v12909.dst,
                        hs: v13230,
                        wb: v13224,
                        wId: p16388
                      });
                    }
                    v13219 -= p16386.weapon.pierce == null ? v13219 : v13220 * config.materialDens.flesh * p16386.weapon.pierce;
                  } else if (v12909.obj && v12909.obj.penetrable && p16386.weapon.pierce != null) {
                    v13224 = true;
                    v13219 = (v13219 - v13220 * config.materialDens.default * p16386.weapon.pierce) * v12909.obj.penetrable;
                  } else if (v12909.ai && v12909.obj) {
                    v13219 -= p16386.weapon.pierce == null ? v13219 : v13220 * config.materialDens.default * p16386.weapon.pierce;
                  } else {
                    break;
                  }
                  if (v13220 > 0 && v13219 <= 0) {
                    break;
                  }
                  if (v13220 < 0 && v13219 >= 0) {
                    break;
                  }
                } else {
                  break;
                }
              }
            }
            if (!(vV13200 < 0)) {
              vV13205 -= 0.12;
              var v13239 = p16386.x + vV13205 * Math.sin(vLN02359 + Math.PI) * Math.cos(vLN02360);
              var v13240 = v13191 + vV13205 * Math.sin(vLN02360);
              var v13241 = p16386.z + vV13205 * Math.cos(vLN02359 + Math.PI) * Math.cos(vLN02360);
              var v13253 = 0;
              var v13254 = 0;
              if (vA714.length) {
                if (v12909.terrain) {
                  v13254 = Math.PI / 2;
                } else if (v13240 >= v12909.obj.y + v12909.obj.height) {
                  v13254 = Math.PI / 2;
                } else if (v13240 <= v12909.obj.y - v12909.obj.height) {
                  v13254 = -Math.PI / 2;
                } else if (v13239 <= v12909.obj.x - v12909.obj.width) {
                  v13253 = -Math.PI / 2;
                } else if (v13239 >= v12909.obj.x + v12909.obj.width) {
                  v13253 = Math.PI / 2;
                } else if (v13241 <= v12909.obj.z - v12909.obj.length) {
                  v13253 = Math.PI;
                }
                if (!serverIO && PARTICLES.showImpactHoles) {
                  PARTICLES.effect(v13239, v13240, v13241, v13253, v13254, 0);
                }
              }
              var v13242 = p16386.weapon && p16386.weapon.trail ? 1 : 0;
              if (p16391 && p16386.weapon && p16386.weapon.trailChrg) {
                v13242 = 2;
              }
              if (serverIO) {
                for (var vLN02370 = 0; vLN02370 < this.list.length; ++vLN02370) {
                  if ((this.list[vLN02370].active || this.list[vLN02370].spectating) && this.list[vLN02370] != p16386) {
                    if (!vA714.length || v12909.player || v12909.ai) {
                      this.list[vLN02370].send("9", [p16386.sid, Math.round(v13239), Math.round(v13240), Math.round(v13241), undefined, undefined, v13242, p16386.x.round(1), p16386.y.round(1), p16386.height.round(1), p16386.z.round(1)]);
                    } else {
                      this.list[vLN02370].send("9", [p16386.sid, Math.round(v13239), Math.round(v13240), Math.round(v13241), v13253.round(1), v13254.round(1), v13242, p16386.x.round(1), p16386.y.round(1), p16386.height.round(1), p16386.z.round(1)]);
                    }
                  }
                }
              }
              if (p16386.isYou && vV13205 >= config.tracerMinDst && PARTICLES.showTracers && p16386.weaponMeshes[p16386.loadoutIndex]) {
                var v13245;
                var v13246 = new game.THREE.Vector3();
                if (v13181) {
                  var v13245 = UTILS.randInt(0, p16386.weaponMeshes[p16386.loadoutIndex].muzzles.length - 1);
                  var v13246 = p16386.weaponMeshes[p16386.loadoutIndex].muzzles[v13245].getWorldPosition(v13246);
                } else {
                  p16386.objInstances.getWorldPosition(v13246);
                  v13246.y += p16386.height / 2;
                }
                var v13247 = p16386.weapon && p16386.weapon.scope && !p16386.currentSkin.noScope && p16386.aimVal == 0 ? 7 : 0;
                var v13248 = v13246.x - v13247 * Math.sin(vLN02359 + Math.PI) * Math.cos(vLN02360);
                var v13249 = v13246.y - v13247 * Math.sin(vLN02360);
                var v13250 = v13246.z - v13247 * Math.cos(vLN02359 + Math.PI) * Math.cos(vLN02360);
                if (RENDER.tracerOffset) {
                  var v13251 = UTILS.randFloat(-Math.PI, Math.PI);
                  var v13252 = RENDER.tracerOffset * 20;
                  v13248 += v13252 * Math.sin(vLN02359 + Math.PI / 2) * Math.cos(v13251);
                  v13249 += v13252 * Math.sin(v13251);
                  v13250 += v13252 * Math.cos(vLN02359 + Math.PI / 2) * Math.cos(v13251);
                }
                var v13253 = UTILS.getDir(v13250, v13248, v13241, v13239);
                var v13254 = UTILS.getDir(UTILS.getDistance(v13248, v13250, v13239, v13241), v13240, 0, v13249);
                PARTICLES.physObj(v13248, v13249, v13250, v13253, v13254, Math.min(vV13205 + v13247, config.tracerMaxDst), v13242, 0, p16386);
              }
            }
          }
          if (vA715.length) {
            game.challenges.updateMulti(game, vA715, {
              wep: p16388
            }, p16386);
          }
        }
        if (v13176 && serverIO) {
          game.incStat("h", p16386);
        }
        var v13255 = game.mode && game.mode.finiteAmmo && !p16386.isBot;
        if (p16386.ammos[p16386.loadoutIndex] <= 0 && p16386.weapon.removeOnEmpty && (!v13255 || v13255 && p16386.reserveAmmos[p16386.loadoutIndex] <= 0)) {
          if (p16386.weapon.id == 25 && p16386.isJuggernaut) {
            game.setJuggernaut(p16386, false);
          } else {
            game.players.removeWeapon(p16386, p16386.weapon.id);
          }
        }
      }
    }
  };
  this.interact = function (p16392, v13261, p16394, p16395) {
    if (game.now - p16392.lastInteract >= config.interactTimer) {
      p16392.lastInteract = game.now;
      if (!p16395) {
        var v13256 = game.mode && game.mode.unrestrictedWeapons;
        if (v13261 == 6 && (!game.mode.teamOptions || game.mode.teamOptions[p16392.team - 1] != "Infected") && (!game.mode || !game.mode.noPickups) && (v12908 = game.map.manager.findByUid(p16394, game.map.manager.pickups), v12908 && v12908.active && v12908.pickup != null && p16392.collides(v12908) && (p16392.loadout.indexOf(v12908.pickup) == -1 || v13256) && game.teamCheck(v12908, p16392) && (!game.weaponConfig[v12908.pickup].bomb || game.mode && game.mode.site))) {
          var v13274 = v12908.method || 0;
          var v13258 = p16392.loadout.indexOf(v12908.pickup);
          var v13259 = v13258 >= 0 && p16392.upgrades[v13258];
          var v13260 = v13256 && v13258 >= 0 & v13274 < 2 ? v13259 ? 4500 : Math.ceil(v12908.scoreP / 2) : v12908.scoreP;
          if (v13274 < 2 && p16392.score >= v13260 || v13274 == 2 && p16392.kills >= v12908.scoreP || v13274 == 3 && p16392.account || v13274 == 4 && p16392.account && p16392.account.featured || v13274 == 5 && p16392.account && p16392.account.premiumT > 0 || v13274 == 6 && p16392.account && p16392.account.partnerApp >= 2 || v13274 == 7 && p16392.account && (p16392.account.level || 0) >= v12908.scoreP) {
            if (v13256) {
              game.players.giveWeapon(p16392, v12908.pickup, false, true);
              if (v13260 != 0 && !v13274) {
                p16392.send("am", [v13274 ? "Unlocked" : "Purchased", v13274 ? null : -v13260, 0, 1]);
                if (!v13274) {
                  this.score(p16392, -v13260);
                }
              }
              return;
            }
            var v13261 = game.weaponConfig[v12908.pickup].type;
            if (game.weaponConfig[v12908.pickup].bomb && (!game.mode || !game.mode.site)) {
              return;
            }
            var v13262 = false;
            v12909 = undefined;
            var v13263;
            var v13264 = v12908.pickupAmmo;
            for (var vLN02372 = 0; vLN02372 < p16392.loadout.length; vLN02372++) {
              v13263 = game.weaponConfig[p16392.loadout[vLN02372]].type;
              if (v13263 == v13261) {
                v12909 = p16392.loadout[vLN02372];
                var v13265 = this.removePicked(p16392, p16392.loadout[0]);
                if (v12908.pickupRep && v13265) {
                  this.addPicked(p16392, v12908.pickup, v12908.uid);
                }
                p16392.loadout[vLN02372] = v12908.pickup;
                p16392.loadoutIndex = vLN02372;
                if (v12908.pickupRep) {
                  v12908.pickup = v12909;
                  v12908.pickupAmmo = p16392.ammos[p16392.loadoutIndex];
                }
                p16392.ammos[p16392.loadoutIndex] = UTILS.isNumber(v13264) ? v13264 : game.weaponConfig[p16392.loadout[p16392.loadoutIndex]].ammo;
                p16392.reserveAmmos[p16392.loadoutIndex] = game.weaponConfig[p16392.loadout[p16392.loadoutIndex]].ammo * game.getReserveMags(game.weaponConfig[p16392.loadout[p16392.loadoutIndex]]);
                p16392.upgrades[p16392.loadoutIndex] = 0;
                v13262 = true;
                break;
              }
            }
            if (!v13262) {
              v12909 = undefined;
              if (v12908.pickupRep) {
                this.addPicked(p16392, v12908.pickup, v12908.uid);
              }
              p16392.loadout.push(v12908.pickup);
              p16392.ammos.push(UTILS.isNumber(v13264) ? v13264 : game.weaponConfig[p16392.loadout[p16392.loadoutIndex]].ammo);
              p16392.reserveAmmos.push(game.weaponConfig[p16392.loadout[p16392.loadoutIndex]].ammo * game.getReserveMags(game.weaponConfig[p16392.loadout[p16392.loadoutIndex]]));
              p16392.upgrades.push(0);
              let vA716 = [...p16392.ammos];
              let vA717 = [...p16392.reserveAmmos];
              let vA718 = [...p16392.upgrades];
              let vA719 = [...p16392.loadout];
              p16392.loadout.sort(function (p16396, p16397) {
                return game.weaponConfig[p16396 || 0].type - game.weaponConfig[p16397 || 0].type;
              });
              var v13266;
              for (var vLN02372 = 0; vLN02372 < p16392.loadout.length; vLN02372++) {
                v13266 = vA719.indexOf(p16392.loadout[vLN02372]);
                p16392.ammos[vLN02372] = vA716[v13266];
                p16392.reserveAmmos[vLN02372] = vA717[v13266];
                p16392.upgrades[vLN02372] = ~~!!vA718[v13266];
              }
              p16392.loadoutIndex = p16392.loadout.indexOf(v12908.pickup);
              if (v12908.pickupRep) {
                v12908.pickup = undefined;
              }
            }
            let vA720 = [...p16392.ammos];
            let vA721 = [...p16392.reserveAmmos];
            let vA722 = [...p16392.upgrades];
            game.broadcast("inat", p16392.sid, p16392.loadout, p16392.loadoutIndex, v12908.uid, v12908.pickupRep ? v12909 : v12908.pickup, !!v12908.active, true, null, vA720, vA721, vA722, true);
            p16392.updateLoadout(game, p16392.loadoutIndex, true, p16392.loadout, vA720, vA721, vA722, true);
            if (v12908.scoreP != 0 && !v13274) {
              p16392.send("am", [v13274 ? "Unlocked" : "Purchased", v13274 ? null : -v12908.scoreP, 0, 1]);
              if (!v13274) {
                this.score(p16392, -v12908.scoreP);
              }
            }
          }
        }
        if (v13261 == 13 && (!game.waitTimers || game.waitTimers[0] && game.waitTimers[0].contTime) && !p16392.hasEquipment() && (v12908 = game.map.manager.findByUid(p16394), v12908 && v12908.mysteryBox && v12908.active && p16392.collides(v12908, v12908.tRadius))) {
          var v13273 = game.fireSaleTimer ? 10 : p16392.sharingIsCaring ? Math.ceil(v12908.scoreP / 2) : v12908.scoreP;
          if (v12908.state == 2) {
            if ((v12908.purchasedBy == -1 || v12908.purchasedBy == p16392.id) && v12908.pendingWeapon != -1) {
              game.players.giveWeapon(p16392, v12908.pendingWeapon, false, true);
              v12908.purchasedBy = undefined;
              v12908.pendingWeapon = undefined;
              v12908.timer = 0;
              v12908.state = 0;
              game.syncMysteryBox(v12908);
            }
          } else if (v12908.state == 0 && p16392.score >= v13273) {
            v12908.purchasedBy = p16392.id;
            var v13268 = p16392.sharingIsCaring ? 0 : 20;
            v12908.pendingWeapon = game.getMysteryBoxWeapon(v13268);
            v12908.timer = config.mysteryBoxAnim;
            v12908.state = 1;
            if (v12908.pendingWeapon != -1) {
              p16392.send("am", ["Purchased", -v13273, 0, 1]);
              this.score(p16392, -v13273);
              game.challenges.update(game, "mybx", 1, null, p16392);
            }
            var v13272 = v12908.pendingWeapon == -1 ? "mystery_1" : "mystery_0";
            game.playSound(config.networkSounds.indexOf(v13272), 0.5, 0, Math.round(v12908.x), Math.round(v12908.y), Math.round(v12908.z), true, 1, false, null, null, true);
            game.syncMysteryBox(v12908);
          }
        }
        if (v13261 == 15 && (!game.waitTimers || game.waitTimers[0] && game.waitTimers[0].contTime) && !p16392.hasEquipment()) {
          var v13270 = !p16392.upgrades[p16392.loadoutIndex] && game.weaponConfig[p16392.loadout[p16392.loadoutIndex]] && game.weaponConfig[p16392.loadout[p16392.loadoutIndex]].canUpgrade;
          v12908 = game.map.manager.findByUid(p16394, game.map.manager.krumMachines);
          if (v12908 && v12908.active && p16392.collides(v12908, v12908.tRadius)) {
            var v13273 = v12908.scoreP;
            if (v12908.state == 2) {
              if (v12908.purchasedBy == -1 || v12908.purchasedBy == p16392.id) {
                game.players.giveWeapon(p16392, v12908.pendingWeapon, true, true);
                v12908.purchasedBy = undefined;
                v12908.pendingWeapon = undefined;
                v12908.timer = 0;
                v12908.state = 0;
                game.syncKrumMachine(v12908);
              }
            } else if (v12908.state == 0 && p16392.score >= v13273 && v13270) {
              v12908.purchasedBy = p16392.id;
              v12908.pendingWeapon = p16392.loadout[p16392.loadoutIndex];
              v12908.timer = config.mysteryBoxAnim;
              v12908.state = 1;
              game.players.removeWeapon(p16392, v12908.pendingWeapon);
              p16392.send("am", ["Purchased", -v13273, 0, 1]);
              this.score(p16392, -v13273);
              var v13272 = v12908.pendingWeapon == -1 ? "mystery_1" : "mystery_0";
              game.playSound(config.networkSounds.indexOf(v13272), 0.5, 0, Math.round(v12908.x), Math.round(v12908.y), Math.round(v12908.z), true, 1, false, null, null, true);
              game.syncKrumMachine(v12908);
            }
          }
        }
        if (v13261 == 14 && (!game.waitTimers || game.waitTimers[0] && game.waitTimers[0].contTime) && p16392.perks.length < config.maxZombiePerks && (v12908 = game.map.manager.findByUid(p16394), v12908 && v12908.perk != null && v12908.active && p16392.collides(v12908, v12908.tRadius))) {
          var v13273 = v12908.scoreP || 0;
          if (p16392.score >= v13273 && !p16392.perks.includes(v12908.perk)) {
            this.givePerk(p16392, v12908.perk);
            p16392.send("am", ["Purchased", -v13273, 0, 1]);
            this.score(p16392, -v13273);
            game.playSound(30431, 0.5, 0, Math.round(v12908.x), Math.round(v12908.y), Math.round(v12908.z), true, 1, false, null, null, true, true);
            game.playSound(30220, 2, 0, Math.round(p16392.x), Math.round(p16392.y), Math.round(p16392.z), true, 1, false, null, null, true, true);
            game.challenges.update(game, "prks", 1, null, p16392);
          }
        }
        if (v13261 == 0 && (!game.waitTimers || game.waitTimers[0] && game.waitTimers[0].contTime) && (v12908 = game.map.manager.findByUid(p16394, game.map.manager.gates), v12908 && (v12908.active || v12908.closeable) && p16392.collides(v12908, v12908.tRadius) && game.teamCheck(v12908, p16392))) {
          var v13274 = v12908.method || 0;
          if (v13274 < 2 && p16392.score >= v12908.scoreP || v13274 == 2 && p16392.kills >= v12908.scoreP || v13274 == 3 && p16392.account || v13274 == 4 && p16392.account && p16392.account.featured || v13274 == 5 && p16392.account && p16392.account.premiumT > 0 || v13274 == 6 && p16392.account && p16392.account.partnerApp >= 2 || v13274 == 7 && p16392.account && (p16392.account.level || 0) >= v12908.scoreP) {
            if (v12908.scoreP != 0) {
              p16392.send("am", [v13274 ? "Unlocked" : "Purchased", v13274 ? null : -v12908.scoreP, 0, 1]);
              if (!v13274) {
                this.score(p16392, -v12908.scoreP);
              }
            }
            v12908.active = !v12908.active;
            game.broadcast("gte", v12908.uid, v12908.active);
          }
        }
        if (v13261 == 9) {
          v12908 = game.map.manager.findByUid(p16394, game.map.manager.spinners);
          if (v12908 && v12908.active && p16392.collides(v12908, v12908.tRadius) && p16392 && p16392.account && p16392.account.funds >= game.store.wheels[v12908.wheel].price) {
            p16392.send("cnfm", v12908.uid, 2);
            p16392.pendingSpin = v12908.uid;
            p16392.pendingTrigger = null;
          }
        }
        if (v13261 == 7 && (!game.waitTimers || game.waitTimers[0] && game.waitTimers[0].contTime)) {
          v12908 = game.map.manager.findByUid(p16394);
          if (v12908 && v12908.onInteractKey && v12908.active && p16392.collides(v12908, 7) && game.teamCheck(v12908, p16392)) {
            if (v12908.trigActCost && (v12908.trigActM || 0) == 0) {
              if (p16392 && p16392.account && p16392.account.funds >= v12908.trigActCost) {
                p16392.send("cnfm", v12908.uid);
                p16392.pendingTrigger = v12908.uid;
                p16392.pendingSpin = null;
              }
            } else {
              game.onTrigger(p16392, v12908);
            }
          }
        }
      }
      if (v13261 == 1) {
        v12908 = game.map.manager.findByUid(p16394, game.map.manager.banks);
        if (v12908 && v12908.active && p16392.collides(v12908, v12908.tRadius) && game.teamCheck(v12908, p16392)) {
          if (v12908.deposited > 0 && p16395) {
            if (v12908.withdrawAmnt && v12908.deposited > v12908.withdrawAmnt) {
              v12908.deposited -= v12908.withdrawAmnt;
              this.score(p16392, v12908.withdrawAmnt);
            } else {
              this.score(p16392, v12908.deposited);
              v12908.deposited = 0;
            }
          } else if (p16392.score != 0 && !p16395) {
            if (v12908.deposited == null) {
              v12908.deposited = 0;
            }
            if (v12908.depositAmnt && p16392.score > v12908.depositAmnt) {
              v12908.deposited += v12908.depositAmnt;
              this.score(p16392, -v12908.depositAmnt);
            } else {
              v12908.deposited += p16392.score;
              this.score(p16392, -p16392.score);
            }
          }
          game.broadcast("bnk", v12908.uid, v12908.deposited);
        }
      }
    }
  };
  this.confirmInteract = function (p16398) {
    if (UTILS.isNumber(p16398.pendingTrigger)) {
      v12908 = game.map.manager.findByUid(p16398.pendingTrigger);
      if (v12908 && v12908.onInteractKey && v12908.active && p16398.collides(v12908, 7) && game.teamCheck(v12908, p16398)) {
        game.onTrigger(p16398, v12908);
      }
    }
  };
  this.findEmptyPickup = function (p16399, p16400) {
    var v13275;
    for (var vLN02373 = 0; vLN02373 < game.map.manager.pickups.length; ++vLN02373) {
      v13275 = game.map.manager.pickups[vLN02373];
      if (v13275.pickupRep && v13275.pickup == null && p16399 == v13275.uid) {
        if (p16400) {
          return v13275;
        } else {
          return v13275.uid;
        }
      }
    }
    return null;
  };
  this.addPicked = function (p16401, p16402, p16403) {
    var v13276 = p16401.lastPicked[p16402];
    if (v13276 == null) {
      p16401.lastPicked[p16402] = p16403;
    }
  };
  this.removePicked = function (p16404, p16405) {
    var v13277 = p16404.lastPicked[p16405];
    if (v13277 != null) {
      delete p16404.lastPicked[p16405];
    }
    return v13277 != null;
  };
  this.dropWeapon = function (p16406, p16407, p16408, p16409 = true) {
    if (p16406 && game.isServer && (!game.mode || !game.mode.noPickups) && game.map.manager.pickups.length) {
      var v13279 = null;
      if (p16408) {
        var v13279 = p16406.loadout.indexOf(p16408);
        if (v13279 == -1) {
          return;
        }
      } else {
        v13279 = p16406.loadoutIndex;
      }
      var v13280;
      var v13281 = p16406.loadout[v13279];
      var v13282 = p16406.ammos[v13279];
      var vA723 = [p16406.x + UTILS.randInt(-1, 1), p16406.y + 1, p16406.z + UTILS.randInt(-1, 1)];
      if (p16407) {
        if (game.mode && game.mode.site) {
          return;
        }
        for (var vLN02374 = 0; vLN02374 < p16406.loadout.length; vLN02374++) {
          v13281 = p16406.loadout[vLN02374];
          v13282 = p16406.ammos[vLN02374];
          if (p16406.lastPicked[v13281] != null) {
            v13280 = this.findEmptyPickup(p16406.lastPicked[v13281]);
            if (v13280 && !game.weaponConfig[v13281].melee) {
              vA723 = [p16406.x + UTILS.randInt(-5, 5), p16406.y + 1, p16406.z + UTILS.randInt(-5, 5)];
              game.updatePickup(v13280, v13281, null, p16409, vA723, v13282);
              game.broadcast("inat", -1, null, null, v13280, v13281, true, p16409, vA723);
            }
          }
        }
        p16406.lastPicked = {};
      } else if (!game.weaponConfig[v13281].melee) {
        if (game.mode && game.mode.site && !game.weaponConfig[v13281].bomb) {
          return;
        }
        if (p16406.lastPicked[v13281] == null) {
          return;
        }
        v13280 = this.findEmptyPickup(p16406.lastPicked[v13281], true);
        if (v13280) {
          this.removePicked(p16406, v13281);
          game.updatePickup(v13280.uid, v13281, null, p16409, vA723, v13282);
        }
        p16406.loadout.splice(v13279, 1);
        p16406.ammos.splice(v13279, 1);
        p16406.reserveAmmos.splice(v13279, 1);
        p16406.upgrades.splice(v13279, 1);
        let vA724 = [...p16406.ammos];
        let vA725 = [...p16406.reserveAmmos];
        let vA726 = [...p16406.upgrades];
        let vA727 = [...p16406.loadout];
        p16406.loadout.sort(function (p16410, p16411) {
          return game.weaponConfig[p16410 || 0].type - game.weaponConfig[p16411 || 0].type;
        });
        var v13283;
        for (var vLN02375 = 0; vLN02375 < p16406.loadout.length; vLN02375++) {
          v13283 = vA727.indexOf(p16406.loadout[vLN02375]);
          p16406.ammos[vLN02375] = vA724[v13283];
          p16406.reserveAmmos[vLN02375] = vA725[v13283];
          p16406.upgrades[vLN02375] = ~~!!vA726[v13283];
        }
        p16406.loadoutIndex = 0;
        let vA728 = [...p16406.ammos];
        let vA729 = [...p16406.reserveAmmos];
        let vA730 = [...p16406.upgrades];
        var v13284 = p16406.loadout.indexOf(12) == -1;
        p16406.updateLoadout(game, p16406.loadoutIndex, true, p16406.loadout, vA728, vA729, vA730, v13284);
        game.broadcast("inat", p16406.sid, p16406.loadout, p16406.loadoutIndex, v13280 ? v13280.uid : null, v13281, !!v13280 && v13280.uid, p16409, vA723, vA728, vA729, vA730, v13284);
        return v13280 || null;
      }
    }
  };
  this.giveWeapon = function (p16412, p16413, p16414, p16415) {
    if (!p16412) {
      return;
    }
    if (!serverIO) {
      return;
    }
    var vParseInt48 = parseInt(p16413 || 0);
    if (!game.weaponConfig[vParseInt48]) {
      return;
    }
    if (p16415 && p16412.hasEquipment()) {
      return;
    }
    var v13285 = p16414 ? game.upgradeWeapons[vParseInt48] : game.weaponConfig[vParseInt48];
    var v13286 = !v13285.secondary && !v13285.melee && !v13285.equipment;
    var v13287 = !!v13285.secondary;
    var v13288 = v13285.melee;
    var v13289 = v13285.equipment;
    var v13290 = -1;
    var v13291 = -1;
    var v13292 = -1;
    var v13293 = -1;
    if (p16415) {
      var v13294 = p16412.loadout.indexOf(vParseInt48);
      var v13301 = v13285.ammo != null && game.mode && game.mode.ammoLimit != null ? game.mode.ammoLimit : v13285.ammo;
      if (v13294 >= 0) {
        p16412.ammos[v13294] = v13301;
        p16412.reserveAmmos[v13294] = v13301 * game.getReserveMags(v13285);
        p16412.upgrades[v13294] = ~~!!p16414;
      } else {
        var v13296 = p16412.perks.includes(6) ? 3 : 2;
        var v13297 = p16412.loadout.indexOf(12);
        if (v13285.equipment) {
          var v13302 = 0;
          p16412.loadout.splice(v13302, 0, v13285.id);
          p16412.ammos.splice(v13302, 0, v13301);
          p16412.reserveAmmos.splice(v13302, 0, v13301 * game.getReserveMags(v13285));
          p16412.upgrades.splice(v13302, 0, ~~!!p16414);
          v13294 = Math.max(v13302, 0);
        } else if (p16412.loadout.length > v13296) {
          var v13298 = p16412.loadoutIndex == v13297 ? 0 : p16412.loadoutIndex;
          p16412.loadout[v13298] = vParseInt48;
          p16412.ammos[v13298] = v13301;
          p16412.reserveAmmos[v13298] = v13301 * game.getReserveMags(v13285);
          p16412.upgrades[v13298] = ~~!!p16414;
          if (v13294 != v13298) {
            v13294 = v13298;
          }
        } else {
          var v13302 = v13297 == -1 ? p16412.loadout.length - 1 : v13297;
          p16412.loadout.splice(v13302, 0, v13285.id);
          p16412.ammos.splice(v13302, 0, v13301);
          p16412.reserveAmmos.splice(v13302, 0, v13301 * game.getReserveMags(v13285));
          p16412.upgrades.splice(v13302, 0, ~~!!p16414);
          v13294 = Math.max(v13302, 0);
        }
      }
      p16412.loadoutIndex = v13294;
    } else {
      var v13300;
      var v13301 = v13285.ammo;
      var vUndefined10 = undefined;
      for (var vLN02377 = 0; vLN02377 < p16412.loadout.length; vLN02377++) {
        v13300 = game.weaponConfig[p16412.loadout[vLN02377]];
        if (v13300) {
          if (!v13300.id == v13285.id) {
            return;
          }
          if (v13300.secondary || v13300.melee || v13300.equipment) {
            if (v13300.secondary) {
              v13291 = vLN02377;
            } else if (v13300.melee) {
              v13292 = vLN02377;
            } else if (v13300.equipment) {
              v13293 = vLN02377;
            }
          } else {
            v13290 = vLN02377;
          }
          if (v13286 && !v13300.secondary && !v13300.melee && !v13300.equipment) {
            p16412.loadout[vLN02377] = v13285.id;
            vUndefined10 = vLN02377;
            break;
          } else if (v13287 && v13300.secondary) {
            p16412.loadout[vLN02377] = v13285.id;
            vUndefined10 = vLN02377;
            break;
          } else if (v13288 && v13300.melee) {
            p16412.loadout[vLN02377] = v13285.id;
            vUndefined10 = vLN02377;
            break;
          } else if (v13289 && v13300.equipment) {
            p16412.loadout[vLN02377] = v13285.id;
            vUndefined10 = vLN02377;
            break;
          }
        }
      }
      if (vUndefined10 != null) {
        p16412.ammos[vUndefined10] = v13301;
        p16412.reserveAmmos[vUndefined10] = v13301 * game.getReserveMags(v13285);
        p16412.upgrades[vUndefined10] = ~~!!p16414;
      } else {
        p16412.loadoutIndex = vUndefined10;
        if (v13288) {
          p16412.loadout.push(v13285.id);
          p16412.ammos.push(v13301);
          p16412.reserveAmmos.push(v13301 * game.getReserveMags(v13285));
          p16412.upgrades.push(~~!!p16414);
        } else {
          var v13302 = v13287 ? v13290 == -1 ? 0 : 1 : 0;
          p16412.loadout.splice(v13302, 0, v13285.id);
          p16412.ammos.splice(v13302, 0, game.weaponConfig[v13285.id].ammo);
          p16412.reserveAmmos.splice(v13302, 0, v13301 * game.getReserveMags(v13285));
          p16412.upgrades.splice(v13302, 0, ~~!!p16414);
        }
      }
    }
    let vA731 = [...p16412.ammos];
    let vA732 = [...p16412.reserveAmmos];
    let vA733 = [...p16412.upgrades];
    var v13303 = p16412.loadout.indexOf(12) == -1;
    p16412.updateLoadout(game, p16412.loadoutIndex, true, p16412.loadout, vA731, vA732, vA733, v13303);
    game.broadcast("inat", p16412.sid, p16412.loadout, p16412.loadoutIndex, undefined, undefined, false, true, undefined, vA731, vA732, vA733, v13303);
  };
  this.removeWeapon = function (p16416, p16417) {
    if (p16416 && serverIO) {
      var v13304 = p16416.loadout.indexOf(p16417);
      var v13305 = p16416.loadout.indexOf(12) == -1;
      if (v13304 != -1) {
        p16416.loadout.splice(v13304, 1);
        p16416.ammos.splice(v13304, 1);
        p16416.reserveAmmos.splice(v13304, 1);
        p16416.upgrades.splice(v13304, 1);
        if (v13304 < p16416.loadoutIndex) {
          p16416.loadoutIndex--;
        }
        let vA734 = [...p16416.ammos];
        let vA735 = [...p16416.reserveAmmos];
        let vA736 = [...p16416.upgrades];
        p16416.updateLoadout(game, p16416.loadoutIndex, true, p16416.loadout, vA734, vA735, vA736, v13305);
        game.broadcast("inat", p16416.sid, p16416.loadout, p16416.loadoutIndex, undefined, undefined, false, true, undefined, vA734, vA735, vA736, v13305);
      }
    }
  };
  this.replaceLoadout = function (p16418, p16419) {
    if (p16418 && serverIO) {
      p16418.updateLoadout(game, 0, true, p16419);
      game.broadcast("inat", p16418.sid, p16419, 0, undefined, undefined, false);
    }
  };
  this.clearLoadout = function (p16420) {
    if (p16420 && serverIO && (p16420.loadout.length != 1 || p16420.loadout[0] != 12)) {
      p16420.updateLoadout(game, 0, true, [12]);
      game.broadcast("inat", p16420.sid, [12], 0, undefined, undefined, false);
    }
  };
  this.enoughKR = function (p16421, p16422) {
    return !!p16421 && (p16421.isYou ? window.canAfford(p16422) : p16421.account && p16421.account.funds >= p16422);
  };
  var vLS115 = "";
  var vLS116 = "";
  var vO422 = {};
  var vA737 = [3, 10, 11, 12];
  var vO423 = {
    id: -1,
    type: -1
  };
  this.clearInteract = function (p16423) {
    if (p16423.isYou) {
      vO423.id = -1;
      vO423.type = -1;
      p16423.lastInteractData.id = -1;
      p16423.lastInteractData.type = -1;
      vO422.active = false;
      vO422.type = null;
      vO422.data = null;
      vO422.obj = {};
      vO422.priority = 0;
    }
  };
  this.changeInteract = function (p16424, p16425, p16426, p16427, p16428) {
    if (p16424.isYou) {
      if (!vA737.includes(p16426)) {
        vO423.id = p16425 ? p16425.isPlayer ? p16425.sid : p16425.uid : -1;
        vO423.type = p16426;
      }
      if (p16425 && p16425.noMsg) {
        return;
      }
      vO422.enabled = true;
      vO422.active = true;
      if (p16428 == null && p16426 != vO422.type || (p16428 || 0) >= (vO422.priority || 0)) {
        vO422.priority = p16428;
        vO422.type = p16426;
        vO422.data = p16427;
        vO422.obj = p16425 || {};
      }
    }
  };
  this.updateInteract = function (p16429) {
    if (p16429.isYou) {
      p16429.lastInteractData.id = vO423.id;
      p16429.lastInteractData.type = vO423.type;
    }
    if (vO422.enabled && interactMsg) {
      var v13306 = game.controls && game.controls.isMobile;
      var v13307 = (v13306 ? 77 : 220) + "px";
      if (p16429.isYou) {
        if (vO422.active) {
          var vLS117 = "";
          if (vO422.type == 0) {
            if (v13306) {
              vLS117 = "window.pressButton(" + game.controls.binds.interact.val + ");";
            }
            var v13318 = vO422.obj.method || 0;
            var v13331 = v13318 < 2 && p16429.score >= vO422.obj.scoreP || v13318 == 2 && p16429.killsC >= vO422.obj.scoreP || v13318 == 3 && p16429.level || v13318 == 4 && p16429.featured || v13318 == 5 && p16429.premiumT > 0 || v13318 == 6 && p16429.partner >= 2 || v13318 == 7 && p16429.level >= vO422.obj.scoreP;
            vLS115 = (v13306 ? "Tap" : "Press <span style=\"color:" + COLORS.interactPopup.key + "\">[" + UTILS.getKeyName(game.controls.binds.interact.val) + "]</span>") + " to " + (vO422.obj.interactMsg || (!vO422.obj.active && vO422.obj.closeable ? "Close" : "Open") + " gate") + (vO422.obj.scoreP != 0 || v13318 > 2 ? " <span style='color:" + (v13331 ? COLORS.interactPopup.enough : COLORS.interactPopup.notEnough) + "'>[" + (v13318 > 2 && v13318 != 7 ? (v13318 == 3 ? "Account" : v13318 == 4 ? "Verified" : v13318 == 5 ? "Premium" : "Partner") + " Only" : (v13318 == 7 ? "Level " : "") + vO422.obj.scoreP || 0) + (v13318 == 2 ? " Kills" : "") + "]</span>" : "");
          } else if (vO422.type == 1) {
            vLS115 = "<span style='color:" + COLORS.interactPopup.notEnough + "'>[" + UTILS.commaFormatNum(vO422.obj.deposited || 0) + "]</span><div style='color: #fff;margin-top:-30px;'>Press <span style='color:" + COLORS.interactPopup.key + "'>[" + UTILS.getKeyName(game.controls.binds.interact.val) + "]</span> to Deposit - " + (vO422.obj.depositAmnt || "All") + "</div><div style='color: #fff;margin-top:-30px;'>Press <span style='color:" + COLORS.interactPopup.key + "'>[" + UTILS.getKeyName(game.controls.binds.secondaryInteract.val) + "]</span> to Withdraw - " + (vO422.obj.withdrawAmnt || "All") + "</div>";
          } else if (vO422.type == 2) {
            ;
          } else if (vO422.type == 3) {
            vLS115 = "Press <span style=\"color:" + COLORS.interactPopup.key + "\">";
            if (vO422.data == 1) {
              vLS115 += "[" + UTILS.getKeyName(10001) + "]</span> to Plant";
            } else if (vO422.data == 2) {
              vLS115 += "[" + UTILS.getKeyName(game.controls.binds.equip.val) + "]</span> to Equip Bomb";
            } else if (vO422.data == 3) {
              vLS115 += "[" + UTILS.getKeyName(10001) + "]</span> to Diffuse";
            }
          } else if (vO422.type == 4) {
            if (v13306) {
              vLS117 = "window.pressButton(10001);";
            }
            vLS115 = (v13306 ? "Hold" : "Hold <span style=\"color:" + COLORS.interactPopup.key + "\">[" + UTILS.getKeyName(10001) + "]</span>") + " to " + (vO422.obj.interactMsg || "Interact");
          } else if (vO422.type == 5) {
            if (v13306) {
              vLS117 = "window.pressButton(" + game.controls.binds.interact.val + ");";
            }
            vLS115 = (v13306 ? "Tap" : "Press <span style=\"color:" + COLORS.interactPopup.key + "\">[" + UTILS.getKeyName(game.controls.binds.interact.val) + "]</span>") + " to Trade with <span style='color:#9eeb56'>[" + (vO422.obj.fakeName || (vO422.obj.premiumT ? vO422.obj.alias : vO422.obj.name)) + "]</span>";
          } else if (vO422.type == 6) {
            if (v13306) {
              vLS117 = "window.pressButton(" + game.controls.binds.interact.val + ");";
            }
            var v13310 = p16429.loadout.indexOf(vO422.obj.pickup);
            var v13311 = v13310 >= 0 && p16429.upgrades[v13310];
            var v13312 = v13311 ? game.upgradeWeapons[vO422.obj.pickup] : game.weaponConfig[vO422.obj.pickup];
            var v13318 = vO422.obj.method || 0;
            var v13314 = game.mode && game.mode.unrestrictedWeapons;
            var v13315 = v13314 && v13310 >= 0 & v13318 < 2 ? v13311 ? 4500 : Math.ceil(vO422.obj.scoreP / 2) : vO422.obj.scoreP;
            var v13331 = v13318 < 2 && p16429.score >= v13315 || v13318 == 2 && p16429.killsC >= vO422.obj.scoreP || v13318 == 3 && p16429.level || v13318 == 4 && p16429.featured || v13318 == 5 && p16429.premiumT > 0 || v13318 == 6 && p16429.partner >= 2 || v13318 == 7 && p16429.level >= vO422.obj.scoreP;
            vLS115 = (v13306 ? "Tap" : "Press <span style=\"color:" + COLORS.interactPopup.key + "\">[" + UTILS.getKeyName(game.controls.binds.interact.val) + "]</span>") + " to " + (v13314 && v13318 < 2 ? "buy " + v13312.name + (v13310 >= 0 ? " ammo" : "") : vO422.obj.interactMsg || "pickup " + v13312.name) + (v13315 != 0 || v13318 > 2 ? " <span style='color:" + (v13331 ? COLORS.interactPopup.enough : COLORS.interactPopup.notEnough) + "'>[" + (v13318 > 2 && v13318 != 7 ? (v13318 == 3 ? "Account" : v13318 == 4 ? "Verified" : v13318 == 5 ? "Premium" : "Partner") + " Only" : (v13318 == 7 ? "Level " : "") + v13315 || 0) + (v13318 == 2 ? " Kills" : "") + "]</span>" : "");
          } else if (vO422.type == 7) {
            var v13322 = p16429.pendingTrigger == vO422.obj.uid;
            if (v13306) {
              vLS117 = "window.pressButton(" + game.controls.binds[v13322 ? "confirm" : "interact"].val + ");";
            }
            vLS115 = (v13306 ? "Tap" : "Press <span style=\"color:" + COLORS.interactPopup.key + "\">[" + UTILS.getKeyName(game.controls.binds[v13322 ? "confirm" : "interact"].val) + "]</span>") + " to " + (v13322 ? "Confirm" : vO422.obj.interactMsg || "Interact");
            var v13318 = vO422.obj.trigActM || 0;
            if (vO422.obj.trigActCost || v13318 > 3) {
              var v13331 = v13318 == 0 ? window.canAfford(vO422.obj.trigActCost || 0) : v13318 < 3 && p16429.score >= (vO422.obj.trigActCost || 0) || v13318 == 3 && p16429.killsC >= (vO422.obj.trigActCost || 0) || v13318 == 4 && p16429.level || v13318 == 5 && p16429.featured || v13318 == 6 && p16429.premiumT > 0 || v13318 == 7 && p16429.partner >= 2 || v13318 == 8 && p16429.level >= (vO422.obj.trigActCost || 0);
              var v13320 = v13318 == 0 ? " KR" : v13318 == 3 ? " Kills" : "";
              vLS115 += (vO422.obj.trigActCost || 0) != 0 || v13318 > 3 ? " <span style='color:" + (v13331 ? COLORS.interactPopup.enough : COLORS.interactPopup.notEnough) + "'>[" + (v13318 > 3 && v13318 != 8 ? (v13318 == 4 ? "Account" : v13318 == 5 ? "Verified" : v13318 == 6 ? "Premium" : "Partner") + " Only" : (v13318 == 8 ? "Level " : "") + vO422.obj.trigActCost || 0) + v13320 + "]</span>" : "";
            }
          } else if (vO422.type == 9) {
            var v13321 = game.store.wheels[vO422.obj.wheel];
            var v13322 = p16429.pendingSpin == vO422.obj.uid;
            if (v13306) {
              vLS117 = "window.pressButton(" + game.controls.binds[v13322 ? "confirm" : "interact"].val + ");";
            }
            vLS115 = (v13306 ? "Tap" : "Press <span style=\"color:" + COLORS.interactPopup.key + "\">[" + UTILS.getKeyName(game.controls.binds[v13322 ? "confirm" : "interact"].val) + "]</span>") + " to " + (v13322 ? "Confirm" : vO422.obj.interactMsg || "Spin") + " " + v13321.name;
            var v13331 = window.canAfford(v13321.price);
            vLS115 += " <span style='color:" + (v13331 ? COLORS.interactPopup.enough : COLORS.interactPopup.notEnough) + "'>[" + v13321.price + " KR]</span>";
          } else if (vO422.type == 10) {
            if (v13306) {
              vLS117 = "window.pressButton(" + game.controls.binds.interact.val + ");";
            }
            vLS115 = (v13306 ? "Hold" : "Hold <span style=\"color:" + COLORS.interactPopup.key + "\">[" + UTILS.getKeyName(game.controls.binds.interact.val) + "]</span>") + " to Claim <span style='color:" + vO422.obj.rarCol + "'>" + vO422.obj.name + "</span>";
          } else if (vO422.type == 11) {
            v13307 = "50%";
            if (v13306) {
              vLS117 = "window.pressButton(" + game.controls.binds.interact.val + ");";
            }
            vLS115 = (v13306 ? "Tap" : "Press <span style=\"color:" + COLORS.interactPopup.key + "\">[" + UTILS.getKeyName(game.controls.binds.interact.val) + "]</span>") + " to view on Opensea";
          } else if (vO422.type == 12) {
            vLS115 = vO422.data;
          } else if (vO422.type == 13) {
            if (v13306) {
              vLS117 = "window.pressButton(" + game.controls.binds.interact.val + ");";
            }
            var v13329 = vO422.obj.state >= 2 && vO422.obj.pendingWeapon != null;
            var v13330 = game.fireSaleTimer ? 10 : p16429.sharingIsCaring ? Math.ceil(vO422.obj.scoreP / 2) : vO422.obj.scoreP;
            var v13331 = p16429.score >= v13330;
            vLS115 = (v13306 ? "Tap" : "Press <span style=\"color:" + COLORS.interactPopup.key + "\">[" + UTILS.getKeyName(game.controls.binds.interact.val) + "]</span>") + (v13329 ? " for weapon" : " for a Random Weapon <span style='color:" + (v13331 ? COLORS.interactPopup.enough : COLORS.interactPopup.notEnough) + "'>[Cost " + (v13330 || 0) + "]</span>");
          } else if (vO422.type == 14) {
            if (p16429.perks.length >= config.maxZombiePerks) {
              vLS115 = "<span style='color:" + COLORS.interactPopup.notEnough + "'>Perk limit reached</span>";
            } else {
              if (v13306) {
                vLS117 = "window.pressButton(" + game.controls.binds.interact.val + ");";
              }
              var v13330 = vO422.obj.scoreP;
              var v13331 = p16429.score >= v13330;
              vLS115 = (v13306 ? "Tap" : "Press <span style=\"color:" + COLORS.interactPopup.key + "\">[" + UTILS.getKeyName(game.controls.binds.interact.val) + "]</span>") + " to buy " + config.zombiePerks[vO422.obj.perk] + " <span style='color:" + (v13331 ? COLORS.interactPopup.enough : COLORS.interactPopup.notEnough) + "'>[Cost " + (v13330 || 0) + "]</span>";
            }
          } else if (vO422.type == 15) {
            if (v13306) {
              vLS117 = "window.pressButton(" + game.controls.binds.interact.val + ");";
            }
            var v13329 = vO422.obj.state >= 2 && vO422.obj.pendingWeapon != null;
            var v13330 = vO422.obj.scoreP;
            var v13331 = p16429.score >= v13330;
            vLS115 = (v13306 ? "Tap" : "Press <span style=\"color:" + COLORS.interactPopup.key + "\">[" + UTILS.getKeyName(game.controls.binds.interact.val) + "]</span>") + (v13329 ? " to take your upgraded weapon" : " to Krum It <span style='color:" + (v13331 ? COLORS.interactPopup.enough : COLORS.interactPopup.notEnough) + "'>[Cost " + (v13330 || 0) + "]</span>");
          }
          if (vLS116 != vLS115) {
            vLS116 = vLS115;
            interactMsg.innerHTML = vLS115;
          }
          if (v13306 && interactMsg.getAttribute("ontouchstart") != vLS117) {
            interactMsg.setAttribute("ontouchstart", vLS117);
          }
        }
        if (!vO422.active && interactMsg.innerHTML != "") {
          interactMsg.innerHTML = "";
          interactMsg.setAttribute("ontouchstart", "");
          vLS116 = "";
        }
        var v13332 = vO422.active ? "block" : "none";
        if (interactMsg.style.display != v13332) {
          interactMsg.style.display = v13332;
        }
        if (interactMsg.style.bottom != v13307) {
          interactMsg.style.bottom = v13307;
        }
      }
    }
  };
  var vA738 = [];
  this.syncLeaders = function (p16430, p16431) {
    if (p16430) {
      var v13333 = game && game.mode && game.mode.showAllLeaders;
      var v13334 = game.mode.leaderStats || ["score"];
      var v13335 = this.list.slice().filter(p16432 => p16432 && (!p16432.isBot || p16432.isBot && !game.mode.botsAsAI));
      v12910 = game.mode.killSort ? v13335.sort(UTILS.orderByKills) : game.mode.leaderSort ? v13335.sort(game.mode.leaderSort) : v13335.sort(UTILS.orderByScore);
      for (var vLN02378 = 0; vLN02378 < game.players.list.length; vLN02378++) {
        vA738.length = 0;
        var vLN02379 = 0;
        if ((p16431 == null || p16431 == game.players.list[vLN02378].id) && (!game.players.list[vLN02378].isBot || !game.mode.botsAsAI)) {
          for (var vLN02380 = 0; vLN02380 < v12910.length; ++vLN02380) {
            if ((v13333 || !v12910[vLN02380].spectating) && vLN02379 < 16) {
              vLN02379++;
              vA738.push(v12910[vLN02380].sid);
              for (var vLN02381 = 0; vLN02381 < v13334.length; ++vLN02381) {
                vA738.push(config.endForm[v13334[vLN02381]] ? config.endForm[v13334[vLN02381]](v12910[vLN02380][v13334[vLN02381]], game, v12910[vLN02380]) : v12910[vLN02380][v13334[vLN02381]]);
              }
            }
          }
          game.players.list[vLN02378].send("7", vA738);
        }
      }
      game.leadersUpdated = false;
    } else {
      game.leadersUpdated = true;
    }
  };
  this.resetToStart = function (p16433) {
    if (game.mode && game.mode.allowReset && p16433 && p16433.initPos) {
      this.endGrapple(p16433);
      p16433.timeLog = 0;
      p16433.gameTime = 0;
      p16433.lastTimer = null;
      p16433.resetTimer = 250;
      p16433.x = p16433.initPos.x;
      p16433.y = p16433.initPos.y;
      p16433.z = p16433.initPos.z;
      p16433.velocity.x = 0;
      p16433.velocity.y = 0;
      p16433.velocity.z = 0;
      p16433.coverDis = 0;
      p16433.scoreObjs = {};
      if (game.isServer) {
        p16433.send("t", "00:00.0");
        this.score(p16433, 0, 0, true);
        p16433.checkPoint = null;
        p16433.checkPointList.length = 0;
        p16433.send("chp", true);
      }
      if (!serverIO) {
        SOUND.play("bhop_reset", 0.9);
        if (game.mode.custUI) {
          game.mode.custUI(game, config, true);
        }
      }
    }
  };
  this.resetToLast = function (p16434) {
    if (game.mode && game.mode.allowReset && p16434) {
      let v13336 = game.map.manager.objects[p16434.checkPoint];
      if (!v13336) {
        return;
      }
      this.endGrapple(p16434);
      let v13337 = p16434.checkPointData;
      p16434.resetTimer = 250;
      p16434.x = v13336.x;
      p16434.y = v13336.y - v13336.height + 0.01;
      p16434.z = v13336.z;
      p16434.velocity.x = 0;
      p16434.velocity.y = 0;
      p16434.velocity.z = 0;
      let v13338 = v13336.forceDir ? v13336.dir : undefined;
      if (v13338 != null) {
        p16434.xDire = -((v13338 || 0) + 1) * Math.PI / 2;
        if (p16434.isYou) {
          game.controls.object.rotation.y = p16434.xDire;
          game.controls.xDr = game.controls.object.rotation.y % Math.PI2;
        }
      }
      if (game.config.lstChkT) {
        p16434.timeLog = v13337[0] || 0;
        p16434.gameTime = v13337[1] || 0;
        p16434.lastTimer = UTILS.getTime(p16434.gameTime, true, true, 1000, parseInt(p16434.gameTime) >= 86400000, 2);
        if (game.isServer) {
          p16434.send("t", p16434.lastTimer);
        }
      }
      if (!serverIO) {
        SOUND.play("bhop_reset", 0.9);
      }
    }
  };
  this.logTime = function (p16435) {
    if (game.isServer && game.doLogTime) {
      p16435.timeLog++;
      var v13339 = game.gameTimer;
      if (game.mode && game.mode.ownTime && game.canOwnTime) {
        v13339 = p16435.gameTime;
      }
      p16435.send("gt", v13339, p16435.timeLog);
      if (p16435.timeLog == game.map.manager.scorezones.length) {
        var v13340 = UTILS.getTime(v13339, true, parseInt(v13339) >= 3600000, 1000, parseInt(v13339) >= 86400000, 2);
        game.broadcast("ch", 0, null, p16435.name + " finished in " + v13340, 2);
        p16435.send("t", v13340);
      }
    }
  };
  this.teamScore = function (p16436, p16437) {
    game.giveTeamScore(p16436.team, p16437);
  };
  this.saveClassScores = function (p16438) {
    var v13341;
    if (p16438.classScores && game.isPubType()) {
      for (var vLN02382 = 0; vLN02382 < game.config.classes.length; ++vLN02382) {
        v13341 = game.config.classes[vLN02382];
        if (p16438.classScores[v13341]) {
          if (!p16438.account.stats["c" + v13341]) {
            p16438.account.stats["c" + v13341] = 0;
          }
          p16438.account.stats["c" + v13341] += p16438.classScores[v13341];
        }
      }
    }
  };
  this.saveWeaponStats = function (p16439) {
    var v13342;
  };
  this.giveAssist = function (p16440) {
    if (p16440) {
      p16440.assists++;
      game.incStat("ast", p16440);
      game.challenges.update(game, "ast", 1, null, p16440);
      this.score(p16440, config.assistScore, 1);
      p16440.send("10");
      game.incMedal("Assist", p16440);
    }
  };
  this.score = function (p16441, p16442, p16443, p16444) {
    if (p16441 && game && game.isServer) {
      var v13343 = (p16441.account ? p16441.account.score || 0 : 0) + p16441.score;
      if (p16441.attributes && p16441.attributes.xpMlt) {
        p16442 = parseInt(p16442 * p16441.attributes.xpMlt);
      }
      if (p16443 == 1 && game && game.mode && game.mode.killMlt) {
        p16442 = Math.ceil(p16442 * (game.mode.killMlt + p16441.killMlt));
      }
      if (p16443 == 1 && game && game.mode && game.mode.oneflag) {
        var v13344 = game.mode.teams && game.flagTeam == p16441.team;
        var v13345 = game.flagCarrier == p16441.sid;
        p16442 = Math.ceil(p16442 * (v13345 ? game.mode.carrierMlt : v13344 ? game.mode.teamCarrierMlt : game.mode.nonCarrierMlt));
      }
      if (game.isDoubleXP) {
        p16442 *= 2;
      }
      if (game.doublePointsTimer && p16442 > 0) {
        p16442 *= 2;
      }
      if (p16444) {
        p16441.score = p16442;
      } else if (p16443 != 1 || !game.mode.noScoreK) {
        p16441.score += p16442;
        if (p16441.active) {
          p16441.scoreL += p16442;
        }
      }
      if (game.isPubType() && p16441.score > 13000 && (!p16441.account || !p16441.account.isDev) && (!game || !game.mode || !game.mode.noScrLimit)) {
        p16441.score = 13000;
        p16442 = 0;
      }
      var v13346 = game.config.keepTScore && p16443 != 2;
      if (game && game.mode && (game.mode.objective || game.mode.oneflag) && p16443 != 1 && !v13346) {
        if (p16444) {
          p16441.objectiveScore = p16442;
        } else {
          p16441.objectiveScore += p16442;
        }
      }
      var v13347;
      if (game && game.isPubType() && (!game.mode || !game.mode.noClassScr) && !p16444) {
        var v13348 = !!game.mode && game.mode.randClassScr != null;
        var v13349 = v13348 ? UTILS.getRandom(game.config.classes) : p16441.classIndex;
        var v13350 = Math.floor(p16442 * (game && game.isDoubleClassXP ? 2 : 1) * (v13348 ? game.mode.randClassScr : 1));
        if (!p16441.classScores) {
          p16441.classScores = [];
        }
        if (!p16441.classScores[v13349 || 0]) {
          p16441.classScores[v13349 || 0] = 0;
        }
        p16441.classScores[v13349 || 0] += v13350;
        v13347 = v13349;
      }
      if (p16441 && p16441.send) {
        p16441.send("5", p16442, false, !!p16444, v13347);
      }
      for (var vLN02383 = 0; vLN02383 < this.list.length; ++vLN02383) {
        if (this.list[vLN02383] && this.list[vLN02383].send && this.list[vLN02383].specStream == p16441.sid) {
          this.list[vLN02383].send("5", p16442, 1, !!p16444);
        }
      }
      this.syncLeaders();
      if (game && game.mode && game.mode.teams && p16441.team && game.teamScores && !v13346 && !game.mode.noScoreC && (p16443 != 1 || !game.mode.objective && !game.mode.oneflag)) {
        this.teamScore(p16441, p16442);
      }
      if (game) {
        game.challenges.update(game, "score", p16442, null, p16441);
      }
      if (p16441.account && game.isPubType()) {
        var v13351 = p16441.account.score + p16441.score;
        if (v13343 >= v13351) {
          return;
        }
        var v13352 = Math.max(1, Math.floor(config.rankVar * Math.sqrt(v13343)));
        var v13353 = Math.max(1, Math.floor(config.rankVar * Math.sqrt(v13351)));
        if (v13353 > v13352) {
          p16441.send("am", [39, "Lvl " + v13353, 1, 1]);
        }
      }
    }
  };
  this.tickPlayer = function (p16445, p16446) {
    if (p16445) {
      p16445.playTime += p16446;
      if (game.doLogTime && game.mode && game.mode.ownTime && p16445.coverDis >= 1 && game.canOwnTime && (p16445.gameTime += p16446, !game.mode.logTime || p16445.timeLog < game.map.manager.scorezones.length)) {
        var v13354 = UTILS.getTime(p16445.gameTime, game.mode.showMS, parseInt(p16445.gameTime) >= 3600000, 100, parseInt(p16445.gameTime) >= 86400000);
        if (v13354 != p16445.lastTimer) {
          p16445.lastTimer = v13354;
          p16445.send("t", UTILS.getTime(p16445.gameTime, game.mode.showMS, parseInt(p16445.gameTime) >= 3600000, 1000, parseInt(p16445.gameTime) >= 86400000, 2));
        }
      }
      if (p16445.hitTimer > 0) {
        p16445.hitTimer -= p16446;
      }
      p16445.ticker -= p16446;
      if (p16445.ticker <= 0 && (p16445.ticker = 500, p16445.tickerC++, p16445.hitTimer <= 0 && !p16445.challMode && !p16445.isJuggernaut && p16445.regen && this.changeHealth(p16445, null, -(p16445.maxHealth * (p16445.regen || 0))), game.isServer && p16445.attributes.enraged && p16445.tickerC % 8 == 0 && this.changeHealth(p16445, null, p16445.attributes.enraged) && this.kill(p16445), game.isServer && p16445.attributes.zap && p16445.tickerC % 2 == 0)) {
        p16445.send("so", game.getSoundIndex("zap_0"), 0.5, 1, null, null, null, UTILS.randFloat(1, 1.75));
        var v13355 = p16445.zappedBy ? game.players.findBySid(p16445.zappedBy) : null;
        if (this.changeHealth(p16445, v13355, p16445.attributes.zap)) {
          this.kill(p16445, v13355 || null, {
            wId: 24
          });
        }
      }
      for (var vLN02384 = 0; vLN02384 < p16445.attributeTimers.length; vLN02384++) {
        if (p16445.attributeTimers[vLN02384].length) {
          for (var v13356 = p16445.attributeTimers[vLN02384].length - 1; v13356 >= 0; --v13356) {
            p16445.attributeTimers[vLN02384][v13356] -= p16446;
            if (p16445.attributeTimers[vLN02384][v13356] <= 0) {
              p16445.attributeTimers[vLN02384].splice(v13356, 1);
              game.players.removeEffect(p16445, vLN02384, 1);
            }
          }
        }
      }
      if (p16445.y <= game.map.deathY && !p16445.godMode) {
        if (p16445.flag) {
          game.resetFlag(p16445.flag);
          p16445.flag = null;
        }
        this.kill(p16445);
      }
    }
  };
  this.updateAssetID = function (p16447, p16448) {
    p16448 += "";
    if (p16447.config.mdl && p16448.length) {
      p16447.assetTxt = p16448;
      if (game.isServer) {
        game.broadcast("uai", p16447.sid, p16448);
      }
      if (p16447.active) {
        this.regenMeshes(p16447);
      }
    }
  };
  this.setHealth = function (p16449, p16450) {
    if (!p16449.godMode && UTILS.isNumber(p16450)) {
      var v13357 = p16449.health;
      p16449.health = p16450;
      if (!UTILS.isNumber(p16449.health)) {
        p16449.health = v13357;
      }
      p16449.send("h", Math.ceil(p16449.health));
      for (var vLN02385 = 0; vLN02385 < this.list.length; ++vLN02385) {
        if (this.list[vLN02385] && this.list[vLN02385] != p16449) {
          this.list[vLN02385].send("h", Math.ceil(p16449.health), p16449.sid);
        }
      }
      return p16449.health <= 0;
    }
  };
  this.changeHealth = function (p16451, p16452, p16453, p16454, p16455) {
    if ((!game.waitTimers || game.waitTimers[0].canDMG) && (p16452 && p16452.team && (p16453 *= game.config["t" + p16452.team + "Dmg"] || 0), !!UTILS.isNumber(p16453)) && (!(p16453 < 0) || p16451.health != p16451.maxHealth) && (p16452 && p16452.account && p16452.account.hack && p16453 && (p16453 *= 0), p16452 && p16452.noDmg && (p16453 *= 0), p16452 && p16452.isHacker && (p16453 *= 0), !!p16454 || !(p16453 > 0) || !!game.mode.dmgTeam || !!game.config.frFire || !p16451.team || !p16452 || p16451.team != p16452.team || !(p16453 > 0))) {
      p16453 = p16453.round(1);
      var v13358 = p16453 <= 0 ? 0 : Math.max(p16453 > p16451.health ? p16451.health : p16453, 0);
      var v13359 = p16451.health;
      p16451.health -= p16453;
      p16451.health = Math.max(Math.min(p16451.maxHealth, p16451.health), 0);
      if (p16451.godMode) {
        p16451.health = p16451.maxHealth;
      }
      if (p16451.isBot && game.bots && game.bots.config && game.bots.config.godMode) {
        p16451.health = p16451.maxHealth;
      }
      if (!UTILS.isNumber(p16451.health)) {
        p16451.health = v13359;
        return;
      }
      if (p16452 && p16452.isPlayer && p16452 != p16451) {
        p16452.send("4", p16451.sid, p16453, p16455, !!(v13359 - p16453 <= 0));
      }
      if (p16451.dummy) {
        return true;
      }
      if (p16453 > 0) {
        p16451.hitTimer = p16451.regenDelay || 0;
      }
      if (p16452 && p16452.isPlayer) {
        if (p16451) {
          p16451.send("h", p16451.health, null, Math.round(p16452.x), Math.round(p16452.z));
        }
        if (p16452 != p16451 && v13358 > 0) {
          p16452.dmgDealt += v13358;
          if (p16451.dmgReceived[p16452.id]) {
            p16451.dmgReceived[p16452.id].val += v13358;
            p16451.dmgReceived[p16452.id].time = game.now;
          } else {
            p16451.dmgReceived[p16452.id] = {
              time: game.now,
              val: v13358
            };
          }
        }
      } else if (p16452) {
        if (p16451) {
          p16451.send("h", p16451.health, null, Math.round(p16452.x), Math.round(p16452.z));
        }
      } else if (p16451) {
        p16451.send("h", p16451.health);
      }
      for (var vLN02386 = 0; vLN02386 < this.list.length; ++vLN02386) {
        if (this.list[vLN02386] && this.list[vLN02386] != p16451) {
          this.list[vLN02386].send("h", p16451.health, p16451.sid);
        }
        if (p16452 && p16452.isPlayer && p16452 != p16451 && p16453 > 0 && this.list[vLN02386] && this.list[vLN02386].specStream == p16452.sid) {
          this.list[vLN02386].send("4", p16451.sid, p16453, p16455);
        }
      }
      if (p16453 > 0 && !(p16451.health <= 0)) {
        game.playerTrigger("onPlayerDamage", p16451);
        if (game && game.mainScript && game.mainScript.onPlayerDamage) {
          game.mainScript.onPlayerDamage(p16451.id + "", p16452 ? p16452.id + "" : "", p16453);
        }
      }
      return p16451.health <= 0;
    }
  };
  this.changePosition = function (p16456, p16457, p16458, p16459, p16460, p16461, p16462, p16463) {
    if (p16456) {
      p16456.oldX = p16457;
      p16456.oldY = p16458;
      p16456.oldZ = p16459;
      p16456.x = p16457;
      p16456.y = p16458;
      p16456.z = p16459;
      if (p16462 != null) {
        p16456.xDire = -((p16462 || 0) + 1) * Math.PI / 2;
        if (p16456.isYou) {
          game.controls.object.rotation.y = p16456.xDire;
          game.controls.xDr = game.controls.object.rotation.y % Math.PI2;
        }
      }
      if (p16461) {
        p16456.lastX = p16457;
        p16456.lastY = p16458;
        p16456.lastZ = p16459;
        p16456.stepVal = 0;
        p16456.velocity.x = 0;
        p16456.velocity.y = 0;
        p16456.velocity.z = 0;
      }
      this.endGrapple(p16456);
      if (p16460) {
        p16456.doRecon = true;
      }
      if (p16463) {
        game.broadcast("chgp", p16456.id, p16457, p16458, p16459, p16460, p16461, p16462);
      }
    }
  };
  this.swapSecondary = function (p16464, p16465) {
    if (!(p16464.ammos.length <= 1)) {
      var v13360 = game.mode && game.mode.unrestrictedWeapons;
      for (var vLN02387 = 0; vLN02387 < p16464.ammos.length; ++vLN02387) {
        var v13361 = p16464.loadout[vLN02387];
        var v13362 = !(p16464.loadoutIndex > p16464.ammos.length - 2);
        if (game.weaponConfig[v13361] && (v13360 ? !game.weaponConfig[v13361].melee && (v13362 ? p16464.loadoutIndex < vLN02387 : p16464.loadoutIndex != vLN02387) : game.weaponConfig[v13361].secondary) && (p16464.loadoutIndex == vLN02387 ? this.swapWeapon(p16464, null, null, undefined, 0, p16465) : this.swapWeapon(p16464, null, null, undefined, vLN02387, p16465), v13360)) {
          break;
        }
      }
    }
  };
  this.swapEquipment = function (p16466, p16467) {
    if (!(p16466.ammos.length <= 1)) {
      var v13363;
      for (var vLN02388 = 0; vLN02388 < p16466.ammos.length; ++vLN02388) {
        v13363 = p16466.loadout[vLN02388];
        if (game.weaponConfig[v13363] && game.weaponConfig[v13363].equipment) {
          if (p16466.loadoutIndex == vLN02388) {
            this.swapWeapon(p16466, null, null, undefined, 0, p16467);
          } else {
            this.swapWeapon(p16466, null, null, undefined, vLN02388, p16467);
          }
        }
      }
    }
  };
  this.swapMelee = function (p16468, p16469) {
    if (!(p16468.ammos.length <= 1)) {
      var v13364;
      for (var vLN02389 = 0; vLN02389 < p16468.ammos.length; ++vLN02389) {
        v13364 = p16468.loadout[vLN02389];
        if (game.weaponConfig[v13364] && game.weaponConfig[v13364].melee) {
          if (p16468.loadoutIndex == vLN02389) {
            this.swapWeapon(p16468, 1, false, undefined, undefined, p16469);
          } else {
            this.swapWeapon(p16468, null, null, undefined, vLN02389, p16469);
          }
        }
      }
    }
  };
  this.swapWeapon = function (p16470, p16471, p16472, p16473, p16474, p16475) {
    if ((!(p16470.ammos.length <= 1) || !p16471) && !(p16473 > p16470.ammos.length)) {
      var v13365 = p16470.loadoutIndex;
      var v13366 = p16470.loadout[v13365] != null && game.weaponConfig[p16470.loadout[v13365]] && game.weaponConfig[p16470.loadout[v13365]].noSwap;
      if (p16471 || p16472 || p16473 != v13365 || p16474 != null || p16475) {
        if (p16471) {
          if (p16471 != 1 && p16471 != -1) {
            p16471 = 0;
          }
          p16470.loadoutIndex += p16471;
          if (p16471 == 1) {
            if (p16470.loadoutIndex > p16470.ammos.length - 2) {
              p16470.loadoutIndex = 0;
            }
          } else if (p16470.loadoutIndex < 0) {
            p16470.loadoutIndex = Math.min(p16470.ammos.length - 1, p16470.weaponLimit);
          } else {
            p16470.loadoutIndex = 0;
          }
        }
        if (p16473 != null) {
          p16470.loadoutIndex = p16473;
        }
        if (p16474 != null) {
          p16470.loadoutIndex = p16474;
        }
        if ((p16471 != null || p16474 != null) && (v13365 != p16470.loadoutIndex || p16472)) {
          if (p16470.isYou) {
            this.resetReloadUIAnim();
          }
          p16470.reloadTimer = 0;
          p16470.cantShootTimer = 0;
          p16470.didShoot = false;
          p16470.burstCount = 0;
          p16470.chargeTime = 0;
          p16470.fullCharge = false;
        }
        var v13367 = p16470.loadout[p16470.loadoutIndex] != null && game.weaponConfig[p16470.loadout[p16470.loadoutIndex]] && game.weaponConfig[p16470.loadout[p16470.loadoutIndex]].noSwap;
        if (v13366 && !v13367) {
          p16470.loadoutIndex = v13365;
        }
        p16470.weapon = game.players.getWeapon(p16470, p16470.loadoutIndex);
        if (!p16470.weapon) {
          p16470.weapon = game.weaponConfig[p16470.loadout[0]];
          if (p16470.weapon) {
            p16470.loadoutIndex = 0;
          }
        }
        if (!p16475 && v13365 != p16470.loadoutIndex) {
          this.endGrapple(p16470);
        }
        if (v13365 != p16470.loadoutIndex || p16472) {
          if (RENDER) {
            this.cancelInspect(p16470);
          }
          for (var vLN02391 = 0; vLN02391 < p16470.weaponMeshes.length; ++vLN02391) {
            p16470.weaponMeshes[vLN02391].visible = false;
          }
          if (p16470.weaponMeshes[p16470.loadoutIndex]) {
            if (RENDER) {
              p16470.weaponMeshes[p16470.loadoutIndex].visible = !this.isWeaponHidden(p16470, p16470.loadoutIndex) || !p16470.renderYou;
              if (p16470.isYou) {
                if (p16470.weapon.melee) {
                  if (p16470.armMeshes[0]) {
                    p16470.armMeshes[0].visible = RENDER.showHands;
                  }
                  if (p16470.armMeshes[1]) {
                    if (!p16470.armMeshes[1].realMat) {
                      p16470.armMeshes[1].realMat = p16470.armMeshes[1].material;
                    }
                    p16470.armMeshes[1].material = RENDER.showHands ? p16470.armMeshes[1].realMat : RENDER.invisMat;
                  }
                } else if (p16470.mergedArmMeshes[p16470.loadoutIndex]) {
                  p16470.mergedArmMeshes[p16470.loadoutIndex].visible = RENDER.showHands;
                }
              }
            } else {
              p16470.weaponMeshes[p16470.loadoutIndex].visible = true;
            }
          }
        }
        if (p16473 == null && p16470.weapon && (!RENDER || p16470.isYou) && (p16470.isYou && v13365 == p16470.loadoutIndex && !p16472 || p16475 || (p16470.swapTime = p16470.weapon.swapTime), p16470.isYou && (v13365 != p16470.loadoutIndex || p16472))) {
          var v13368 = game.controls.toggleADS[(RENDER.vmSetts ? p16470.loadout[v13365] : -1) + 1];
          var v13369 = game.controls.toggleADS[(RENDER.vmSetts ? p16470.loadout[p16470.loadoutIndex] : -1) + 1];
          if (game.controls.adsToggled && v13368 && !v13369) {
            game.controls.adsToggled = false;
          }
          var vLS118 = "";
          var v13370 = p16470.loadout.toString() === p16470.lastLoadout.toString() && p16470.skins.toString() === p16470.lastSkins.toString() && weapHolder.innerHTML.length;
          for (var vLN02391 = 0; vLN02391 < p16470.ammos.length; ++vLN02391) {
            var v13371 = vLN02391 == p16470.loadoutIndex ? 1 : 0.5;
            var v13372 = game.players.getWeapon(p16470, vLN02391);
            if (v13372.icon) {
              var v13373 = game.store.skins[v13372.melee ? p16470.meleeIndex : p16470.getSkinForLoadout(vLN02391)];
              var v13374 = !!p16470.canThrow && !!v13372.melee && !!v13373 && !!v13373.local;
              var v13375 = UTILS.assetsUrl((p16470.canThrow && v13372.melee ? "/textures/melee/icon_" + (v13373 ? v13373.id || 0 : 0) : "/textures/weapons/" + v13372.icon) + ".png", undefined, v13374);
              if (v13372.assetIcon.length) {
                v13375 = UTILS.userAssetsUrl("/" + v13372.assetIcon.replace(/[^\d]/g, "") + "/texture.png");
              }
              if (v13370) {
                var v13376 = document.getElementById("weapItem_" + vLN02391);
                if (v13376.style.opacity != v13371) {
                  v13376.style.opacity = v13371;
                }
                v13376 = v13376.firstElementChild;
                if (p16470.lastThrow != p16470.canThrow) {
                  v13376.lastChild.src = v13375;
                }
                if (vLN02391 > 0 && !RENDER.isMobile) {
                  v13376.firstChild.textContent = v13372.melee ? UTILS.getKeyName(game.controls.binds.melee.val) : v13372.equipment ? UTILS.getKeyName(game.controls.binds.equip.val) : UTILS.getKeyName(game.controls.binds.swap.val);
                }
              } else {
                let v13377 = p16470.currentStreakWeapon == v13372.id && p16470.weaponStreak ? p16470.weaponStreak : 0;
                vLS118 += "<div class='weapItem' id='weapItem_" + vLN02391 + "' style='opacity:" + v13371 + "'><div class=\"weapItemInner\">" + (vLN02391 > 0 && !RENDER.isMobile ? "<div class='weapKey'>" + (v13372.melee ? UTILS.getKeyName(game.controls.binds.melee.val) : v13372.equipment ? UTILS.getKeyName(game.controls.binds.equip.val) : UTILS.getKeyName(game.controls.binds.swap.val)) + "</div>" : "") + ("<span class='weapSkin" + (v13373 && v13373.rarity == 5 ? " whiteShad" : "") + "' style='color:" + (v13373 ? game.store.rarities[v13373.rarity || 0].color : "#fff") + "'>" + (v13373 ? v13373.name : v13372.name) + "</span>") + "<div class='weapStreakHolder' data-weapon-index='" + v13372.id + "' style='display:" + (v13377 ? "block" : "none") + "'><div class='weapStreakInner'><span class='weapStreak'>" + v13377 + "</span><span style='color: var(--yellow)'>KS</span></div></div><img class='weapIcon' src='" + v13375 + "' " + (v13372.melee ? "id='weapIconMel' " : "") + "/></div></div>";
              }
            }
            if (v13372.melee) {
              p16470.lastThrow = p16470.canThrow;
            }
          }
          if (!p16475) {
            if (p16470.swapTween) {
              p16470.swapTween.stop();
            }
            p16470.swapTweenA = 0.5;
            p16470.swapTween = new TWEEN.Tween(p16470).to({
              swapTweenA: 1
            }, 1200).easing(TWEEN.Easing.Elastic.Out).start();
            if (v13365 != p16470.loadoutIndex && p16470.aimVal == 1) {
              if (p16470.swapTweenAnim) {
                p16470.swapTweenAnim.stop();
              }
              p16470.swapTweenR = p16470.weapon.swapWiggle || 0.6;
              p16470.swapTweenAnim = new TWEEN.Tween(p16470).to({
                swapTweenR: 0
              }, p16470.weapon.swapTime + 220).easing(TWEEN.Easing.Back.InOut).start();
            }
            if (v13365 != p16470.loadoutIndex) {
              if (p16470.weapon.swapSnd) {
                SOUND.play(p16470.weapon.swapSnd, 0.05);
              }
              if (p16470.meleeAnim.anim) {
                p16470.meleeAnim.anim.stop();
              }
              p16470.resetMeleeAnim();
              if (p16470.aimVal == 1) {
                p16470.meleeAnim.armR = -0.3;
                if (p16470.weapon.melee) {
                  if (p16470.currentMelee && (p16470.currentMelee.equipAnim || p16470.currentMelee.flipAnim)) {
                    p16470.meleeAnim.weaR = -(Math.PI * 4);
                  }
                  if (p16470.canThrow) {
                    SOUND.play("melee_equip", 0.06, false, 1.5);
                  }
                  p16470.meleeAnim.anim = new TWEEN.Tween(p16470.meleeAnim).to({
                    armR: 0,
                    weaR: 0
                  }, 310).easing(TWEEN.Easing.Sinusoidal.Out).start();
                }
              }
            }
          }
          if (!v13370) {
            weapHolder.innerHTML = vLS118;
          }
          p16470.lastLoadout = [...p16470.loadout];
          p16470.lastSkins = [...p16470.skins];
          this.updatePlayerAmmo(p16470);
          this.updatePlayerFov(p16470);
        }
      }
    }
  };
  this.taunt = function (p16476, p16477, p16478) {
    if (p16476 && p16476.active && config.taunts[p16477] && (p16478 || !p16476.lastTaunt || game.now - p16476.lastTaunt >= 0)) {
      p16476.lastTaunt = game.now + config.taunts[p16477].tm;
      game.playSound(config.taunts[p16477].id, 0.3, p16476.sid, p16476.x, p16476.y, p16476.z, true, UTILS.randFloat(0.9, 1));
    }
  };
  this.useStreak = function (p16479, p16480) {
    if (!game || !game.endTimer) {
      if (p16479.streaks[p16480] && p16479.streaks[p16480].streak.activate(game, p16479, serverIO)) {
        if (p16479.streaks[p16480].cnt > 1) {
          p16479.streaks[p16480].cnt--;
        } else {
          p16479.streaks[p16480] = null;
        }
        p16479.send("st", p16480, p16479.streaks[p16480] ? p16479.streaks[p16480].cnt || 0 : 0);
        game.challenges.update(game, "stk", 1, {
          stk: p16480
        }, p16479);
      }
    }
  };
  this.checkStreak = function (p16481, p16482) {
    if (p16481 && p16481.active && game && UTILS.isNumber(p16482)) {
      var vParseInt49 = parseInt(p16481.streakIndexs[p16482]);
      if (p16481.streaks[vParseInt49]) {
        game.players.useStreak(p16481, vParseInt49);
      } else {
        for (var v13378 in p16481.streaks) {
          if (p16481.streaks[v13378] && game.streaks[v13378] && game.streaks[v13378].slot == p16482) {
            game.players.useStreak(p16481, v13378);
            break;
          }
        }
      }
    }
  };
  this.updateStreaks = function (p16483) {
    for (var vLN02392 = 0; vLN02392 < p16483.streakIndexs.length; ++vLN02392) {
      if (game.streaks[p16483.streakIndexs[vLN02392]] && (!game.streaks[p16483.streakIndexs[vLN02392]].devOnly || p16483.account && p16483.account.isDev)) {
        if (!game || !game.mode || !game.mode.disabledStreaks || !(game.mode.disabledStreaks.indexOf(p16483.streakIndexs[vLN02392]) >= 0)) {
          if (p16483.realKillStreak == game.streaks[p16483.streakIndexs[vLN02392]].kills) {
            this.addStreak(p16483, p16483.streakIndexs[vLN02392]);
          }
        }
      }
    }
    if (p16483.realKillStreak >= p16483.maxPossibleStreak) {
      p16483.realKillStreak = 0;
    }
  };
  this.addStreak = function (p16484, p16485) {
    if ((!game.streaks[p16485].noCustoms || !game.isCustom) && (!!game.isSandbox || !game.streaks[p16485].reqAccount || !!p16484.account)) {
      if (p16484.streaks[p16485]) {
        p16484.streaks[p16485].cnt++;
      } else {
        p16484.streaks[p16485] = {
          cnt: 1,
          streak: game.streaks[p16485]
        };
      }
      p16484.send("st", p16485, p16484.streaks[p16485].cnt);
    }
  };
  this.givePerk = function (p16486, p16487) {
    if (!!p16486 && !p16486.perks.includes(p16487)) {
      p16486.perks.push(p16487);
      if (p16487 == 0) {
        p16486.maxHealth = 250;
        p16486.health = 250;
        game.broadcast("h", p16486.health, p16486.sid, null, null, true, true);
      } else if (p16487 != 1 && p16487 != 2 && p16487 != 3 && p16487 != 4 && p16487 != 5) {
        p16487 == 6;
      }
      game.broadcast("upk", p16486.sid, p16486.perks);
    }
  };
  this.giveEffect = function (p16488, p16489, p16490, p16491, p16492) {
    p16490 = p16490 || 1;
    if (p16491) {
      p16489 = UTILS.randInt(0, game.effectConfig.length - 1);
    }
    var v13379 = game.effectConfig[p16489];
    if (p16488 && v13379) {
      if (p16488.effects[p16489]) {
        p16488.effects[p16489] += p16490;
      } else {
        p16488.effects[p16489] = p16490;
      }
      if (!p16492 && p16488.effects[p16489] > v13379.max) {
        var v13380 = p16488.effects[p16489] - v13379.max;
        p16488.effects[p16489] = v13379.max;
        if (v13379.timer) {
          for (var vLN02394 = 0; vLN02394 < v13380; vLN02394++) {
            if (p16488.attributeTimers[p16489][vLN02394]) {
              p16488.attributeTimers[p16489][vLN02394] = v13379.timer * 1000;
            } else {
              p16488.attributeTimers[p16489].push(v13379.timer * 1000);
            }
          }
        }
        return;
      }
      if (v13379.timer) {
        for (var vLN02394 = 0; vLN02394 < p16490; vLN02394++) {
          p16488.attributeTimers[p16489].push(v13379.timer * 1000);
        }
      }
      v13379.execute(game, p16488);
      p16488.send("am", [v13379.mid, "x" + p16488.effects[p16489], 0, 1]);
      p16488.send("pk", p16489, p16488.effects[p16489]);
    }
  };
  this.removeEffect = function (p16493, p16494, p16495) {
    var v13381 = true;
    var v13382 = game.effectConfig[p16494];
    if (p16495 && p16493.effects[p16494]) {
      p16493.effects[p16494]--;
      v13381 = !!(p16493.effects[p16494] <= 0);
    }
    if (v13381) {
      this.clearEffect(p16493, p16494);
    } else {
      v13382.execute(game, p16493);
      p16493.send("pk", p16494, p16493.effects[p16494]);
    }
  };
  this.clearEffect = function (p16496, p16497) {
    var v13383 = game.effectConfig[p16497];
    if (p16496.effects[p16497]) {
      p16496.effects[p16497] = null;
    }
    p16496.attributes[v13383.key] = v13383.def;
    p16496.attributeTimers[v13383.index].length = 0;
    if (v13383.clear) {
      v13383.clear(p16496);
    }
    if (game.isServer) {
      p16496.send("pk", p16497, null);
    }
  };
  this.isBoosted = function (p16498, p16499) {
    return config.isProd && !game.isSandbox && !!p16498 && !!serverIO && !!serverIO.sockets && !!serverIO.sockets[p16498.id] && !!(p16499 & serverIO.sockets[p16499.id]) && serverIO.sockets[p16498.id].remoteAddress == serverIO.sockets[p16499.id].remoteAddress;
  };
  this.kill = function (p16500, p16501, p16502, p16503, p16504) {
    if (p16500.dummy || p16500.active) {
      if (p16501 && !p16501.isPlayer) {
        p16501 = null;
      }
      var v13384 = p16500 && p16500.isBot;
      var v13385 = p16501 && p16501.isBot;
      var v13386 = game && game.mode && game.mode.botsAsAI;
      if (v13385 && v13386) {
        p16501 = null;
      }
      if (v13384 && v13386) {
        p16503 = true;
      }
      if (game && game.mode && game.mode.noKillFeed) {
        p16503 = true;
      }
      var v13387 = false;
      var v13388 = -1;
      if (!p16500.dummy) {
        p16500.active = false;
        if (p16500.isYou) {
          this.toggleAim(p16500, 0);
        }
        if (p16500.objInstances) {
          this.disposeMesh(p16500);
        }
      }
      if (game.isServer) {
        var v13389;
        var vLN02395 = 0;
        var v13390 = p16502 && p16502.stk != null;
        if (!game.waitTimers || !game.waitTimers[0] || !!game.waitTimers[0].contTime) {
          p16500.deaths++;
          p16500.deathsL++;
          game.challenges.update(game, "d", 1, null, p16500);
        }
        p16500.lastKiller = null;
        if (!p16500.deathInfo) {
          p16500.deathInfo = {};
        }
        p16500.deathInfo.time = game.now;
        p16500.deathInfo.tillNext = game.forceSpawn ? game.forceSpawn * 1000 + config.deathDelay : null;
        if (!game.mode.noStreaks && !game.config.noStreaks) {
          p16500.deathStreak++;
        }
        if (p16500.lives && (!game.waitTimers || game.waitTimers && game.waitTimers[0].contTime)) {
          p16500.lives--;
          p16500.send("lv", p16500.lives);
        }
        game.kills++;
        if (p16501) {
          v13388 = p16502 && p16502.wId != null ? p16502.wId : p16501.loadout[p16501.loadoutIndex];
        }
        if (p16501 && p16501 != p16500 && (!v13386 || !v13384)) {
          p16500.lastKiller = p16501.id;
          if (!p16501.weaponStats[v13388]) {
            p16501.weaponStats[v13388] = {};
          }
          if (!p16500.dummy) {
            p16501.kills++;
            if (p16501.active) {
              p16501.killsL++;
            }
            if (!p16500.account && p16500.kills == 0) {
              p16501.sussKills++;
            }
            if (v13390) {
              game.challenges.update(game, "k", 1, null, p16501);
            } else {
              if (!p16501.weaponStats[v13388].kills) {
                p16501.weaponStats[v13388].kills = 0;
              }
              p16501.weaponStats[v13388].kills++;
              game.challenges.update(game, "k", 1, {
                wep: v13388
              }, p16501);
              if (p16502 && p16502.hs) {
                if (!p16501.weaponStats[v13388].headshots) {
                  p16501.weaponStats[v13388].headshots = 0;
                }
                p16501.weaponStats[v13388].headshots++;
              }
              if (p16502 && p16502.ls) {
                if (!p16501.weaponStats[v13388].legshots) {
                  p16501.weaponStats[v13388].legshots = 0;
                }
                p16501.weaponStats[v13388].legshots++;
              }
              if (p16501.uniqueWeaponKills.indexOf(v13388) == -1) {
                p16501.uniqueWeaponKills.push(v13388);
                game.challenges.update(game, "uwk", p16501.uniqueWeaponKills.length, null, p16501);
              }
            }
          }
          if (!game.mode.noStreaks && !game.config.noStreaks && !this.isBoosted(p16500, p16501)) {
            p16501.streak++;
            p16501.killStreak++;
            p16501.realKillStreak++;
            if (p16501.killStreak > p16501.highestStreak) {
              p16501.highestStreak = p16501.killStreak;
            }
            if (v13390) {
              game.challenges.update(game, "kstk", p16501.killStreak, null, p16501);
            } else {
              if (!p16501.weaponStats[v13388].highestWeaponStreak) {
                p16501.weaponStats[v13388].highestWeaponStreak = 0;
              }
              if (p16501.currentStreakWeapon != null && p16501.currentStreakWeapon != v13388) {
                p16501.weaponStreak = 1;
              } else {
                p16501.weaponStreak++;
              }
              p16501.currentStreakWeapon = v13388;
              if (p16501.weaponStreak > (p16501.weaponStats[p16501.currentStreakWeapon].highestWeaponStreak || 0)) {
                p16501.weaponStats[p16501.currentStreakWeapon].highestWeaponStreak = p16501.weaponStreak;
              }
              game.challenges.update(game, "kstk", p16501.weaponStreak, {
                wep: v13388,
                nonWep: p16501.killStreak
              }, p16501);
              p16501.send("wstk", p16501.currentStreakWeapon, p16501.weaponStreak);
            }
            p16501.deathStreak = 0;
            this.updateStreaks(p16501);
            if (p16501.killStreak % 5 == 0) {
              vLN02395 = p16501.killStreak;
            }
            if (game.now - p16501.lastKill >= config.feedTimer) {
              p16501.streak = 0;
            }
          }
          p16501.lastKill = game.now;
          if (!p16504 && game.config.killRewards && !game.mode.noKillRewards) {
            v13389 = kills.reward(this, p16501, p16500, p16502, game);
            if (v13389) {
              p16501.send("6", v13389, config.networkSounds.indexOf(this.getKillSnd(p16502, p16501)), p16501.kills);
            }
            this.score(p16501, kills.getScore(v13389), 1);
            v13387 = true;
          }
        }
        if (p16501 && p16501 != p16500 && p16500 && p16500.isJuggernaut) {
          game.incStat("kjg", p16501);
        }
        if (p16501 && p16501 != p16500 && p16501.isJuggernaut) {
          game.incStat("jgk", p16501);
        }
        if (p16500 && p16500.isJuggernaut) {
          game.setJuggernaut(p16500, false);
        }
        if (!v13386 || !v13384) {
          game.players.dropWeapon(p16500, true);
        }
        if (p16502 && p16502.w) {
          delete p16502.w;
        }
        if (!p16500.dummy) {
          for (var vLN02396 = 0; vLN02396 < this.list.length; ++vLN02396) {
            if (this.list[vLN02396]) {
              if (!game.config.noAssists && !game.mode.noAssists && p16500 && p16500.dmgReceived && p16500.dmgReceived[this.list[vLN02396].id] && p16501 != this.list[vLN02396] && p16500.dmgReceived[this.list[vLN02396].id].val >= config.assistMin && game.now - p16500.dmgReceived[this.list[vLN02396].id].time <= config.assistTime) {
                this.giveAssist(this.list[vLN02396]);
                v13387 = true;
              }
              if (this.list[vLN02396] == p16500) {
                p16500.send("3", p16500.sid, p16500.deaths, p16501 ? p16501.sid : 0, [v13388, p16501 && p16501.account && !p16501.anonMode && p16501.account.stats["c" + p16501.classIndex] ? p16501.account.stats["c" + p16501.classIndex] : 0, p16501 && p16501.account && p16501.pcStatIndex != -1 ? [p16501.pcStatIndex, config.playerCardStats[p16501.pcStatIndex].stat(p16501)] : null, [Date.now() - p16500.spawnTime, p16500.totShotsL || 0, (p16500.totShotsL ? Math.min(p16500.totShotsL || 0, p16500.hitShotsL || 0) / (p16500.totShotsL || 0) * 100 : 0).round(1) + "%", p16500.killsL || 0, p16500.scoreL || 0]], p16502, p16503);
              } else {
                this.list[vLN02396].send("3", p16500.sid, p16500.deaths, p16501 ? p16501.sid : 0, [], p16502, p16503);
              }
            }
          }
        }
        if (game.mode.onKill) {
          game.mode.onKill(game, serverIO, p16500, p16501, p16502);
        }
        if (game.mode.effectOnKill && p16501 && p16501 != p16500) {
          game.players.giveEffect(p16501, null, 1, true);
        }
        if (p16501 && p16501 != p16500 && p16501.attributes.siphon) {
          game.players.changeHealth(p16501, null, -p16501.attributes.siphon);
        }
        if (vLN02395) {
          game.broadcast("kst", p16501.sid, vLN02395);
        }
        game.playerTrigger("onPlayerDie", p16500);
        if (p16501 && p16501 != p16500) {
          game.playerTrigger("onPlayerKill", p16501);
        }
        if (p16500 && p16500.onDeath) {
          p16500.onDeath(p16501 && p16501 != p16500 ? p16501 : null);
        }
        if (p16501 && p16501 != p16500 && p16501.onKill) {
          p16501.onKill(p16500);
        }
        if (game && game.mainScript && game.mainScript.onPlayerSpawn) {
          game.mainScript.onPlayerDeath(p16500.id + "", p16501 ? p16501.id + "" : "");
        }
      }
      if (game.isServer && !v13387) {
        this.syncLeaders();
      }
    }
  };
  this.getWeapon = function (p16505, p16506) {
    if (p16505) {
      p16506 = p16506 == null ? p16505.loadoutIndex : p16506;
      if (p16505.upgrades[p16506]) {
        return game.upgradeWeapons[p16505.loadout[p16506]];
      } else {
        return game.weaponConfig[p16505.loadout[p16506]];
      }
    } else {
      return null;
    }
  };
  this.getKillSnd = function (p16507, p16508) {
    if (!p16507) {
      return null;
    }
    if (p16507.hs) {
      return "headshot_0";
    }
    if (p16507.wId == null) {
      return null;
    }
    var v13391;
    var v13392 = p16508.loadout.indexOf(p16507.wId);
    var v13393 = game.weaponConfig[p16507.wId];
    v13391 = p16507.wId == 12 ? game.store.skins[p16508.meleeIndex || null] || null : game.store.skins[p16508.skins[v13392] || null] || null;
    if (v13391 && v13391.killSnd) {
      if (v13391.type) {
        return v13393.sound + (v13391 && v13391.id != null ? "_" + v13391.id : "");
      } else {
        return null;
      }
    } else {
      return null;
    }
  };
  this.getReloadSnd = function (p16509, p16510) {
    var v13394 = game.store.skins[p16509.skins[p16509.loadoutIndex] || null] || null;
    var vLSReload = "reload";
    if (v13394 && v13394.reloadSnd) {
      vLSReload = p16509.weapon.sound + (v13394.mid == null ? "" : "_" + v13394.mid) + "_r";
    }
    return vLSReload + "_" + p16510;
  };
  this.findBySid = function (p16511) {
    for (var vLN02397 = 0; vLN02397 < this.list.length; ++vLN02397) {
      if (this.list[vLN02397].sid === p16511) {
        return this.list[vLN02397];
      }
    }
    return null;
  };
  this.findByAccID = function (p16512) {
    for (var vLN02398 = 0; vLN02398 < this.list.length; ++vLN02398) {
      if (this.list[vLN02398].accid === p16512) {
        return this.list[vLN02398];
      }
    }
    return null;
  };
  this.findById = function (p16513) {
    for (var vLN02399 = 0; vLN02399 < this.list.length; ++vLN02399) {
      if (this.list[vLN02399].id === p16513) {
        return this.list[vLN02399];
      }
    }
    return null;
  };
  this.findByName = function (p16514, p16515) {
    p16514 = (p16514 + "").toLowerCase();
    for (var vLN02400 = 0; vLN02400 < this.list.length; ++vLN02400) {
      if (this.list[vLN02400].name.toLowerCase() === p16514 || !p16515 && this.list[vLN02400].alias.toLowerCase() === p16514) {
        return this.list[vLN02400];
      }
    }
    return null;
  };
  this.indexBySid = function (p16516) {
    for (var vLN02401 = 0; vLN02401 < this.list.length; ++vLN02401) {
      if (this.list[vLN02401].sid == p16516) {
        return vLN02401;
      }
    }
    return -1;
  };
  this.sendMessage = function (p16517, p16518, p16519) {
    p16517.send("ch", -1, null, p16518, 2, p16519);
  };
  this.challengeCompleted = function (p16520, p16521, p16522) {
    p16520.send("chgC", p16521, true, p16522);
  };
  var vA739 = [];
  var v13395 = null;
  var v13396 = null;
  this.sync = function () {
    for (var vLN02402 = 0; vLN02402 < this.list.length; ++vLN02402) {
      vA739.length = 0;
      v13395 = this.list[vLN02402];
      var v13397 = v13395 && v13395.account && v13395.account.isDev;
      if (v13395.active || v13395.spectating) {
        for (var vLN02403 = 0; vLN02403 < this.list.length; ++vLN02403) {
          v13396 = this.list[vLN02403];
          if (!!v13396.active && !v13396.sentTo.includes(v13395.id) && !v13396.kpdData) {
            v13396.sentTo.push(v13395.id);
            vA739.push(v13396.id, v13396.sid, Math.round(v13396.x), Math.round(v13396.y), Math.round(v13396.z), v13396.getName(v13395.account, false, v13397 || v13395.kpdData), v13396.classIndex, Math.round(v13396.health), Math.round(v13396.maxHealth), v13396.team, v13396.anonMode && !v13397 ? v13396.fakeLevel || UTILS.randInt(1, 100) : v13396.account ? v13396.account.level : v13396.isBot && v13396.fakeLevel ? v13396.fakeLevel : 0, v13396.anonMode && !v13397 ? 0 : v13396.account ? v13396.account.clan : v13396.isBot && v13396.fakeClan ? v13396.fakeClan : 0, v13396.account || v13396.isBot || game.isSandbox ? v13396.skins : 0, v13396.hatIndex, v13396.bodyIndex, v13396.secIndex, ~~(!!v13396.account && v13396.account.hack), v13396.customLoadout ? v13396.customLoadout : null, v13396.xDire, v13396.meleeIndex, v13396.skinColIndex, v13396.propID, v13396.attachIndex, v13396.pcStatIndex, v13396.dyeIndex, ~~(v13396.anonMode && !v13397 ? 0 : v13396.account && v13396.showBadges.verified ? v13396.account.featured : !!v13396.isBot && v13396.fakeFeatured), v13396.anonMode && !v13397 ? -1 : v13396.account ? v13396.account.stats.flg : -1, v13396.anonMode && !v13397 ? 0 : v13396.account && v13396.showBadges.premium ? v13396.account.premiumT : v13396.isBot ? v13396.fakePremium : 0, v13396.getName(v13395.account, true, v13397 || v13395.kpdData), v13396.shoeIndex, v13396.waistIndex, v13396.anonMode && !v13397 ? 0 : v13396.account ? v13396.account.id : 0, v13396.hairCol, v13396.faceIndex, ~~(v13396.anonMode && !v13397 ? 0 : !!v13396.account && !!v13396.showBadges.partner && v13396.account.partnerApp), v13396.petIndex, v13396.anonMode && !v13397 ? -1 : v13396.account && v13396.showBadges.custom ? v13396.badgeIndex : -1, v13396.wristIndex, v13396.isJuggernaut ? 1 : 0, parseFloat(v13396.headMlt), v13396.account || v13396.isBot || game.isSandbox ? v13396.charms : 0, v13396.upgrades, v13396.backIndex, v13396.headIndex, v13396.playerCardIndex, v13396.isBot ? 1 : 0, v13396.isBusy ? 1 : 0);
          }
        }
        if (vA739.length) {
          v13395.send("0", vA739, 1);
        }
      }
    }
  };
  this.resetFreq = function () {
    for (var vLN02404 = 0; vLN02404 < this.list.length; ++vLN02404) {
      this.list[vLN02404].inputFreq = 0;
    }
  };
};